import SaveAndNavigate from "../../../Components/SaveAndNavigate";
import SideBarMenu from "../../../Components/SideBarMenu";
import {
  HTTPResponse,
  PageDesignConstants,
  RRMMCohortTreatment,
  SideMenuItems,
  TRPQuestionType,
  ToastMessageType,
  ToastMessages,
} from "../../../Helpers/Enums";
import PatientDetails from "../../../Components/PatientInformation";
import {
  CommonError_Msgs,
  hyperlinkTextLineOfTherapy,
  hyperlinkTextStandardIMWGReportingCriteria,
  TreatmentResponseProgression_Msgs,
} from "../../../Helpers/HelperText";
import { useContext, useEffect, useState } from "react";
import ErrorField from "../../../Components/ErrorField";
import {
  GetLocalStorageData,
  GetLoggedInUserID,
  GetOrdinal,
  IsAdmin,
  IsDateValid,
  IsLessOrEqual,
  isStringEmpty,
} from "../../../Helpers/Utilities";
import { AppContext } from "../../../Contexts/AppContextProvider";
import { ClinicalOutcomes } from "../../../WebApiServices/ClinicalOutcomes.service";
import InfoPopUp from "../../../Components/InfoPopUp";
import dayjs from "dayjs";
import DatePickerComponent from "../../../Components/DatePickerComponent";

const TreatmentResponseProgression = () => {
  const [navigatePaths, setNavigatePaths] = useState({
    prevPage: "/IMWGReporting",
    currPage: "/TreatmentResponseProgression",
    nextPage: "/AdverseEvents",
  });

  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    isSideMenuActive,
    setIsSideMenuActive,
  } = useContext(AppContext);

  const [showTopErrMsg, setShowTopErrMsg] = useState(false);

  const [showHideHyperlinkModal, setShowHideHyperlinkModal] = useState(false);

  const [NDMMRRMMAchievedVGPR, setNDMMRRMMAchievedVGPR] = useState(false);

  const [NDMMRRMMDiseaseProgression28, setNDMMRRMMDiseaseProgression28] =
    useState(false);
  const [NDMMRRMMInsufficientResponse28, setNDMMRRMMInsufficientResponse28] =
    useState(false);
  const [NDMMRRMMDiseaseProgression30, setNDMMRRMMDiseaseProgression30] =
    useState(false);

  const [NDMMRRMMInsufficientResponse30, setNDMMRRMMInsufficientResponse30] =
    useState(false);
  const [NDMMRRMMInsufficientResponse33, setNDMMRRMMInsufficientResponse33] =
    useState(false);
  const [Q46MRDWarnings, setQ46MRDWarnings] = useState({});

  const [NDMMRRMMDiseaseProgression33Tec, setNDMMRRMMDiseaseProgression33Tec] =
    useState(false);
  const [NDMMRRMMDiseaseProgression33Tal, setNDMMRRMMDiseaseProgression33Tal] =
    useState(false);
  const [NDMMRRMMDiseaseProgression33Lin, setNDMMRRMMDiseaseProgression33Lin] =
    useState(false);
  const [
    NDMMRRMMDiseaseProgression33Carvykti,
    setNDMMRRMMDiseaseProgression33Carvykti,
  ] = useState(false);
  const [NDMMRRMMDiseaseProgression33Elr, setNDMMRRMMDiseaseProgression33Elr] =
    useState(false);
  const [
    NDMMRRMMDiseaseProgression33Abecma,
    setNDMMRRMMDiseaseProgression33Abecma,
  ] = useState(false);

  const [showHideHyperlinkModalIMWG, setShowHideHyperlinkModalIMWG] =
    useState(false);
  const [assessmentMethods, setAssessmentMethods] = useState([]);

  const [ndmmEndofFollowupDate, setNdmmEndofFollowupDate] = useState(
    "[NDMM End of Follow up Date]",
  );

  const [ndmmSecondLotStartDate, setNDMMSecondLotStartDate] = useState("");

  const [ndmmThirdLotStartDate, setNDMMThirdLotStartDate] = useState("");

  const [endOfFollowUpDate, setEndOfFollowUpDate] = useState("");
  const [cohortNextLotDatesList, setCohortNextLotDatesList] = useState([]);

  const TmtResponseProgressionRow = {
    cohorttreatmentid: 0,
    cohorttreatmentNextLotDate: "",
    assessmentmethodid: 0,
    lineoftreatmentid: 0,
    treatmentmrdassessmentbridgeid: 0,

    assessmentMethod: [],

    treatmentresponseprogressionid1: 0,
    treatmentresponseprogressionid2: 0,
    treatmentresponseprogressionid3: 0,
    treatmentresponseprogressionid4: 0,

    cohortTreatmentName: "",
    cohortIndexDate: "",
    cohortTreatmentNameSuperscript: "",

    bispecificEOFLabel: "",
    bispecificEOF: "",
    bispecificNextLOTStartDate: "",

    //44
    Q44dateOfProgressionRd: null,
    Q44dateOfProgression_dt: "",
    Invalid_dateofProgression_dt: false,
    Q44serum: false,
    Q44uninary: false,
    Q44freelight: false,
    Q44plasma: false,
    Q44bonelesion: false,
    Q44plasmacytomas: false,
    Q44ReasonOfProgression_oth: false,
    Q44ReasonOfProgression_txt: "",
    Q44ReasonOfProgression: null,

    Q44WarningMsg: false,
    Q44WarningMsgTec: false,
    Q44WarningMsgTal: false,
    Q44WarningMsgElr: false,
    Q44WarningMsgLin: false,
    Q44WarningMsgCarvykti: false,
    Q44WarningMsgAbecma: false,

    Q44assessmentMethodRd: null,

    Q44EmptyError: false,
    Q44dateOfProgression_dtEmpty: false,
    Q44ReasonOfProgressionEmpty: false,
    Q44ReasonOfProgressionTxtEmpty: false,
    Q44assessmentMethodEmpty: false,

    Q44DateValidationError: false,

    Q44ConditionMet: false,
    //45
    Q45WarningMsg: false,
    Q45VGPRWarningMsg: false,
    Q45PRWarningMsg: false,
    q45SuboptimalResponseSelectedInQ26: false,
    Q45FR_tmtResponseStatus: null,
    Q45FR_dateOfResponse_assessRd: null,
    Q45FR_dateOfResponse_assess_dt: "",
    Invalid_dateofResponse_assess_dt: false,
    Q45FR_assessmentMethodRd: null,

    Q45BR_tmtResponseStatus: null,
    Q45BR_dateOfResponse_assessRd: null,
    Q45BR_dateOfResponse_assess_dt: "",
    Invalid_BR_dateOfResponse_assess_dt: false,
    Q45BR_assessmentMethodRd: null,

    Q45FR_tmtResponseStatusEmpty: false,
    Q45FR_dateOfResponse_assessEmpty: false,
    Q45FR_dateOfResponse_assess_dtEmpty: false,
    Q45FR_assessmentMethodEmpty: false,

    Q45FRBR_DateMismatch: false,
    Q45BR_PD_DateMismatch: false,

    Q45BR_tmtResponseStatusEmpty: false,
    Q45BR_dateOfResponse_assessEmpty: false,
    Q45BR_dateOfResponse_assess_dtEmpty: false,
    Q45BR_assessmentMethodEmpty: false,

    Q45FRDateValidationError: false,
    Q45BRDateValidationError: false,

    //46
    q46Row: [
      {
        treatmentmrdassessmentbridgeid: 0,
        Q46dateofassessmentRd: null,
        Q46dateofassessment_dt: "",
        Invalid_dateofassessment_dt: false,
        Q46assessmentmethodRd: null,
        Q46sensitivityRd: null,
        Q46mrdstatusRd: null,

        Q46dateofassessmentEmpty: false,
        Q46dateofassessment_dtEmpty: false,
        Q46assessmentmethodEmpty: false,
        Q46sensitivityEmpty: false,
        Q46mrdstatusEmpty: false,

        Q46DateValidationError: false,

        Q46MRD5WarningMsg: false,
        Q46MRD6WarningMsg: false,

        ndmmrrmmAchievedMRD5Tec: false,
        ndmmrrmmAchievedMRD6Tec: false,
        ndmmrrmmAchievedMRD5Tal: false,
        ndmmrrmmAchievedMRD6Tal: false,
        ndmmrrmmAchievedMRD5Elr: false,
        ndmmrrmmAchievedMRD6Elr: false,
        ndmmrrmmAchievedMRD5Lin: false,
        ndmmrrmmAchievedMRD6Lin: false,
      },
    ],

    //47

    Q47ConditionMet: false,

    Q47dateOfProgressionRd: null,
    Q47dateOfProgression_dt: "",
    Invalid_Q47dateOfProgression_dt: false,
    Q47serum: false,
    Q47uninary: false,
    Q47freelight: false,
    Q47plasma: false,
    Q47bonelesion: false,
    Q47plasmacytomas: false,
    Q47ReasonOfProgression_oth: false,
    Q47ReasonOfProgression_txt: "",
    Q47ReasonOfProgression: null,

    Q47assessmentMethodRd: null,

    Q47dateOfProgressionEmpty: false,
    Q47dateOfProgression_dtEmpty: false,
    Q47ReasonOfProgressionEmpty: false,
    Q47ReasonOfProgressionTxtEmpty: false,
    Q47assessmentMethodEmpty: false,
    Q47q28WarningMsg: false,

    Q47DateValidationError: false,

    //48
    Q48FR_tmtResponseStatus: null,
    Q48FR_dateOfResponse_assessRd: null,
    Q48FR_dateOfResponse_assess_dt: "",
    Invalid_Q48FR_dateOfResponse_assess_dt: false,
    Q48FR_assessmentMethodRd: null,

    Q48BR_tmtResponseStatus: null,
    Q48BR_dateOfResponse_assessRd: null,
    Q48BR_dateOfResponse_assess_dt: "",
    Invalid_Q48BR_dateOfResponse_assess_dt: false,
    Q48BR_assessmentMethodRd: null,

    Q48FR_tmtResponseStatusEmpty: false,
    Q48FR_dateOfResponse_assessEmpty: false,
    Q48FR_dateOfResponse_assess_dtEmpty: false,
    Q48FR_assessmentMethodEmpty: false,

    Q48BR_tmtResponseStatusEmpty: false,
    Q48BR_dateOfResponse_assessEmpty: false,
    Q48BR_dateOfResponse_assess_dtEmpty: false,
    Q48BR_assessmentMethodEmpty: false,
    Q48q28WarningMsg: false,

    Q48FRBR_DateMismatch: false,
    Q48BR_PD_DateMismatch: false,

    Q48BRDateValidation: false,

    Q48FRDateValidation: false,

    //49
    Q49ConditionMet: false,

    Q49dateOfProgressionRd: null,
    Q49dateOfProgression_dt: "",
    Invalid_Q49dateOfProgression_dt: false,
    Q49serum: false,
    Q49uninary: false,
    Q49freelight: false,
    Q49plasma: false,
    Q49bonelesion: false,
    Q49plasmacytomas: false,
    Q49ReasonOfProgression_oth: false,
    Q49ReasonOfProgression_txt: "",
    Q49ReasonOfProgression: null,

    Q49assessmentMethodRd: null,

    Q49dateOfProgressionEmpty: false,
    Q49dateOfProgression_dtEmpty: false,
    Q49ReasonOfProgressionEmpty: false,
    Q49ReasonOfProgressionTxtEmpty: false,
    Q49assessmentMethodEmpty: false,

    Q49DateValidation: false,

    //50
    Q50FR_tmtResponseStatus: null,
    Q50FR_dateOfResponse_assessRd: null,
    Q50FR_dateOfResponse_assess_dt: "",
    Invalid_Q50FR_dateOfResponse_assess_dt: false,
    Q50FR_assessmentMethodRd: null,

    Q50BR_tmtResponseStatus: null,
    Q50BR_dateOfResponse_assessRd: null,
    Q50BR_dateOfResponse_assess_dt: "",
    Invalid_Q50BR_dateOfResponse_assess_dt: false,
    Q50BR_assessmentMethodRd: null,

    Q50FR_tmtResponseStatusEmpty: false,
    Q50FR_dateOfResponse_assessEmpty: false,
    Q50FR_dateOfResponse_assess_dtEmpty: false,
    Q50FR_assessmentMethodEmpty: false,

    Q50BR_tmtResponseStatusEmpty: false,
    Q50BR_dateOfResponse_assessEmpty: false,
    Q50BR_dateOfResponse_assess_dtEmpty: false,
    Q50BR_assessmentMethodEmpty: false,

    Q50FRDateValidation: false,

    Q50BRDateValidation: false,

    Q50FRBR_DateMismatch: false,
    Q50BR_PD_DateMismatch: false,
    Q50q30WarningMsg: false,

    //51
    showQ51_52: false,
    Q51ConditionMet: false,
    Q51dateOfProgressionRd: null,
    Q51dateOfProgression_dt: "",
    Invalid_Q51dateOfProgression_dt: false,
    Q51serum: false,
    Q51uninary: false,
    Q51freelight: false,
    Q51plasma: false,
    Q51bonelesion: false,
    Q51plasmacytomas: false,
    Q51ReasonOfProgression_oth: false,
    Q51ReasonOfProgression_txt: "",
    Q51ReasonOfProgression: null,

    Q51assessmentMethodRd: null,

    Q51dateOfProgressionEmpty: false,
    Q51dateOfProgression_dtEmpty: false,
    Q51ReasonOfProgressionEmpty: false,
    Q51ReasonOfProgressionTxtEmpty: false,
    Q51assessmentMethodEmpty: false,

    Q51DateValidation: false,

    Q51q33WarningMsg: false,

    Q51q33WarningMsgTec: false,
    Q51q33WarningMsgTal: false,
    Q51q33WarningMsgElr: false,
    Q51q33WarningMsgLin: false,
    Q51q33WarningMsgCarvykti: false,
    Q51q33WarningMsgAbecma: false,

    //52
    Q52FR_tmtResponseStatus: null,
    Q52FR_dateOfResponse_assessRd: null,
    Q52FR_dateOfResponse_assess_dt: "",
    Invalid_Q52FR_dateOfResponse_assess_dt: false,
    Q52FR_assessmentMethodRd: null,

    Q52BR_tmtResponseStatus: null,
    Q52BR_dateOfResponse_assessRd: null,
    Q52BR_dateOfResponse_assess_dt: "",
    Invalid_Q52BR_dateOfResponse_assess_dt: false,
    Q52BR_assessmentMethodRd: null,

    Q52FR_tmtResponseStatusEmpty: false,
    Q52FR_dateOfResponse_assessEmpty: false,
    Q52FR_dateOfResponse_assess_dtEmpty: false,
    Q52FR_assessmentMethodEmpty: false,

    Q52BR_tmtResponseStatusEmpty: false,
    Q52BR_dateOfResponse_assessEmpty: false,
    Q52BR_dateOfResponse_assess_dtEmpty: false,
    Q52BR_assessmentMethodEmpty: false,

    Q52FRDateValidation: false,

    Q52BRDateValidation: false,

    Q52FRBR_DateMismatch: false,
    Q52BR_PD_DateMismatch: false,
    Q52q33WarningMsg: false,
  };
  const [tmtResponseProgression, setTmtResponseProgression] = useState([
    TmtResponseProgressionRow,
  ]);
  const pid = GetLocalStorageData("patientId") ?? 0;
  const cohortTreatmentModelListt =
    JSON.parse(GetLocalStorageData("CohortTreatment") || "[]")?.filter(
      (c) => c?.isEligible,
    ) || [];

  const [showQ47_48, setShowQ47_48] = useState(false);
  const [showQ49_50, setShowQ49_50] = useState(false);
  const [treatmentlist, settreatmentlist] = useState([]);

  function syncQ48FRBR(updatedArray, id, source) {
    const currentItem = { ...updatedArray[id] };
    if (!currentItem) return updatedArray;

    const frStatus = currentItem.Q48FR_tmtResponseStatus;
    const brStatus = currentItem.Q48BR_tmtResponseStatus;

    if (frStatus !== brStatus || ![1, 2, 3, 4].includes(frStatus)) {
      return updatedArray;
    }

    if (source === "FR") {
      if (currentItem.Q48FR_dateOfResponse_assessRd === 1) {
        currentItem.Q48BR_dateOfResponse_assessRd = 1;
        currentItem.Q48BR_dateOfResponse_assess_dt =
          currentItem.Q48FR_dateOfResponse_assess_dt;
        currentItem.Q48BR_dateOfResponse_assessEmpty = false;
      }
      if (currentItem.Q48FR_dateOfResponse_assessRd === 99) {
        currentItem.Q48BR_dateOfResponse_assessRd = 99;
        currentItem.Q48BR_dateOfResponse_assess_dt = "";
      }
    }

    if (source === "BR") {
      if (currentItem.Q48BR_dateOfResponse_assessRd === 1) {
        currentItem.Q48FR_dateOfResponse_assessRd = 1;
        currentItem.Q48FR_dateOfResponse_assess_dt =
          currentItem.Q48BR_dateOfResponse_assess_dt;
        currentItem.Q48FR_dateOfResponse_assessEmpty = false;
      }
      if (currentItem.Q48BR_dateOfResponse_assessRd === 99) {
        currentItem.Q48FR_dateOfResponse_assessRd = 99;
        currentItem.Q48FR_dateOfResponse_assess_dt = "";
      }
    }

    const newArray = [...updatedArray];
    newArray[id] = currentItem;
    return newArray;
  }

  const HandleRepeaterFieldChange = (e, cohortid) => {
    const { name, id, value } = e.target;
    const value_int = Number(value);
    const parentIndex = name.substring(name.lastIndexOf("-") + 1);

    let cohortData = treatmentlist.filter(
      (c) => c.cohortTreatmentID === cohortid,
    )[0];

    switch (name) {
      //radio - Q44dateOfProgression
      case "Q44dateOfProgressionRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };
        updatedArray[id].Q44dateOfProgressionRd = value_int;
        if (value_int === 99) {
          updatedArray[id].Q44dateOfProgression_dt = "";
          updatedArray[id].Q45BR_PD_DateMismatch = false;
        }

        updatedArray[id].Q44WarningMsg =
          value_int == 1 && cohortData.ndmmrrmmDiseaseProg == true;

        updatedArray[id].Q44EmptyError = false;
        updatedArray[id].Q44dateOfProgression_dtEmpty = false;
        updatedArray[id].Invalid_dateofProgression_dt = false;

        updatedArray[id].Q44DateValidationError = false;

        if (value_int === 1) {
          updatedArray[id].Q44ConditionMet = false;
          updatedArray[id].Q44serum = false;
          updatedArray[id].Q44uninary = false;
          updatedArray[id].Q44freelight = false;
          updatedArray[id].Q44plasma = false;
          updatedArray[id].Q44bonelesion = false;
          updatedArray[id].Q44plasmacytomas = false;
          updatedArray[id].Q44ReasonOfProgression_oth = false;
          updatedArray[id].Q44ReasonOfProgression_txt = "";
          updatedArray[id].Q44ReasonOfProgression = null;
          updatedArray[id].Q44assessmentMethodRd = null;
          updatedArray[id].Q44ReasonOfProgressionEmpty = false;
          updatedArray[id].Q44ReasonOfProgressionTxtEmpty = false;
          updatedArray[id].Q44assessmentMethodEmpty = false;
          updatedArray[id].Q45BR_PD_DateMismatch = false;
          updatedArray[id].Q44dateOfProgression_dt = "";
        }

        if (value_int === 2 || value_int === 99) {
          updatedArray[id].Q44ConditionMet = true;
        } else {
          updatedArray[id].Q44ConditionMet = false;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Q44 Reason of Progression
      case "Q44serum" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q44serum = !updatedArray[id].Q44serum;
        updatedArray[id].Q44ReasonOfProgression = null;

        updatedArray[id].Q44ReasonOfProgressionEmpty = false;
        updatedArray[id].Q44ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Uninary

      case "Q44uninary" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q44uninary = !updatedArray[id].Q44uninary;
        updatedArray[id].Q44ReasonOfProgression = null;

        updatedArray[id].Q44ReasonOfProgressionEmpty = false;
        updatedArray[id].Q44ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Free light

      case "Q44freelight" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q44freelight = !updatedArray[id].Q44freelight;
        updatedArray[id].Q44ReasonOfProgression = null;

        updatedArray[id].Q44ReasonOfProgressionEmpty = false;
        updatedArray[id].Q44ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Plasma

      case "Q44plasma" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q44plasma = !updatedArray[id].Q44plasma;
        updatedArray[id].Q44ReasonOfProgression = null;

        updatedArray[id].Q44ReasonOfProgressionEmpty = false;
        updatedArray[id].Q44ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Bone lesion

      case "Q44bonelesion" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q44bonelesion = !updatedArray[id].Q44bonelesion;
        updatedArray[id].Q44ReasonOfProgression = null;

        updatedArray[id].Q44ReasonOfProgressionEmpty = false;
        updatedArray[id].Q44ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - plasmacytomas

      case "Q44plasmacytomas" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q44plasmacytomas = !updatedArray[id].Q44plasmacytomas;
        updatedArray[id].Q44ReasonOfProgression = null;

        updatedArray[id].Q44ReasonOfProgressionEmpty = false;
        updatedArray[id].Q44ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - ReasonOfProgression_oth

      case "Q44ReasonOfProgression_oth" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q44ReasonOfProgression_oth =
          !updatedArray[id].Q44ReasonOfProgression_oth;
        updatedArray[id].Q44ReasonOfProgression = null;
        updatedArray[id].Q44ReasonOfProgression_txt = "";

        updatedArray[id].Q44ReasonOfProgressionEmpty = false;
        updatedArray[id].Q44ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - ReasonOfProgression_oth

      case "Q44ReasonOfProgression_txt" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q44ReasonOfProgression_txt = value;
        updatedArray[id].Q44ReasonOfProgression = null;
        updatedArray[id].Q44ReasonOfProgression_oth = true;

        updatedArray[id].Q44ReasonOfProgressionEmpty = false;
        updatedArray[id].Q44ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Unknown
      case "Q44ReasonOfProgression" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q44ReasonOfProgression = value_int;

        updatedArray[id].Q44serum = false;
        updatedArray[id].Q44uninary = false;
        updatedArray[id].Q44freelight = false;
        updatedArray[id].Q44plasma = false;
        updatedArray[id].Q44bonelesion = false;
        updatedArray[id].Q44plasmacytomas = false;
        updatedArray[id].Q44ReasonOfProgression_oth = false;
        updatedArray[id].Q44ReasonOfProgression_txt = "";

        updatedArray[id].Q44ReasonOfProgressionEmpty = false;
        updatedArray[id].Q44ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Method of Assessment
      case "Q44assessmentMethodRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q44assessmentMethodRd = value_int;

        updatedArray[id].Q44assessmentMethodEmpty = false;

        setTmtResponseProgression(updatedArray);
        break;
      }

      //Q45
      //radio - Treatment Response status
      case "Q45FR_tmtResponseStatus" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };
        updatedArray[id].Q45FR_tmtResponseStatus = value_int;
        updatedArray[id].Q45WarningMsg =
          cohortData.ndmmrrmmAchievedCR === true &&
          value_int !== 1 &&
          value_int !== 2 &&
          updatedArray[id].Q45BR_tmtResponseStatus !== 2 &&
          updatedArray[id].Q45BR_tmtResponseStatus !== 1;
        updatedArray[id].Q45VGPRWarningMsg =
          NDMMRRMMAchievedVGPR === true &&
          value_int !== 1 &&
          value_int !== 2 &&
          value_int !== 3 &&
          updatedArray[id].Q45BR_tmtResponseStatus != 3 &&
          updatedArray[id].Q45BR_tmtResponseStatus != 2 &&
          updatedArray[id].Q45BR_tmtResponseStatus != 1;
        updatedArray[id].Q45PRWarningMsg =
          updatedArray[id].q45SuboptimalResponseSelectedInQ26 === true &&
          value_int !== 4 &&
          updatedArray[id].Q45BR_tmtResponseStatus != 4 &&
          value_int !== 6 &&
          updatedArray[id].Q45BR_tmtResponseStatus != 6;
        updatedArray[id].Q45FR_tmtResponseStatusEmpty = false;

        if (value_int == 8 || value_int === 9 || value_int == 5) {
          updatedArray[id].Q45FR_dateOfResponse_assessRd = null;
          updatedArray[id].Q45FR_dateOfResponse_assess_dt = "";
          updatedArray[id].Q45FR_assessmentMethodRd = null;

          updatedArray[id].Q45FR_dateOfResponse_assessEmpty = false;
          updatedArray[id].Q45FR_dateOfResponse_assess_dtEmpty = false;
          updatedArray[id].Invalid_dateofResponse_assess_dt = false;
          updatedArray[id].Q45FR_assessmentMethodEmpty = false;

          updatedArray[id].Q45FRDateValidationError = false;
        }

        if (value_int != updatedArray[id].Q45BR_tmtResponseStatus) {
          updatedArray[id].Q45FRBR_DateMismatch = false;
        } else if (
          value_int === updatedArray[id].Q45BR_tmtResponseStatus &&
          updatedArray[id].Q45BR_dateOfResponse_assess_dt !==
            updatedArray[id].Q45FR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q45FRBR_DateMismatch = true;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      // Date of response assessment

      case "Q45FR_dateOfResponse_assessRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };

        updatedArray[id].Q45FR_dateOfResponse_assessRd = value_int;
        if (value_int === 99) {
          updatedArray[id].Q45FR_dateOfResponse_assess_dt = "";
        }
        // updatedArray[id].Q45FR_dateOfResponse_assess_dt = "";

        updatedArray[id].Q45FR_dateOfResponse_assessEmpty = false;

        updatedArray[id].Q45FRDateValidationError = false;

        if (value_int === 99) {
          updatedArray[id].Q45FRBR_DateMismatch = false;
        }
        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Method of assessment
      case "Q45FR_assessmentMethodRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q45FR_assessmentMethodRd = value_int;

        updatedArray[id].Q45FR_assessmentMethodEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //Best Response
      //radio - Treatment Response status
      case "Q45BR_tmtResponseStatus" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };
        updatedArray[id].Q45BR_tmtResponseStatus = value_int;
        updatedArray[id].Q45WarningMsg =
          cohortData.ndmmrrmmAchievedCR === true &&
          value_int !== 1 &&
          value_int !== 2 &&
          updatedArray[id].Q45FR_tmtResponseStatus !== 2 &&
          updatedArray[id].Q45FR_tmtResponseStatus !== 1;
        updatedArray[id].Q45VGPRWarningMsg =
          NDMMRRMMAchievedVGPR === true &&
          value_int !== 1 &&
          value_int !== 2 &&
          value_int !== 3 &&
          updatedArray[id].Q45FR_tmtResponseStatus != 3 &&
          updatedArray[id].Q45FR_tmtResponseStatus != 2 &&
          updatedArray[id].Q45FR_tmtResponseStatus != 1;
        updatedArray[id].Q45PRWarningMsg =
          updatedArray[id].q45SuboptimalResponseSelectedInQ26 === true &&
          value_int !== 4 &&
          value_int !== 6 &&
          updatedArray[id].Q45FR_tmtResponseStatus != 4 &&
          updatedArray[id].Q45FR_tmtResponseStatus != 6;
        updatedArray[id].Q45BR_tmtResponseStatusEmpty = false;

        if (value_int == 8 || value_int === 9) {
          updatedArray[id].Q45BR_dateOfResponse_assessRd = null;
          updatedArray[id].Q45BR_dateOfResponse_assess_dt = "";
          updatedArray[id].Q45BR_assessmentMethodRd = null;

          updatedArray[id].Q45BR_dateOfResponse_assessEmpty = false;
          updatedArray[id].Q45BR_dateOfResponse_assess_dtEmpty = false;
          updatedArray[id].Invalid_BR_dateOfResponse_assess_dt = false;
          updatedArray[id].Q45BR_assessmentMethodEmpty = false;

          updatedArray[id].Q45BRDateValidationError = false;
        }

        if (
          value_int === 7 &&
          updatedArray[id].Q44dateOfProgressionRd === 2 &&
          updatedArray[id].Q44dateOfProgression_dt &&
          updatedArray[id].Q44dateOfProgression_dt !== "" &&
          updatedArray[id].Q44dateOfProgression_dt !== "Invalid Date" &&
          updatedArray[id].Q45BR_dateOfResponse_assess_dt !== "" &&
          updatedArray[id].Q45BR_dateOfResponse_assess_dt &&
          updatedArray[id].Q45BR_dateOfResponse_assess_dt !== "Invalid Date" &&
          updatedArray[id].Q44dateOfProgression_dt !==
            updatedArray[id].Q45BR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q45BR_PD_DateMismatch = true;
        } else {
          updatedArray[id].Q45BR_PD_DateMismatch = false;
        }

        if (value_int != updatedArray[id].Q45FR_tmtResponseStatus) {
          updatedArray[id].Q45FRBR_DateMismatch = false;
        } else if (
          value_int === updatedArray[id].Q45FR_tmtResponseStatus &&
          updatedArray[id].Q45BR_dateOfResponse_assess_dt !==
            updatedArray[id].Q45FR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q45FRBR_DateMismatch = true;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      // Date of response assessment

      case "Q45BR_dateOfResponse_assessRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };

        updatedArray[id].Q45BR_dateOfResponse_assessRd = value_int;
        // Clear date when selecting "Unknown"
        if (value_int === 99) {
          updatedArray[id].Q45BR_dateOfResponse_assess_dt = "";
        }

        updatedArray[id].Q45BR_dateOfResponse_assessEmpty = false;

        updatedArray[id].Q45BRDateValidationError = false;

        if (value_int === 99) {
          updatedArray[id].Q45FRBR_DateMismatch = false;
          updatedArray[id].Q45BR_PD_DateMismatch = false;
        }

        //  Final update
        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Method of assessment
      case "Q45BR_assessmentMethodRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q45BR_assessmentMethodRd = value_int;

        updatedArray[id].Q45BR_assessmentMethodEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //46 States
      // Function to handle the change of Q46dateofassessmentRd field
      case "Q46dateofassessmentRd" + id + "-" + parentIndex: {
        const temp = [...tmtResponseProgression];

        let innerArr = [...temp[parentIndex].q46Row];

        // Update the specific item in the inner array
        innerArr[id] = {
          ...innerArr[id],
          Q46dateofassessmentRd: value_int,
          Q46dateofassessment_dt: "",

          Q46dateofassessment_dtEmpty: false,
          Invalid_dateofassessment_dt: false,
          Q46dateofassessmentEmpty: false,

          Q46DateValidationError: false,
          Q46MRD5WarningMsg: false,
          Q46MRD6WarningMsg: false,
        };

        if (value_int === 1) {
          // Update all other validation states to false
          innerArr[id] = {
            ...innerArr[id],
            Q46dateofassessment_dtEmpty: false,
            Invalid_dateofassessment_dt: false,
            Q46dateofassessmentEmpty: false,
            Q46DateValidationError: false,
            Q46assessmentmethodRd: null,
            Q46sensitivityRd: null,
            Q46mrdstatusRd: null,

            Q46assessmentmethodEmpty: false,
            Q46sensitivityEmpty: false,
            Q46mrdstatusEmpty: false,
          };
        }

        // If value_int === 1, delete all rows below the current one
        if (value_int === 1) {
          const deleteStartIndex = Number(id) + 1;
          if (deleteStartIndex >= 0 && deleteStartIndex < innerArr.length) {
            innerArr.splice(
              deleteStartIndex,
              innerArr.length - deleteStartIndex,
            );
          }
        }
        // MRD5: false if ANY row has sensitivity 1 AND mrdstatus = 2
        const blockMRD5 =
          cohortData.ndmmrrmmAchievedMRD5 === true &&
          innerArr.some(
            (row) => row.Q46sensitivityRd === 1 && row.Q46mrdstatusRd === 2,
          );

        // MRD5: true only if some row has sensitivity 1 AND mrdstatus != 2
        const requireMRD5 =
          cohortData.ndmmrrmmAchievedMRD5 === true &&
          innerArr.some(
            (row) => row.Q46sensitivityRd === 1 && row.Q46mrdstatusRd !== 2,
          );

        const finalMRD5Warning = !blockMRD5 && requireMRD5;

        // MRD6: false if ANY row has sensitivity 2 AND mrdstatus = 2
        const blockMRD6 =
          cohortData.ndmmrrmmAchievedMRD6 === true &&
          innerArr.some(
            (row) => row.Q46sensitivityRd === 2 && row.Q46mrdstatusRd === 2,
          );

        // MRD6: true only if some row has sensitivity 2 AND mrdstatus != 2
        const requireMRD6 =
          cohortData.ndmmrrmmAchievedMRD6 === true &&
          innerArr.some(
            (row) => row.Q46sensitivityRd === 2 && row.Q46mrdstatusRd !== 2,
          );

        const finalMRD6Warning = !blockMRD6 && requireMRD6;

        const hasMultipleRows = innerArr.length > 1;
        const isSingleRow = innerArr.length === 1;
        const validAssessment = (row) =>
          [1, 2, 99].includes(row.Q46dateofassessmentRd);

        const updatedInnerArr = innerArr.map((row) => {
          const keepMRD5 = hasMultipleRows && row.Q46MRD5WarningMsg === true;

          const setMRD5 =
            isSingleRow &&
            validAssessment(row) &&
            cohortData.ndmmrrmmAchievedMRD5 === true;

          const keepMRD6 = hasMultipleRows && row.Q46MRD6WarningMsg === true;

          const setMRD6 =
            isSingleRow &&
            validAssessment(row) &&
            cohortData.ndmmrrmmAchievedMRD6 === true;

          return {
            ...row,
            Q46MRD5WarningMsg: keepMRD5 || setMRD5 || finalMRD5Warning,
            Q46MRD6WarningMsg: keepMRD6 || setMRD6 || finalMRD6Warning,
          };
        });

        // // Apply results to each row
        // const updatedInnerArr = innerArr.map(row => ({
        //   ...row,
        //   Q46MRD5WarningMsg:innerArr.length>1 &&row.Q46MRD5WarningMsg==true?  cohortData.ndmmrrmmAchievedMRD5 ==true?true: finalMRD5Warning:innerArr.length==1  && [1, 2, 99].includes(row.Q46dateofassessmentRd) && cohortData.ndmmrrmmAchievedMRD5 ==true?true: finalMRD5Warning,
        //   Q46MRD6WarningMsg:innerArr.length>1 &&row.Q46MRD6WarningMsg==true?  cohortData.ndmmrrmmAchievedMRD6 ==true?true: finalMRD6Warning:innerArr.length==1 &&[1, 2, 99].includes(row.Q46dateofassessmentRd) && cohortData.ndmmrrmmAchievedMRD6 ==true?true: finalMRD6Warning
        // }));

        // Assign the updated inner array back to the outer array
        temp[parentIndex] = {
          ...temp[parentIndex],
          q46Row: updatedInnerArr,
        };

        setTmtResponseProgression(temp);

        break;
      }

      case "Q46assessmentmethodRd" + id + "-" + parentIndex: {
        const temp = [...tmtResponseProgression];

        let innerArr = [...temp[parentIndex].q46Row];

        // Update the specific item in the inner array
        innerArr[id] = {
          ...innerArr[id],
          Q46assessmentmethodRd: value_int,
          Q46assessmentmethodEmpty: false,
        };

        // Assign the updated inner array back to the outer array
        temp[parentIndex] = {
          ...temp[parentIndex],
          q46Row: innerArr,
        };

        setTmtResponseProgression(temp);

        break;
      }

      case "Q46sensitivityRd" + id + "-" + parentIndex: {
        const temp = [...tmtResponseProgression];
        const innerArr = [...temp[parentIndex].q46Row];

        innerArr[id] = {
          ...innerArr[id],
          Q46sensitivityRd: value_int,
          Q46sensitivityEmpty: false,
        };

        // MRD5: false if ANY row has sensitivity 1 AND mrdstatus = 2
        const blockMRD5 =
          cohortData.ndmmrrmmAchievedMRD5 === true &&
          innerArr.some(
            (row) => row.Q46sensitivityRd === 1 && row.Q46mrdstatusRd === 2,
          );

        // MRD5: true only if some row has sensitivity 1 AND mrdstatus != 2
        const requireMRD5 =
          cohortData.ndmmrrmmAchievedMRD5 === true &&
          !innerArr.some(
            (row) => row.Q46sensitivityRd === 1 && row.Q46mrdstatusRd === 2,
          );

        const finalMRD5Warning = !blockMRD5 && requireMRD5;

        // MRD6: false if ANY row has sensitivity 2 AND mrdstatus = 2
        const blockMRD6 =
          cohortData.ndmmrrmmAchievedMRD6 === true &&
          innerArr.some(
            (row) => row.Q46sensitivityRd === 2 && row.Q46mrdstatusRd === 2,
          );

        // MRD6: true only if some row has sensitivity 2 AND mrdstatus != 2
        const requireMRD6 =
          cohortData.ndmmrrmmAchievedMRD6 === true &&
          !innerArr.some(
            (row) => row.Q46sensitivityRd === 2 && row.Q46mrdstatusRd === 2,
          );

        const finalMRD6Warning = !blockMRD6 && requireMRD6;

        // Apply results to each row
        const updatedInnerArr = innerArr.map((row) => ({
          ...row,
          Q46MRD5WarningMsg: finalMRD5Warning,
          Q46MRD6WarningMsg: finalMRD6Warning,
        }));

        temp[parentIndex] = {
          ...temp[parentIndex],
          q46Row: updatedInnerArr, //innerArr,
        };

        setTmtResponseProgression(temp);
        break;
      }

      case "Q46mrdstatusRd" + id + "-" + parentIndex: {
        setTmtResponseProgression((prev) => {
          const temp = [...prev];
          const innerArr = [...temp[parentIndex].q46Row];

          innerArr[id] = {
            ...innerArr[id],
            Q46mrdstatusRd: value_int,
            Q46mrdstatusEmpty: false,
          };

          // MRD5: false if ANY row has sensitivity 1 AND mrdstatus = 2
          const blockMRD5 =
            cohortData.ndmmrrmmAchievedMRD5 === true &&
            innerArr.some(
              (row) => row.Q46sensitivityRd === 1 && row.Q46mrdstatusRd === 2,
            );

          // MRD5: true only if some row has sensitivity 1 AND mrdstatus != 2
          const requireMRD5 =
            cohortData.ndmmrrmmAchievedMRD5 === true &&
            !innerArr.some(
              (row) => row.Q46sensitivityRd === 1 && row.Q46mrdstatusRd === 2,
            );

          const finalMRD5Warning = !blockMRD5 && requireMRD5;

          // MRD6: false if ANY row has sensitivity 2 AND mrdstatus = 2
          const blockMRD6 =
            cohortData.ndmmrrmmAchievedMRD6 === true &&
            innerArr.some(
              (row) => row.Q46sensitivityRd === 2 && row.Q46mrdstatusRd === 2,
            );

          // MRD6: true only if some row has sensitivity 2 AND mrdstatus != 2
          const requireMRD6 =
            cohortData.ndmmrrmmAchievedMRD6 === true &&
            !innerArr.some(
              (row) => row.Q46sensitivityRd === 2 && row.Q46mrdstatusRd === 2,
            );

          const finalMRD6Warning = !blockMRD6 && requireMRD6;

          // Apply results to each row
          const updatedInnerArr = innerArr.map((row) => ({
            ...row,
            Q46MRD5WarningMsg: finalMRD5Warning,
            Q46MRD6WarningMsg: finalMRD6Warning,
          }));

          temp[parentIndex] = {
            ...temp[parentIndex],
            q46Row: updatedInnerArr, //innerArr,
          };

          return temp;
        });

        break;
      }

      // 47

      //radio - Q44dateOfProgression
      case "Q47dateOfProgressionRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };
        updatedArray[id].Q47dateOfProgressionRd = value_int;
        if (value_int === 99) {
          updatedArray[id].Q47dateOfProgression_dt = "";
          updatedArray[id].Q48BR_PD_DateMismatch = false;
        }
        // updatedArray[id].Q47dateOfProgression_dt = "";
        updatedArray[id].Q47q28WarningMsg =
          value_int == 1 && NDMMRRMMDiseaseProgression28 == true ? true : false;

        updatedArray[id].Q47dateOfProgressionEmpty = false;
        updatedArray[id].Q47dateOfProgression_dtEmpty = false;
        updatedArray[id].Invalid_Q47dateOfProgression_dt = false;

        updatedArray[id].Q47DateValidationError = false;

        if (value_int === 1) {
          updatedArray[id].Q47ConditionMet = false;
          updatedArray[id].Q47serum = false;
          updatedArray[id].Q47uninary = false;
          updatedArray[id].Q47freelight = false;
          updatedArray[id].Q47plasma = false;
          updatedArray[id].Q47bonelesion = false;
          updatedArray[id].Q47plasmacytomas = false;
          updatedArray[id].Q47ReasonOfProgression_oth = false;
          updatedArray[id].Q47ReasonOfProgression_txt = "";
          updatedArray[id].Q47ReasonOfProgression = null;
          updatedArray[id].Q47assessmentMethodRd = null;

          updatedArray[id].Q47ReasonOfProgressionEmpty = false;
          updatedArray[id].Q47ReasonOfProgressionTxtEmpty = false;
          updatedArray[id].Q47assessmentMethodEmpty = false;
          updatedArray[id].Q48BR_PD_DateMismatch = false;
          updatedArray[id].Q47dateOfProgression_dt = "";
        }

        if (value_int === 2 || value_int === 99) {
          updatedArray[id].Q47ConditionMet = true;
        } else {
          updatedArray[id].Q47ConditionMet = false;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Q44 Reason of Progression
      case "Q47serum" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q47serum = !updatedArray[id].Q47serum;
        updatedArray[id].Q47ReasonOfProgression = null;

        updatedArray[id].Q47ReasonOfProgressionEmpty = false;
        updatedArray[id].Q47ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Uninary

      case "Q47uninary" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q47uninary = !updatedArray[id].Q47uninary;
        updatedArray[id].Q47ReasonOfProgression = null;

        updatedArray[id].Q47ReasonOfProgressionEmpty = false;
        updatedArray[id].Q47ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Free light

      case "Q47freelight" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q47freelight = !updatedArray[id].Q47freelight;
        updatedArray[id].Q47ReasonOfProgression = null;

        updatedArray[id].Q47ReasonOfProgressionEmpty = false;
        updatedArray[id].Q47ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Plasma

      case "Q47plasma" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q47plasma = !updatedArray[id].Q47plasma;
        updatedArray[id].Q47ReasonOfProgression = null;

        updatedArray[id].Q47ReasonOfProgressionEmpty = false;
        updatedArray[id].Q47ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Bone lesion

      case "Q47bonelesion" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q47bonelesion = !updatedArray[id].Q47bonelesion;
        updatedArray[id].Q47ReasonOfProgression = null;

        updatedArray[id].Q47ReasonOfProgressionEmpty = false;
        updatedArray[id].Q47ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - plasmacytomas

      case "Q47plasmacytomas" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q47plasmacytomas = !updatedArray[id].Q47plasmacytomas;
        updatedArray[id].Q47ReasonOfProgression = null;

        updatedArray[id].Q47ReasonOfProgressionEmpty = false;
        updatedArray[id].Q47ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - ReasonOfProgression_oth

      case "Q47ReasonOfProgression_oth" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q47ReasonOfProgression_oth =
          !updatedArray[id].Q47ReasonOfProgression_oth;
        updatedArray[id].Q47ReasonOfProgression = null;
        updatedArray[id].Q47ReasonOfProgression_txt = "";

        updatedArray[id].Q47ReasonOfProgressionEmpty = false;
        updatedArray[id].Q47ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - ReasonOfProgression_oth

      case "Q47ReasonOfProgression_txt" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q47ReasonOfProgression_txt = value;
        updatedArray[id].Q47ReasonOfProgression = null;
        updatedArray[id].Q47ReasonOfProgression_oth = true;

        updatedArray[id].Q47ReasonOfProgressionEmpty = false;
        updatedArray[id].Q47ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Unknown
      case "Q47ReasonOfProgression" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q47ReasonOfProgression = value_int;

        updatedArray[id].Q47serum = false;
        updatedArray[id].Q47uninary = false;
        updatedArray[id].Q47freelight = false;
        updatedArray[id].Q47plasma = false;
        updatedArray[id].Q47bonelesion = false;
        updatedArray[id].Q47plasmacytomas = false;
        updatedArray[id].Q47ReasonOfProgression_oth = false;
        updatedArray[id].Q47ReasonOfProgression_txt = "";

        updatedArray[id].Q47ReasonOfProgressionEmpty = false;
        updatedArray[id].Q47ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Method of Assessment
      case "Q47assessmentMethodRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q47assessmentMethodRd = value_int;

        updatedArray[id].Q47assessmentMethodEmpty = false;

        setTmtResponseProgression(updatedArray);
        break;
      }

      //48
      //radio - Treatment Response status
      case "Q48FR_tmtResponseStatus" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };
        updatedArray[id].Q48FR_tmtResponseStatus = value_int;
        updatedArray[id].Q48FR_tmtResponseStatusEmpty = false;
        // updatedArray[id].Q48q28WarningMsg=value_int==1 && NDMMRRMMInsufficientResponse28==true?true:false;

        if (value_int == 8 || value_int === 9 || value_int == 5) {
          updatedArray[id].Q48FR_dateOfResponse_assessRd = null;
          updatedArray[id].Q48FR_dateOfResponse_assess_dt = "";
          updatedArray[id].Q48FR_assessmentMethodRd = null;

          updatedArray[id].Q48FR_dateOfResponse_assessEmpty = false;
          updatedArray[id].Q48FR_dateOfResponse_assess_dtEmpty = false;
          updatedArray[id].Invalid_Q48FR_dateOfResponse_assess_dt = false;
          updatedArray[id].Q48FR_assessmentMethodEmpty = false;

          updatedArray[id].Q48FRDateValidation = false;
        }

        if (value_int !== updatedArray[id].Q48BR_tmtResponseStatus) {
          updatedArray[id].Q48FRBR_DateMismatch = false;
        } else if (
          value_int === updatedArray[id].Q48BR_tmtResponseStatus &&
          updatedArray[id].Q48BR_dateOfResponse_assess_dt !==
            updatedArray[id].Q48FR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q48FRBR_DateMismatch = true;
        }
        //const synced = syncQ48FRBR(updatedArray, id, "FR");
        setTmtResponseProgression(updatedArray);
        break;
      }

      // Date of response assessment

      case "Q48FR_dateOfResponse_assessRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };
        updatedArray[id].Q48FR_dateOfResponse_assessRd = value_int;
        if (value_int === 99) {
          updatedArray[id].Q48FR_dateOfResponse_assess_dt = "";
          updatedArray[id].Q48FRBR_DateMismatch = false;
        }
        // updatedArray[id].Q48FR_dateOfResponse_assess_dt = "";

        updatedArray[id].Q48FR_dateOfResponse_assessEmpty = false;
        updatedArray[id].Q48FRDateValidation = false;
        const synced = syncQ48FRBR(updatedArray, id, "FR");
        setTmtResponseProgression(synced);
        break;
      }

      //radio - Method of assessment
      case "Q48FR_assessmentMethodRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q48FR_assessmentMethodRd = value_int;

        updatedArray[id].Q48FR_assessmentMethodEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //Best Response
      //radio - Treatment Response status
      case "Q48BR_tmtResponseStatus" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };
        updatedArray[id].Q48BR_tmtResponseStatus = value_int;
        updatedArray[id].Q48q28WarningMsg =
          (value_int == 7 || value_int == 8 || value_int == 9) &&
          NDMMRRMMInsufficientResponse28 == true
            ? true
            : false;
        updatedArray[id].Q48BR_tmtResponseStatusEmpty = false;

        if (value_int == 8 || value_int === 9) {
          updatedArray[id].Q48BR_dateOfResponse_assessRd = null;
          updatedArray[id].Q48BR_dateOfResponse_assess_dt = "";
          updatedArray[id].Q48BR_assessmentMethodRd = null;

          updatedArray[id].Q48BR_dateOfResponse_assessEmpty = false;
          updatedArray[id].Q48BR_dateOfResponse_assess_dtEmpty = false;
          updatedArray[id].Invalid_Q48BR_dateOfResponse_assess_dt = false;
          updatedArray[id].Q48BR_assessmentMethodEmpty = false;
          updatedArray[id].Q48PDDateMismatch = false;

          updatedArray[id].Q48BRDateValidation = false;
        }

        if (
          value_int === 7 &&
          updatedArray[id].Q47dateOfProgressionRd === 2 &&
          updatedArray[id].Q47dateOfProgression_dt &&
          updatedArray[id].Q47dateOfProgression_dt !== "" &&
          updatedArray[id].Q47dateOfProgression_dt !== "Invalid Date" &&
          updatedArray[id].Q48BR_dateOfResponse_assess_dt !== "" &&
          updatedArray[id].Q48BR_dateOfResponse_assess_dt &&
          updatedArray[id].Q48BR_dateOfResponse_assess_dt !== "Invalid Date" &&
          updatedArray[id].Q47dateOfProgression_dt !==
            updatedArray[id].Q48BR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q48BR_PD_DateMismatch = true;
        } else {
          updatedArray[id].Q48BR_PD_DateMismatch = false;
        }
        // const synced = syncQ48FRBR(updatedArray, id, "BR");
        if (value_int !== updatedArray[id].Q48FR_tmtResponseStatus) {
          updatedArray[id].Q48FRBR_DateMismatch = false;
        } else if (
          value_int === updatedArray[id].Q48FR_tmtResponseStatus &&
          updatedArray[id].Q48BR_dateOfResponse_assess_dt !==
            updatedArray[id].Q48FR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q48FRBR_DateMismatch = true;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      // Date of response assessment

      case "Q48BR_dateOfResponse_assessRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };
        updatedArray[id].Q48BR_dateOfResponse_assessRd = value_int;
        if (value_int === 99) {
          updatedArray[id].Q48BR_dateOfResponse_assess_dt = "";
          updatedArray[id].Q48FRBR_DateMismatch = false;
          updatedArray[id].Q48BR_PD_DateMismatch = false;
        }
        // updatedArray[id].Q48BR_dateOfResponse_assess_dt = "";

        updatedArray[id].Q48BR_dateOfResponse_assessEmpty = false;

        updatedArray[id].Q48BRDateValidation = false;
        updatedArray[id].Q48PDDateMismatch = false;

        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Method of assessment
      case "Q48BR_assessmentMethodRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q48BR_assessmentMethodRd = value_int;

        updatedArray[id].Q48BR_assessmentMethodEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //49,50
      //radio -
      case "Q49dateOfProgressionRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        // updatedArray[id] = { ...updatedArray[id] };
        updatedArray[id].Q49dateOfProgressionRd = value_int;
        if (value_int === 99) {
          updatedArray[id].Q50BR_PD_DateMismatch = false;
        }
        updatedArray[id].Q49dateOfProgression_dt = "";
        updatedArray[id].Q49q30WarningMsg =
          value_int == 1 && NDMMRRMMDiseaseProgression30 == true ? true : false;

        updatedArray[id].Q49dateOfProgressionEmpty = false;
        updatedArray[id].Q49dateOfProgression_dtEmpty = false;
        updatedArray[id].Invalid_Q49dateOfProgression_dt = false;

        updatedArray[id].Q49DateValidation = false;

        if (value_int === 1) {
          updatedArray[id].Q49ConditionMet = false;
          updatedArray[id].Q49serum = false;
          updatedArray[id].Q49uninary = false;
          updatedArray[id].Q49freelight = false;
          updatedArray[id].Q49plasma = false;
          updatedArray[id].Q49bonelesion = false;
          updatedArray[id].Q49plasmacytomas = false;
          updatedArray[id].Q49ReasonOfProgression_oth = false;
          updatedArray[id].Q49ReasonOfProgression_txt = "";
          updatedArray[id].Q49ReasonOfProgression = null;
          updatedArray[id].Q49assessmentMethodRd = null;

          updatedArray[id].Q49ReasonOfProgressionEmpty = false;
          updatedArray[id].Q49ReasonOfProgressionTxtEmpty = false;
          updatedArray[id].Q49assessmentMethodEmpty = false;
          updatedArray[id].Q50BR_PD_DateMismatch = false;
          updatedArray[id].Q49dateOfProgression_dt = "";
        }

        if (value_int === 2 || value_int === 99) {
          updatedArray[id].Q49ConditionMet = true;
        } else {
          updatedArray[id].Q49ConditionMet = false;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Q49 Reason of Progression
      case "Q49serum" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q49serum = !updatedArray[id].Q47serum;
        updatedArray[id].Q49ReasonOfProgression = null;

        updatedArray[id].Q49ReasonOfProgressionEmpty = false;
        updatedArray[id].Q49ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Uninary

      case "Q49uninary" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q49uninary = !updatedArray[id].Q47uninary;
        updatedArray[id].Q49ReasonOfProgression = null;

        updatedArray[id].Q49ReasonOfProgressionEmpty = false;
        updatedArray[id].Q49ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Free light

      case "Q49freelight" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q49freelight = !updatedArray[id].Q49freelight;
        updatedArray[id].Q49ReasonOfProgression = null;

        updatedArray[id].Q49ReasonOfProgressionEmpty = false;
        updatedArray[id].Q49ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Plasma

      case "Q49plasma" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q49plasma = !updatedArray[id].Q49plasma;
        updatedArray[id].Q49ReasonOfProgression = null;

        updatedArray[id].Q49ReasonOfProgressionEmpty = false;
        updatedArray[id].Q49ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Bone lesion

      case "Q49bonelesion" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q49bonelesion = !updatedArray[id].Q49bonelesion;
        updatedArray[id].Q49ReasonOfProgression = null;

        updatedArray[id].Q49ReasonOfProgressionEmpty = false;
        updatedArray[id].Q49ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - plasmacytomas

      case "Q49plasmacytomas" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q49plasmacytomas = !updatedArray[id].Q49plasmacytomas;
        updatedArray[id].Q49ReasonOfProgression = null;

        updatedArray[id].Q49ReasonOfProgressionEmpty = false;
        updatedArray[id].Q49ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - ReasonOfProgression_oth

      case "Q49ReasonOfProgression_oth" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q49ReasonOfProgression_oth =
          !updatedArray[id].Q49ReasonOfProgression_oth;
        updatedArray[id].Q49ReasonOfProgression = null;
        updatedArray[id].Q49ReasonOfProgression_txt = "";

        updatedArray[id].Q49ReasonOfProgressionEmpty = false;
        updatedArray[id].Q49ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - ReasonOfProgression_oth

      case "Q49ReasonOfProgression_txt" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q49ReasonOfProgression_txt = value;
        updatedArray[id].Q49ReasonOfProgression = null;
        updatedArray[id].Q49ReasonOfProgression_oth = true;

        updatedArray[id].Q49ReasonOfProgressionEmpty = false;
        updatedArray[id].Q49ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Unknown
      case "Q49ReasonOfProgression" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q49ReasonOfProgression = value_int;

        updatedArray[id].Q49serum = false;
        updatedArray[id].Q49uninary = false;
        updatedArray[id].Q49freelight = false;
        updatedArray[id].Q49plasma = false;
        updatedArray[id].Q49bonelesion = false;
        updatedArray[id].Q49plasmacytomas = false;
        updatedArray[id].Q49ReasonOfProgression_oth = false;
        updatedArray[id].Q49ReasonOfProgression_txt = "";

        updatedArray[id].Q49ReasonOfProgressionEmpty = false;
        updatedArray[id].Q49ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Method of Assessment
      case "Q49assessmentMethodRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q49assessmentMethodRd = value_int;

        updatedArray[id].Q49assessmentMethodEmpty = false;

        setTmtResponseProgression(updatedArray);
        break;
      }

      //50
      //radio - Treatment Response status
      case "Q50FR_tmtResponseStatus" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q50FR_tmtResponseStatus = value_int;

        updatedArray[id].Q50FR_tmtResponseStatusEmpty = false;

        if (value_int == 8 || value_int === 9 || value_int == 5) {
          updatedArray[id].Q50FR_dateOfResponse_assessRd = null;
          updatedArray[id].Q50FR_dateOfResponse_assess_dt = "";
          updatedArray[id].Q50FR_assessmentMethodRd = null;

          updatedArray[id].Q50FR_dateOfResponse_assessEmpty = false;
          updatedArray[id].Q50FR_dateOfResponse_assess_dtEmpty = false;
          updatedArray[id].Q50FR_assessmentMethodEmpty = false;
          updatedArray[id].Invalid_Q50FR_dateOfResponse_assess_dt = false;

          updatedArray[id].Q50FRDateValidation = false;
        }

        if (value_int != updatedArray[id].Q50BR_tmtResponseStatus) {
          updatedArray[id].Q50FRBR_DateMismatch = false;
        } else if (
          value_int === updatedArray[id].Q50BR_tmtResponseStatus &&
          updatedArray[id].Q50BR_dateOfResponse_assess_dt !==
            updatedArray[id].Q50FR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q50FRBR_DateMismatch = true;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      // Date of response assessment

      case "Q50FR_dateOfResponse_assessRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q50FR_dateOfResponse_assessRd = value_int;
        updatedArray[id].Q50FR_dateOfResponse_assess_dt = "";

        updatedArray[id].Q50FR_dateOfResponse_assessEmpty = false;

        updatedArray[id].Q50FRDateValidation = false;

        if (value_int === 99) {
          updatedArray[id].Q50FRBR_DateMismatch = false;
        }
        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Method of assessment
      case "Q50FR_assessmentMethodRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q50FR_assessmentMethodRd = value_int;

        updatedArray[id].Q50FR_assessmentMethodEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //Best Response
      //radio - Treatment Response status
      case "Q50BR_tmtResponseStatus" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q50BR_tmtResponseStatus = value_int;

        updatedArray[id].Q50BR_tmtResponseStatusEmpty = false;
        updatedArray[id].Q50q30WarningMsg =
          (value_int == 7 || value_int == 8 || value_int == 9) &&
          NDMMRRMMInsufficientResponse30 == true
            ? true
            : false;

        if (value_int == 8 || value_int === 9) {
          updatedArray[id].Q50BR_dateOfResponse_assessRd = null;
          updatedArray[id].Q50BR_dateOfResponse_assess_dt = "";
          updatedArray[id].Q50BR_assessmentMethodRd = null;

          updatedArray[id].Q50BR_dateOfResponse_assessEmpty = false;
          updatedArray[id].Q50BR_dateOfResponse_assess_dtEmpty = false;
          updatedArray[id].Q50BR_assessmentMethodEmpty = false;
          updatedArray[id].Invalid_Q50BR_dateOfResponse_assess_dt = false;

          updatedArray[id].Q50BRDateValidation = false;
        }

        if (
          value_int === 7 &&
          updatedArray[id].Q49dateOfProgressionRd === 2 &&
          updatedArray[id].Q49dateOfProgression_dt &&
          updatedArray[id].Q49dateOfProgression_dt !== "" &&
          updatedArray[id].Q49dateOfProgression_dt !== "Invalid Date" &&
          updatedArray[id].Q50BR_dateOfResponse_assess_dt !== "" &&
          updatedArray[id].Q50BR_dateOfResponse_assess_dt &&
          updatedArray[id].Q50BR_dateOfResponse_assess_dt !== "Invalid Date" &&
          updatedArray[id].Q49dateOfProgression_dt !==
            updatedArray[id].Q50BR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q50BR_PD_DateMismatch = true;
        } else {
          updatedArray[id].Q50BR_PD_DateMismatch = false;
        }

        if (value_int != updatedArray[id].Q50FR_tmtResponseStatus) {
          updatedArray[id].Q50FRBR_DateMismatch = false;
        } else if (
          value_int === updatedArray[id].Q50FR_tmtResponseStatus &&
          updatedArray[id].Q50BR_dateOfResponse_assess_dt !==
            updatedArray[id].Q50FR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q50FRBR_DateMismatch = true;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      // Date of response assessment

      case "Q50BR_dateOfResponse_assessRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q50BR_dateOfResponse_assessRd = value_int;
        updatedArray[id].Q50BR_dateOfResponse_assess_dt = "";

        updatedArray[id].Q50BR_dateOfResponse_assessEmpty = false;

        updatedArray[id].Q50BRDateValidation = false;

        if (value_int === 99) {
          updatedArray[id].Q50FRBR_DateMismatch = false;
          updatedArray[id].Q50BR_PD_DateMismatch = false;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Method of assessment
      case "Q50BR_assessmentMethodRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q50BR_assessmentMethodRd = value_int;

        updatedArray[id].Q50BR_assessmentMethodEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      // 51,52

      case "Q51dateOfProgressionRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q51dateOfProgressionRd = value_int;
        updatedArray[id].Q51dateOfProgression_dt = "";
        // updatedArray[id].Q51q33WarningMsg=value_int==1 && NDMMRRMMDiseaseProgression33==true?true:false;

        updatedArray[id].Q51q33WarningMsgTec =
          value_int == 1 && NDMMRRMMDiseaseProgression33Tec == true
            ? true
            : false;
        updatedArray[id].Q51q33WarningMsgTal =
          value_int == 1 && NDMMRRMMDiseaseProgression33Tal == true
            ? true
            : false;
        updatedArray[id].Q51q33WarningMsgElr =
          value_int == 1 && NDMMRRMMDiseaseProgression33Elr == true
            ? true
            : false;
        updatedArray[id].Q51q33WarningMsgLin =
          value_int == 1 && NDMMRRMMDiseaseProgression33Lin == true
            ? true
            : false;
        updatedArray[id].Q51q33WarningMsgCarvykti =
          value_int == 1 && NDMMRRMMDiseaseProgression33Carvykti == true
            ? true
            : false;
        updatedArray[id].Q51q33WarningMsgAbecma =
          value_int == 1 && NDMMRRMMDiseaseProgression33Abecma == true
            ? true
            : false;

        updatedArray[id].Q51dateOfProgressionEmpty = false;
        updatedArray[id].Q51dateOfProgression_dtEmpty = false;
        updatedArray[id].Invalid_Q51dateOfProgression_dt = false;

        updatedArray[id].Q51DateValidation = false;

        if (value_int === 1) {
          updatedArray[id].Q51ConditionMet = false;
          updatedArray[id].Q51serum = false;
          updatedArray[id].Q51uninary = false;
          updatedArray[id].Q51freelight = false;
          updatedArray[id].Q51plasma = false;
          updatedArray[id].Q51bonelesion = false;
          updatedArray[id].Q51plasmacytomas = false;
          updatedArray[id].Q51ReasonOfProgression_oth = false;
          updatedArray[id].Q51ReasonOfProgression_txt = "";
          updatedArray[id].Q51ReasonOfProgression = null;
          updatedArray[id].Q51assessmentMethodRd = null;

          updatedArray[id].Q51ReasonOfProgressionEmpty = false;
          updatedArray[id].Q51ReasonOfProgressionTxtEmpty = false;
          updatedArray[id].Q51assessmentMethodEmpty = false;
          updatedArray[id].Q52BR_PD_DateMismatch = false;
        }

        if (value_int === 99) {
          updatedArray[id].Q52BR_PD_DateMismatch = false;
        }

        if (value_int === 2 || value_int === 99) {
          updatedArray[id].Q51ConditionMet = true;
        } else {
          updatedArray[id].Q51ConditionMet = false;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Q49 Reason of Progression
      case "Q51serum" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q51serum = !updatedArray[id].Q47serum;
        updatedArray[id].Q51ReasonOfProgression = null;

        updatedArray[id].Q51ReasonOfProgressionEmpty = false;
        updatedArray[id].Q51ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Uninary

      case "Q51uninary" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q51uninary = !updatedArray[id].Q47uninary;
        updatedArray[id].Q51ReasonOfProgression = null;

        updatedArray[id].Q51ReasonOfProgressionEmpty = false;
        updatedArray[id].Q51ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Free light

      case "Q51freelight" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q51freelight = !updatedArray[id].Q51freelight;
        updatedArray[id].Q51ReasonOfProgression = null;

        updatedArray[id].Q51ReasonOfProgressionEmpty = false;
        updatedArray[id].Q51ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Plasma

      case "Q51plasma" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q51plasma = !updatedArray[id].Q49plasma;
        updatedArray[id].Q51ReasonOfProgression = null;

        updatedArray[id].Q51ReasonOfProgressionEmpty = false;
        updatedArray[id].Q51ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - Bone lesion

      case "Q51bonelesion" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q51bonelesion = !updatedArray[id].Q51bonelesion;
        updatedArray[id].Q51ReasonOfProgression = null;

        updatedArray[id].Q51ReasonOfProgressionEmpty = false;
        updatedArray[id].Q51ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - plasmacytomas

      case "Q51plasmacytomas" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q51plasmacytomas = !updatedArray[id].Q51plasmacytomas;
        updatedArray[id].Q51ReasonOfProgression = null;

        updatedArray[id].Q51ReasonOfProgressionEmpty = false;
        updatedArray[id].Q51ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - ReasonOfProgression_oth

      case "Q51ReasonOfProgression_oth" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q51ReasonOfProgression_oth =
          !updatedArray[id].Q51ReasonOfProgression_oth;
        updatedArray[id].Q51ReasonOfProgression = null;
        updatedArray[id].Q51ReasonOfProgression_txt = "";

        updatedArray[id].Q51ReasonOfProgressionEmpty = false;
        updatedArray[id].Q51ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //checkbox - ReasonOfProgression_oth

      case "Q51ReasonOfProgression_txt" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q51ReasonOfProgression_txt = value;
        updatedArray[id].Q51ReasonOfProgression = null;
        updatedArray[id].Q51ReasonOfProgression_oth = true;

        updatedArray[id].Q51ReasonOfProgressionEmpty = false;
        updatedArray[id].Q51ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Unknown
      case "Q51ReasonOfProgression" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q51ReasonOfProgression = value_int;

        updatedArray[id].Q51serum = false;
        updatedArray[id].Q51uninary = false;
        updatedArray[id].Q51freelight = false;
        updatedArray[id].Q51plasma = false;
        updatedArray[id].Q51bonelesion = false;
        updatedArray[id].Q51plasmacytomas = false;
        updatedArray[id].Q51ReasonOfProgression_oth = false;
        updatedArray[id].Q51ReasonOfProgression_txt = "";

        updatedArray[id].Q51ReasonOfProgressionEmpty = false;
        updatedArray[id].Q51ReasonOfProgressionTxtEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Method of Assessment
      case "Q51assessmentMethodRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q51assessmentMethodRd = value_int;

        updatedArray[id].Q51assessmentMethodEmpty = false;

        setTmtResponseProgression(updatedArray);
        break;
      }

      //52
      //radio - Treatment Response status
      case "Q52FR_tmtResponseStatus" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q52FR_tmtResponseStatus = value_int;

        updatedArray[id].Q52FR_tmtResponseStatusEmpty = false;

        if (value_int == 8 || value_int === 9 || value_int == 5) {
          updatedArray[id].Q52FR_dateOfResponse_assessRd = null;
          updatedArray[id].Q52FR_dateOfResponse_assess_dt = "";
          updatedArray[id].Q52FR_assessmentMethodRd = null;

          updatedArray[id].Q52FR_dateOfResponse_assessEmpty = false;
          updatedArray[id].Q52FR_dateOfResponse_assess_dtEmpty = false;
          updatedArray[id].Invalid_Q52FR_dateOfResponse_assess_dt = false;

          updatedArray[id].Q52FR_assessmentMethodEmpty = false;

          updatedArray[id].Q52FRDateValidation = false;
        }

        if (value_int != updatedArray[id].Q52BR_tmtResponseStatus) {
          updatedArray[id].Q52FRBR_DateMismatch = false;
        } else if (
          value_int === updatedArray[id].Q52BR_tmtResponseStatus &&
          updatedArray[id].Q52BR_dateOfResponse_assess_dt !==
            updatedArray[id].Q52FR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q52FRBR_DateMismatch = true;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      // Date of response assessment

      case "Q52FR_dateOfResponse_assessRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q52FR_dateOfResponse_assessRd = value_int;
        updatedArray[id].Q52FR_dateOfResponse_assess_dt = "";

        updatedArray[id].Q52FR_dateOfResponse_assessEmpty = false;

        updatedArray[id].Q52FRDateValidation = false;

        if (value_int === 99) {
          updatedArray[id].Q52FRBR_DateMismatch = false;
        }
        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Method of assessment
      case "Q52FR_assessmentMethodRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q52FR_assessmentMethodRd = value_int;

        updatedArray[id].Q52FR_assessmentMethodEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }

      //Best Response
      //radio - Treatment Response status
      case "Q52BR_tmtResponseStatus" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q52BR_tmtResponseStatus = value_int;

        updatedArray[id].Q52BR_tmtResponseStatusEmpty = false;

        updatedArray[id].Q52q33WarningMsg =
          (value_int == 7 || value_int == 8 || value_int == 9) &&
          NDMMRRMMInsufficientResponse33 == true
            ? true
            : false;
        if (value_int == 8 || value_int === 9) {
          updatedArray[id].Q52BR_dateOfResponse_assessRd = null;
          updatedArray[id].Q52BR_dateOfResponse_assess_dt = "";
          updatedArray[id].Q52BR_assessmentMethodRd = null;

          updatedArray[id].Q52BR_dateOfResponse_assessEmpty = false;
          updatedArray[id].Q52BR_dateOfResponse_assess_dtEmpty = false;
          updatedArray[id].Invalid_Q52BR_dateOfResponse_assess_dt = false;
          updatedArray[id].Q52BR_assessmentMethodEmpty = false;

          updatedArray[id].Q52BRDateValidation = false;
        }

        if (
          value_int === 7 &&
          updatedArray[id].Q51dateOfProgressionRd === 2 &&
          updatedArray[id].Q51dateOfProgression_dt &&
          updatedArray[id].Q51dateOfProgression_dt !== "" &&
          updatedArray[id].Q51dateOfProgression_dt !== "Invalid Date" &&
          updatedArray[id].Q52BR_dateOfResponse_assess_dt !== "" &&
          updatedArray[id].Q52BR_dateOfResponse_assess_dt &&
          updatedArray[id].Q52BR_dateOfResponse_assess_dt !== "Invalid Date" &&
          updatedArray[id].Q51dateOfProgression_dt !==
            updatedArray[id].Q52BR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q52BR_PD_DateMismatch = true;
        } else {
          updatedArray[id].Q52BR_PD_DateMismatch = false;
        }

        if (value_int != updatedArray[id].Q52FR_tmtResponseStatus) {
          updatedArray[id].Q52FRBR_DateMismatch = false;
        } else if (
          value_int === updatedArray[id].Q52FR_tmtResponseStatus &&
          updatedArray[id].Q52BR_dateOfResponse_assess_dt !==
            updatedArray[id].Q52FR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q52FRBR_DateMismatch = true;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      // Date of response assessment

      case "Q52BR_dateOfResponse_assessRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q52BR_dateOfResponse_assessRd = value_int;
        updatedArray[id].Q52BR_dateOfResponse_assess_dt = "";

        updatedArray[id].Q52BR_dateOfResponse_assessEmpty = false;

        updatedArray[id].Q52BRDateValidation = false;

        if (value_int === 99) {
          updatedArray[id].Q52FRBR_DateMismatch = false;
          updatedArray[id].Q52BR_PD_DateMismatch = false;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      //radio - Method of assessment
      case "Q52BR_assessmentMethodRd" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id].Q52BR_assessmentMethodRd = value_int;

        updatedArray[id].Q52BR_assessmentMethodEmpty = false;
        setTmtResponseProgression(updatedArray);
        break;
      }
      default:
        break;
    }
  };

  const HandleRepeaterDateChange = (name, date, q46Id) => {
    const lastIndex = name.lastIndexOf("-");
    const id = name.slice(lastIndex + 1);
    const parentIndex = name.substring(name.lastIndexOf("-") + 1);
    switch (name) {
      //46Date

      case "Q46dateofassessment_dt-" + q46Id + "-" + parentIndex: {
        let updatedArray = [...tmtResponseProgression];

        let innerArr = [...updatedArray[parentIndex].q46Row];

        // Update the specific item in the inner array
        innerArr[q46Id] = {
          ...innerArr[q46Id],
          Q46dateofassessment_dt: date,
          Q46dateofassessmentRd: 2,

          Q46dateofassessmentEmpty: false,
          Q46dateofassessment_dtEmpty: false,
          Invalid_dateofassessment_dt: false,

          Q46DateValidationError: false,
        };

        // Assign the updated inner array back to the outer array
        updatedArray[parentIndex] = {
          ...updatedArray[parentIndex],
          q46Row: innerArr,
        };

        setTmtResponseProgression(updatedArray);
        break;
      }

      //44 Date of progression assessment
      case "Q44dateOfProgression_dt-" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };
        updatedArray[id].Q44dateOfProgression_dt = date;
        updatedArray[id].Q44dateOfProgressionRd = 2;

        updatedArray[id].Q44EmptyError = false;
        updatedArray[id].Q44dateOfProgression_dtEmpty = false;
        updatedArray[id].Invalid_dateofProgression_dt = false;

        updatedArray[id].Q44ConditionMet = true;

        updatedArray[id].Q44DateValidationError = false;

        if (
          updatedArray[id].Q44dateOfProgressionRd === 2 &&
          updatedArray[id].Q45BR_dateOfResponse_assess_dt &&
          updatedArray[id].Q44dateOfProgression_dt &&
          updatedArray[id].Q44dateOfProgression_dt !=
            updatedArray[id].Q45BR_dateOfResponse_assess_dt &&
          updatedArray[id].Q45BR_tmtResponseStatus === 7
        ) {
          updatedArray[id].Q45BR_PD_DateMismatch = true;
        }
        setTmtResponseProgression(updatedArray);
        break;
      }

      //45 date of progression FR
      case "Q45FR_dateOfResponse_assess_dt-" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };

        updatedArray[id].Q45FR_dateOfResponse_assess_dt = date;
        updatedArray[id].Q45FR_dateOfResponse_assessRd = 1;

        updatedArray[id].Q45FR_dateOfResponse_assessEmpty = false;
        updatedArray[id].Q45FR_dateOfResponse_assess_dtEmpty = false;
        updatedArray[id].Invalid_dateofResponse_assess_dt = false;

        updatedArray[id].Q45FRDateValidationError = false;

        if (
          updatedArray[id].Q45FR_tmtResponseStatus ==
            updatedArray[id].Q45BR_tmtResponseStatus &&
          updatedArray[id].Q45FR_dateOfResponse_assessRd === 1 &&
          updatedArray[id].Q45BR_dateOfResponse_assessRd === 1 &&
          date != updatedArray[id].Q45BR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q45FRBR_DateMismatch = true;
        } else {
          updatedArray[id].Q45FRBR_DateMismatch = false;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      //BR
      case "Q45BR_dateOfResponse_assess_dt-" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };

        updatedArray[id].Q45BR_dateOfResponse_assess_dt = date;
        updatedArray[id].Q45BR_dateOfResponse_assessRd = 1;

        updatedArray[id].Q45BR_dateOfResponse_assessEmpty = false;
        updatedArray[id].Q45BR_dateOfResponse_assess_dtEmpty = false;
        updatedArray[id].Invalid_BR_dateOfResponse_assess_dt = false;

        updatedArray[id].Q45BRDateValidationError = false;

        if (
          updatedArray[id].Q45FR_tmtResponseStatus ==
            updatedArray[id].Q45BR_tmtResponseStatus &&
          updatedArray[id].Q45FR_dateOfResponse_assessRd === 1 &&
          updatedArray[id].Q45BR_dateOfResponse_assessRd === 1 &&
          date != updatedArray[id].Q45FR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q45FRBR_DateMismatch = true;
        } else {
          updatedArray[id].Q45FRBR_DateMismatch = false;
        }

        if (
          updatedArray[id].Q45BR_tmtResponseStatus === 7 &&
          updatedArray[id].Q44dateOfProgression_dt &&
          updatedArray[id].Q44dateOfProgression_dt != date
        ) {
          updatedArray[id].Q45BR_PD_DateMismatch = true;
        } else {
          updatedArray[id].Q45BR_PD_DateMismatch = false;
        }

        // Final update
        setTmtResponseProgression(updatedArray);
        break;
      }

      //47

      case "Q47dateOfProgression_dt-" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };

        updatedArray[id].Q47dateOfProgression_dt = date;
        updatedArray[id].Q47dateOfProgressionRd = 2;

        updatedArray[id].Q47ConditionMet = true;

        updatedArray[id].Q47dateOfProgressionEmpty = false;
        updatedArray[id].Q47dateOfProgression_dtEmpty = false;
        updatedArray[id].Invalid_Q47dateOfProgression_dt = false;

        updatedArray[id].Q47DateValidationError = false;

        if (
          updatedArray[id].Q47dateOfProgressionRd === 2 &&
          updatedArray[id].Q48BR_dateOfResponse_assess_dt &&
          updatedArray[id].Q47dateOfProgression_dt &&
          updatedArray[id].Q47dateOfProgression_dt !=
            updatedArray[id].Q48BR_dateOfResponse_assess_dt &&
          updatedArray[id].Q48BR_tmtResponseStatus === 7
        ) {
          updatedArray[id].Q48BR_PD_DateMismatch = true;
        }
        setTmtResponseProgression(updatedArray);
        break;
      }

      //48

      case "Q48FR_dateOfResponse_assess_dt-" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };

        updatedArray[id].Q48FR_dateOfResponse_assess_dt = date;
        updatedArray[id].Q48FR_dateOfResponse_assessRd = 1;

        updatedArray[id].Q48FR_dateOfResponse_assessEmpty = false;
        updatedArray[id].Q48FR_dateOfResponse_assess_dtEmpty = false;
        updatedArray[id].Invalid_Q48FR_dateOfResponse_assess_dt = false;
        updatedArray[id].Q48FRDateValidation = false;

        if (
          updatedArray[id].Q48FR_tmtResponseStatus ==
            updatedArray[id].Q48BR_tmtResponseStatus &&
          updatedArray[id].Q48FR_dateOfResponse_assessRd === 1 &&
          updatedArray[id].Q48BR_dateOfResponse_assessRd === 1 &&
          date != updatedArray[id].Q48BR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q48FRBR_DateMismatch = true;
        } else {
          updatedArray[id].Q48FRBR_DateMismatch = false;
        }
        //  const synced = syncQ48FRBR(updatedArray, id, "FR");
        setTmtResponseProgression(updatedArray);
        break;
      }

      //BR
      case "Q48BR_dateOfResponse_assess_dt-" + id: {
        let updatedArray = [...tmtResponseProgression];
        updatedArray[id] = { ...updatedArray[id] };

        updatedArray[id].Q48BR_dateOfResponse_assess_dt = date;
        updatedArray[id].Q48BR_dateOfResponse_assessRd = 1;

        updatedArray[id].Q48BR_dateOfResponse_assessEmpty = false;
        updatedArray[id].Q48BR_dateOfResponse_assess_dtEmpty = false;
        updatedArray[id].Invalid_Q48BR_dateOfResponse_assess_dt = false;

        updatedArray[id].Q48BRDateValidation = false;

        if (
          updatedArray[id].Q48FR_tmtResponseStatus ==
            updatedArray[id].Q48BR_tmtResponseStatus &&
          updatedArray[id].Q48FR_dateOfResponse_assessRd === 1 &&
          updatedArray[id].Q48BR_dateOfResponse_assessRd === 1 &&
          date != updatedArray[id].Q48FR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q48FRBR_DateMismatch = true;
        } else {
          updatedArray[id].Q48FRBR_DateMismatch = false;
        }

        if (
          updatedArray[id].Q48BR_tmtResponseStatus === 7 &&
          updatedArray[id].Q47dateOfProgression_dt &&
          updatedArray[id].Q47dateOfProgression_dt != date
        ) {
          updatedArray[id].Q48BR_PD_DateMismatch = true;
        } else {
          updatedArray[id].Q48BR_PD_DateMismatch = false;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      //49
      case "Q49dateOfProgression_dt-" + id: {
        let updatedArray = [...tmtResponseProgression];
        // updatedArray[id] = { ...updatedArray[id] };

        updatedArray[id].Q49dateOfProgression_dt = date;
        updatedArray[id].Q49dateOfProgressionRd = 2;

        updatedArray[id].Q49ConditionMet = true;

        updatedArray[id].Q49dateOfProgressionEmpty = false;
        updatedArray[id].Q49dateOfProgression_dtEmpty = false;
        updatedArray[id].Invalid_Q49dateOfProgression_dt = false;

        updatedArray[id].Q49DateValidation = false;

        if (
          updatedArray[id].Q49dateOfProgressionRd === 2 &&
          updatedArray[id].Q50BR_dateOfResponse_assess_dt &&
          updatedArray[id].Q49dateOfProgression_dt &&
          updatedArray[id].Q49dateOfProgression_dt !=
            updatedArray[id].Q50BR_dateOfResponse_assess_dt &&
          updatedArray[id].Q50BR_tmtResponseStatus === 7
        ) {
          updatedArray[id].Q50BR_PD_DateMismatch = true;
        }
        setTmtResponseProgression(updatedArray);
        break;
      }

      //50

      case "Q50FR_dateOfResponse_assess_dt-" + id: {
        let updatedArray = [...tmtResponseProgression];

        updatedArray[id].Q50FR_dateOfResponse_assess_dt = date;
        updatedArray[id].Q50FR_dateOfResponse_assessRd = 1;

        updatedArray[id].Q50FR_dateOfResponse_assessEmpty = false;
        updatedArray[id].Q50FR_dateOfResponse_assess_dtEmpty = false;
        updatedArray[id].Invalid_Q50FR_dateOfResponse_assess_dt = false;

        updatedArray[id].Q50FRDateValidation = false;

        if (
          updatedArray[id].Q50FR_tmtResponseStatus ==
            updatedArray[id].Q50BR_tmtResponseStatus &&
          updatedArray[id].Q50FR_dateOfResponse_assessRd === 1 &&
          updatedArray[id].Q50BR_dateOfResponse_assessRd === 1 &&
          date != updatedArray[id].Q50BR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q50FRBR_DateMismatch = true;
        } else {
          updatedArray[id].Q50FRBR_DateMismatch = false;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      //BR
      case "Q50BR_dateOfResponse_assess_dt-" + id: {
        let updatedArray = [...tmtResponseProgression];

        updatedArray[id].Q50BR_dateOfResponse_assess_dt = date;
        updatedArray[id].Q50BR_dateOfResponse_assessRd = 1;

        updatedArray[id].Q50BR_dateOfResponse_assessEmpty = false;
        updatedArray[id].Q50BR_dateOfResponse_assess_dtEmpty = false;
        updatedArray[id].Invalid_Q50BR_dateOfResponse_assess_dt = false;

        updatedArray[id].Q50BRDateValidation = false;

        if (
          updatedArray[id].Q50FR_tmtResponseStatus ==
            updatedArray[id].Q50BR_tmtResponseStatus &&
          updatedArray[id].Q50FR_dateOfResponse_assessRd === 1 &&
          updatedArray[id].Q50BR_dateOfResponse_assessRd === 1 &&
          date != updatedArray[id].Q50FR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q50FRBR_DateMismatch = true;
        } else {
          updatedArray[id].Q50FRBR_DateMismatch = false;
        }

        if (
          updatedArray[id].Q50BR_tmtResponseStatus === 7 &&
          updatedArray[id].Q49dateOfProgression_dt &&
          updatedArray[id].Q49dateOfProgression_dt != date
        ) {
          updatedArray[id].Q50BR_PD_DateMismatch = true;
        } else {
          updatedArray[id].Q50BR_PD_DateMismatch = false;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      //51
      case "Q51dateOfProgression_dt-" + id: {
        let updatedArray = [...tmtResponseProgression];

        updatedArray[id].Q51dateOfProgression_dt = date;
        updatedArray[id].Q51dateOfProgressionRd = 2;
        updatedArray[id].Q51ConditionMet = true;

        updatedArray[id].Q51dateOfProgressionEmpty = false;
        updatedArray[id].Q51dateOfProgression_dtEmpty = false;
        updatedArray[id].Invalid_Q51dateOfProgression_dt = false;

        updatedArray[id].Q51DateValidation = false;

        if (
          updatedArray[id].Q51dateOfProgressionRd === 2 &&
          updatedArray[id].Q52BR_dateOfResponse_assess_dt &&
          updatedArray[id].Q51dateOfProgression_dt &&
          updatedArray[id].Q51dateOfProgression_dt !=
            updatedArray[id].Q52BR_dateOfResponse_assess_dt &&
          updatedArray[id].Q52BR_tmtResponseStatus === 7
        ) {
          updatedArray[id].Q52BR_PD_DateMismatch = true;
        }
        setTmtResponseProgression(updatedArray);
        break;
      }

      //52

      case "Q52FR_dateOfResponse_assess_dt-" + id: {
        let updatedArray = [...tmtResponseProgression];

        updatedArray[id].Q52FR_dateOfResponse_assess_dt = date;
        updatedArray[id].Q52FR_dateOfResponse_assessRd = 1;

        updatedArray[id].Q52FR_dateOfResponse_assessEmpty = false;
        updatedArray[id].Q52FR_dateOfResponse_assess_dtEmpty = false;
        updatedArray[id].Invalid_Q52FR_dateOfResponse_assess_dt = false;

        updatedArray[id].Q52FRDateValidation = false;

        if (
          updatedArray[id].Q52FR_tmtResponseStatus ==
            updatedArray[id].Q52BR_tmtResponseStatus &&
          updatedArray[id].Q52FR_dateOfResponse_assessRd === 1 &&
          updatedArray[id].Q52BR_dateOfResponse_assessRd === 1 &&
          date != updatedArray[id].Q52BR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q52FRBR_DateMismatch = true;
        } else {
          updatedArray[id].Q52FRBR_DateMismatch = false;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }

      //BR
      case "Q52BR_dateOfResponse_assess_dt-" + id: {
        let updatedArray = [...tmtResponseProgression];

        updatedArray[id].Q52BR_dateOfResponse_assess_dt = date;
        updatedArray[id].Q52BR_dateOfResponse_assessRd = 1;

        updatedArray[id].Q52BR_dateOfResponse_assessEmpty = false;
        updatedArray[id].Q52BR_dateOfResponse_assess_dtEmpty = false;
        updatedArray[id].Invalid_Q52BR_dateOfResponse_assess_dt = false;

        updatedArray[id].Q52BRDateValidation = false;

        if (
          updatedArray[id].Q52FR_tmtResponseStatus ==
            updatedArray[id].Q52BR_tmtResponseStatus &&
          updatedArray[id].Q52FR_dateOfResponse_assessRd === 1 &&
          updatedArray[id].Q52BR_dateOfResponse_assessRd === 1 &&
          date != updatedArray[id].Q52FR_dateOfResponse_assess_dt
        ) {
          updatedArray[id].Q52FRBR_DateMismatch = true;
        } else {
          updatedArray[id].Q52FRBR_DateMismatch = false;
        }

        if (
          updatedArray[id].Q52BR_tmtResponseStatus === 7 &&
          updatedArray[id].Q51dateOfProgression_dt &&
          updatedArray[id].Q51dateOfProgression_dt != date
        ) {
          updatedArray[id].Q52BR_PD_DateMismatch = true;
        } else {
          updatedArray[id].Q52BR_PD_DateMismatch = false;
        }

        setTmtResponseProgression(updatedArray);
        break;
      }
      default:
        break;
    }
  };

  const buildNextLotStartDatesLookup = (list) => {
    const map = new Map();

    list.forEach((cohort) => {
      const questionMap = new Map();

      cohort.questions?.forEach((q) => {
        questionMap.set(q.questionCode, q.nextLotStartDate);
      });

      map.set(cohort.cohortTreatmentId, questionMap);
    });

    return map;
  };

  const LoadData = async () => {
    ToggleLoader(true);
    try {
      if (pid > 0) {
        const response = await ClinicalOutcomes.LoadTreatmentResponseData(pid);

        if (response?.status === HTTPResponse.OK) {
          const { data } = response;
          const nextLotLookup = buildNextLotStartDatesLookup(
            data.cohortNextLotDatesList ?? [],
          );
          setCohortNextLotDatesList(nextLotLookup);
          setAssessmentMethods(data.assessmentMethods);

          setNDMMRRMMDiseaseProgression28(data.ndmmrrmmDiseaseProgression28);
          setNDMMRRMMInsufficientResponse28(
            data.ndmmrrmmInsufficientResponse28,
          );
          setNDMMRRMMInsufficientResponse30(
            data.ndmmrrmmInsufficientResponse30,
          );
          setNDMMRRMMDiseaseProgression30(data.ndmmrrmmDiseaseProgression30);

          setNDMMRRMMDiseaseProgression33Tec(
            data.ndmmrrmmDiseaseProgression33Tec,
          );
          setNDMMRRMMDiseaseProgression33Tal(
            data.ndmmrrmmDiseaseProgression33Tal,
          );
          setNDMMRRMMDiseaseProgression33Lin(
            data.ndmmrrmmDiseaseProgression33Lin,
          );
          setNDMMRRMMDiseaseProgression33Elr(
            data.ndmmrrmmDiseaseProgression33Elr,
          );
          setNDMMRRMMDiseaseProgression33Carvykti(
            data.ndmmrrmmDiseaseProgression33Carvykti,
          );
          setNDMMRRMMDiseaseProgression33Abecma(
            data.ndmmrrmmDiseaseProgression33Abecma,
          );

          setNDMMRRMMAchievedVGPR(data.ndmmrrmmAchievedVGPR);

          setNDMMRRMMInsufficientResponse33(
            data.ndmmrrmmInsufficientResponse33,
          );
          setNDMMSecondLotStartDate(data.ndmmSecondLotStartDate || "");

          setNDMMThirdLotStartDate(data.ndmmThirdLotStartDate || "");

          setNdmmEndofFollowupDate(
            data.ndmmEndOfFollowUpDate == null ||
              data.ndmmEndOfFollowUpDate === ""
              ? data.endOfFollowUpDate == null || data.endOfFollowUpDate === ""
                ? "[NDMM End of Follow up Date]"
                : data.endOfFollowUpDate
              : data.ndmmEndOfFollowUpDate,
          );

          setEndOfFollowUpDate(data.endOfFollowUpDate || "");

          const cohortTreatmentMap = new Map();
          if (cohortTreatmentModelListt?.length > 0) {
            const rrmmMap = new Map(
              (data.rrmmBispecificDates || []).map((x) => [
                x.cohorttreatmentid,
                x.bispecificsEndOfFollowUp,
                x.lotStartDate,
              ]),
            );
            const fallbackFollowUp = data.endOfFollowUpDate;

            cohortTreatmentModelListt.forEach((item) => {
              if (item.isEligible) {
                const bispecificNextLOTStartDate =
                  rrmmMap.get(item.cohortTreatmentID) || "";

                const followUp =
                  rrmmMap.get(item.cohortTreatmentID) ||
                  fallbackFollowUp ||
                  null;
                const bispecificEOFLabel =
                  rrmmMap.get(item.cohortTreatmentID) ||
                  fallbackFollowUp ||
                  `[${item.cohortTreatmentName} End of Follow up Date]`;

                cohortTreatmentMap.set(item.cohortTreatmentID, {
                  cohortTreatmentName:
                    item.cohortTreatmentName === "DKRd (TE or TIE)"
                      ? item.cohortTreatmentSCT === 1
                        ? "DKRd (TE)"
                        : item.cohortTreatmentSCT === 2
                          ? "DKRd (TIE)"
                          : item.cohortTreatmentName
                      : item.cohortTreatmentName,
                  cohortIndexDate: item.earliestCohortIndexDate,
                  cohortTreatmentNameSuperscript:
                    item.cohortTreatmentNameSuperscript,
                  bispecificEOF: followUp,
                  bispecificEOFLabel,
                  bispecificNextLOTStartDate,
                });
              }
            });
          }

          if (
            data.treatmentResponseData === 0 ||
            data.treatmentResponseData === undefined ||
            data.treatmentResponseData.length === 0
          ) {
            const warnings = {};
            const hasMRDNegativity105 = data.ndmmrrmmAchievedMRD5 === true;
            const hasMRDNegativity106 = data.ndmmrrmmAchievedMRD6 === true;
            warnings[0] = {
              show105: hasMRDNegativity105,
              show106: hasMRDNegativity106,
            };

            setQ46MRDWarnings((prev) => {
              const updated = { ...prev, ...warnings };

              return updated;
            });
          }

          let repeaterData = [];
          const cohortTreatmentModelList = data.cohortTreatmentModelList || [];
          settreatmentlist(cohortTreatmentModelList);

          // // Handling Treatment Response Data
          if (
            data.treatmentResponseData &&
            data.treatmentResponseData.length !== 0
          ) {
            const cohortTreatmentDataMap = new Map();

            // Populate the map with data grouped by cohortTreatmentId
            data.treatmentResponseData.forEach((item) => {
              const cohortTreatmentId = item.cohorttreatmentid;
              if (!cohortTreatmentDataMap.has(cohortTreatmentId)) {
                cohortTreatmentDataMap.set(cohortTreatmentId, []);
              }
              cohortTreatmentDataMap.get(cohortTreatmentId).push(item);
            });

            // Iterate over the map to create response items
            cohortTreatmentDataMap.forEach((items, cohortTreatmentId) => {
              // Fetch cohort treatment details

              const cohortTreatment =
                cohortTreatmentMap.get(cohortTreatmentId) || {};

              const matchingItem = cohortTreatmentModelList.find(
                (item) => item.cohortTreatmentID === cohortTreatmentId,
              );

              //to get lot num for Q51 52
              const rrmmLot = data.cohortLotNumberListRRMM?.find(
                (rrmmItem) => rrmmItem.cohorttreatmentid === cohortTreatmentId,
              );
              const lotNum = rrmmLot?.lotnumberid;
              // Determine the lines of treatment present for this cohort

              const lotOne =
                matchingItem.ndmm === true
                  ? items.find((a) => a.lineoftreatmentid === 1)
                  : lotNum === undefined
                    ? items.find((a) => a.ndmm === false)
                    : items.find(
                        (a) =>
                          a.ndmm === false && a.lineoftreatmentid !== lotNum,
                      );
              const lotTwo = items.find((a) => a.lineoftreatmentid === 2);
              const lotThree = items.find((a) => a.lineoftreatmentid === 3);
              const subsequentLot =
                lotNum === undefined
                  ? items.find((a) => a.ndmm === false)
                  : items.find(
                      (a) => a.ndmm === false && a.lineoftreatmentid == lotNum,
                    );

              const cohortTreatmentIdsForSuboptimalResponse =
                data.cohortTreatmentIdsForSuboptimalResponse ?? [];

              const q45SuboptimalResponseSelectedInQ26 =
                cohortTreatmentIdsForSuboptimalResponse &&
                cohortTreatmentIdsForSuboptimalResponse.includes(
                  cohortTreatmentId,
                );
              // Initialize the object with common properties
              const responseItem = {
                cohorttreatmentid: cohortTreatmentId,
                cohortTreatmentName:
                  (cohortTreatment.cohortTreatmentName === "DKRd (TE or TIE)"
                    ? cohortTreatment.cohortTreatmentSCT === 1
                      ? "DKRd (TE)"
                      : cohortTreatment.cohortTreatmentSCT === 2
                        ? "DKRd (TIE)"
                        : cohortTreatment.cohortTreatmentName
                    : cohortTreatment.cohortTreatmentName) || null,
                cohortIndexDate: cohortTreatment.cohortIndexDate || null,
                cohortTreatmentNameSuperscript:
                  cohortTreatment.cohortTreatmentNameSuperscript || null,
                cohorttreatmentNextLotDate: "",
                bispecificEOF: cohortTreatment.bispecificEOF || "",
                bispecificEOFLabel: cohortTreatment.bispecificEOFLabel || "",
                bispecificNextLOTStartDate:
                  cohortTreatment.bispecificNextLOTStartDate || "",
                lotNum,
                Q44EmptyError: false,
                Invalid_dateofProgression_dt: false,
                Q44dateOfProgression_dtEmpty: false,
                Q44DateValidationError: false,
                Q44ReasonOfProgressionEmpty: false,
                Q44ReasonOfProgressionTxtEmpty: false,
                Q44assessmentMethodEmpty: false,
                Q44WarningMsg: false,

                Q45FR_tmtResponseStatusEmpty: false,
                Q45FR_dateOfResponse_assessEmpty: false,
                Q45FRBR_DateMismatch: false,
                Q45FR_dateOfResponse_assess_dtEmpty: false,
                Invalid_dateofResponse_assess_dt: false,
                Q45FRDateValidationError: false,
                Q45FR_assessmentMethodEmpty: false,
                Q45BR_tmtResponseStatusEmpty: false,
                Q45BR_dateOfResponse_assessEmpty: false,
                Q45BR_PD_DateMismatch: false,
                Q45BR_dateOfResponse_assess_dtEmpty: false,
                Invalid_BR_dateOfResponse_assess_dt: false,
                Q45BRDateValidationError: false,
                Q45BR_assessmentMethodEmpty: false,
                Q45WarningMsg: false,
                Q45VGPRWarningMsg: false,
                Q45PRWarningMsg: false,
                q45SuboptimalResponseSelectedInQ26:
                  q45SuboptimalResponseSelectedInQ26,
                q46Row: [
                  {
                    treatmentmrdassessmentbridgeid: 0,
                    Q46dateofassessmentRd: null,
                    Q46dateofassessment_dt: "",
                    Invalid_dateofassessment_dt: false,
                    Q46assessmentmethodRd: null,
                    Q46sensitivityRd: null,
                    Q46mrdstatusRd: null,

                    Q46dateofassessmentEmpty: false,
                    Q46dateofassessment_dtEmpty: false,
                    Q46assessmentmethodEmpty: false,
                    Q46sensitivityEmpty: false,
                    Q46mrdstatusEmpty: false,

                    Q46DateValidationError: false,

                    Q46MRD5WarningMsg: false,
                    Q46MRD6WarningMsg: false,

                    ndmmrrmmAchievedMRD5Tec: false,
                    ndmmrrmmAchievedMRD6Tec: false,
                    ndmmrrmmAchievedMRD5Tal: false,
                    ndmmrrmmAchievedMRD6Tal: false,
                    ndmmrrmmAchievedMRD5Elr: false,
                    ndmmrrmmAchievedMRD6Elr: false,
                    ndmmrrmmAchievedMRD5Lin: false,
                    ndmmrrmmAchievedMRD6Lin: false,
                    // showQ46Columns:false,
                  },
                ],

                Q47dateOfProgressionEmpty: false,
                Q47dateOfProgression_dtEmpty: false,
                Invalid_Q47dateOfProgression_dt: false,
                Q47DateValidationError: false,
                Q47ReasonOfProgressionEmpty: false,
                Q47ReasonOfProgressionTxtEmpty: false,
                Q47assessmentMethodEmpty: false,
                Q47q28WarningMsg: false,

                Q48FR_tmtResponseStatusEmpty: false,
                Q48FR_dateOfResponse_assessEmpty: false,
                Q48FRBR_DateMismatch: false,
                Q48FR_dateOfResponse_assess_dtEmpty: false,
                Invalid_Q48FR_dateOfResponse_assess_dt: false,
                Q48FRDateValidation: false,
                Q48FR_assessmentMethodEmpty: false,

                Q48BR_tmtResponseStatusEmpty: false,
                Q48PDDateMismatch: false,
                Q48BR_dateOfResponse_assessEmpty: false,
                Q48BR_dateOfResponse_assess_dtEmpty: false,
                Invalid_Q48BR_dateOfResponse_assess_dt: false,
                Q48BR_PD_DateMismatch: false,
                Q48BRDateValidation: false,
                Q48BR_assessmentMethodEmpty: false,
                Q48q28WarningMsg: false,

                Q49dateOfProgressionEmpty: false,
                Q49dateOfProgression_dtEmpty: false,
                Invalid_Q49dateOfProgression_dt: false,
                Q49DateValidation: false,
                Q49ReasonOfProgressionEmpty: false,
                Q49ReasonOfProgressionTxtEmpty: false,
                Q49assessmentMethodEmpty: false,
                Q49q30WarningMsg: false,

                Q50FR_dateOfResponse_assessEmpty: false,
                Q50FRBR_DateMismatch: false,
                Q50FR_dateOfResponse_assess_dtEmpty: false,
                Invalid_Q50FR_dateOfResponse_assess_dt: false,
                Q50FRDateValidation: false,
                Q50DateMismatch: false,
                Q50PDDateMismatch: false,
                Q50DateEmpty: false,
                Invalid_Q50BR_dateOfResponse_assess_dt: false,
                Q50BRDateValidation: false,
                Q50BR_assessmentMethodEmpty: false,
                Q50q30WarningMsg: false,

                Q51dateOfProgressionEmpty: false,
                Q51dateOfProgression_dtEmpty: false,
                Invalid_Q51dateOfProgression_dt: false,
                Q51DateValidation: false,
                Q51ReasonOfProgressionEmpty: false,
                Q51ReasonOfProgressionTxtEmpty: false,
                Q51assessmentMethodEmpty: false,
                Q51q33WarningMsgTec: false,
                Q51q33WarningMsgTal: false,
                Q51q33WarningMsgLin: false,
                Q51q33WarningMsgElr: false,
                Q51q33WarningMsgAbecma: false,
                Q51q33WarningMsgCarvykti: false,

                Q52FR_tmtResponseStatusEmpty: false,
                Q52FR_dateOfResponse_assessEmpty: false,
                Q52FRBR_DateMismatch: false,
                Q52FR_dateOfResponse_assess_dtEmpty: false,
                Invalid_Q52FR_dateOfResponse_assess_dt: false,
                Q52FRDateValidation: false,
                Q52FR_assessmentMethodEmpty: false,

                Q52BR_tmtResponseStatusEmpty: false,
                Q52BR_dateOfResponse_assessEmpty: false,
                Q52BR_PD_DateMismatch: false,
                Q52BR_dateOfResponse_assess_dtEmpty: false,
                Invalid_Q52BR_dateOfResponse_assess_dt: false,
                Q52BRDateValidation: false,
                Q52BR_assessmentMethodEmpty: false,
                Q52q33WarningMsg: false,
              };
              // Conditionally add questions based on line of treatment

              if (lotOne) {
                const rrmmLot = data.cohortLotNumberListRRMM?.find(
                  (rrmmItem) =>
                    rrmmItem.cohorttreatmentid ===
                    responseItem.cohorttreatmentid,
                );
                const showQ51_52 =
                  rrmmLot !== undefined
                    ? rrmmLot?.rrmmLotnumberids === true
                    : false; // && rrmmLot?.lotStartdate !=null

                const cohort = data.cohortTreatmentModelList.find(
                  (c) => c.cohortTreatmentID === responseItem.cohorttreatmentid,
                );

                Object.assign(responseItem, {
                  // Questions 44-45

                  cohorttreatmentNextLotDate:
                    lotOne.cohorttreatmentNextLotDate || "",
                  treatmentresponseprogressionid1:
                    lotOne.treatmentresponseprogressionid,
                  Q44dateOfProgressionRd:
                    lotOne.progressionDidnotoccur === true
                      ? 1
                      : lotOne.progressionDate
                        ? 2
                        : lotOne.progressionDateUnk === true
                          ? 99
                          : null,

                  Q44ConditionMet:
                    lotOne.progressionDate !== "" ||
                    lotOne.progressionDateUnk === true
                      ? true
                      : false,

                  Q44dateOfProgression_dt: lotOne.progressionDate,

                  Q44WarningMsg:
                    data.cohortTreatmentModelList.filter(
                      (c) =>
                        c.cohortTreatmentID === responseItem.cohorttreatmentid,
                    ).ndmmrrmmDiseaseProg === true,
                  // Q44WarningMsgTec:data.ndmmrrmmDiseaseProgressionTec ==true && lotOne.progressionDidnotoccur === true,
                  // Q44WarningMsgTal:data.ndmmrrmmDiseaseProgressionTal ==true && lotOne.progressionDidnotoccur === true,
                  // Q44WarningMsgElr:data.ndmmrrmmDiseaseProgressionElr ==true && lotOne.progressionDidnotoccur === true,
                  // Q44WarningMsgLin:data.ndmmrrmmDiseaseProgressionLin ==true && lotOne.progressionDidnotoccur === true,

                  Q44serum: lotOne.progressionReasonSerum,
                  Q44uninary: lotOne.progressionReasonUrinary,
                  Q44freelight: lotOne.progressionReasonFreelight,
                  Q44plasma: lotOne.progressionReasonPlasmacell,
                  Q44bonelesion: lotOne.progressionReasonIncreasesizeBone,
                  Q44plasmacytomas:
                    lotOne.progressionReasonIncreasesizePlasmacytomas,
                  Q44ReasonOfProgression_oth: lotOne.progressionReasonOth,
                  Q44ReasonOfProgression_txt: lotOne.progressionReasonOthTxt,
                  Q44ReasonOfProgression:
                    lotOne.progressionReasonUnk === true ? 99 : null,
                  Q44assessmentMethodRd: lotOne.assessmentmethodid || null,

                  Q45FR_tmtResponseStatus:
                    lotOne.firstTreatmentresponseStatus || null,

                  Q45FR_dateOfResponse_assessRd:
                    lotOne.firstResponseAssessmentDateUnk === true
                      ? 99
                      : lotOne.firstResponseAssessmentDate
                        ? 1
                        : null,

                  Q45FR_dateOfResponse_assess_dt:
                    lotOne.firstResponseAssessmentDate || "",
                  Q45FR_assessmentMethodRd:
                    lotOne.firstAssessmentmethodid || null,

                  Q45BR_tmtResponseStatus:
                    lotOne.bestTreatmentresponseStatus || null,

                  Q45BR_dateOfResponse_assessRd:
                    lotOne.bestResponseAssessmentDateUnk === true
                      ? 99
                      : lotOne.bestResponseAssessmentDate
                        ? 1
                        : null,

                  Q45BR_dateOfResponse_assess_dt:
                    lotOne.bestResponseAssessmentDate || "",
                  Q45BR_assessmentMethodRd:
                    lotOne.bestAssessmentmethodid || null,

                  Q45WarningMsg:
                    cohort?.ndmmrrmmAchievedCR === true &&
                    lotOne.firstTreatmentresponseStatus != null &&
                    lotOne.bestTreatmentresponseStatus != null &&
                    ![1, 2].includes(lotOne.firstTreatmentresponseStatus) &&
                    ![1, 2].includes(lotOne.bestTreatmentresponseStatus),

                  Q45VGPRWarningMsg:
                    data.ndmmrrmmAchievedVGPR == true &&
                    lotOne.firstTreatmentresponseStatus != null &&
                    lotOne.bestTreatmentresponseStatus != null &&
                    ![1, 2, 3].includes(lotOne.firstTreatmentresponseStatus) &&
                    ![1, 2, 3].includes(lotOne.bestTreatmentresponseStatus),
                  //!(lotOne.firstTreatmentresponseStatus === 1 || lotOne.firstTreatmentresponseStatus === 2) ,//&& lotOne.progressionDidnotoccur === true
                  Q45PRWarningMsg:
                    q45SuboptimalResponseSelectedInQ26 === true &&
                    lotOne.firstTreatmentresponseStatus != null &&
                    lotOne.bestTreatmentresponseStatus != null &&
                    ![4].includes(lotOne.firstTreatmentresponseStatus) &&
                    ![4, 6].includes(lotOne.bestTreatmentresponseStatus),
                  //&& lotOne.progressionDidnotoccur === true,
                  Q44EmptyError: false,
                  Invalid_dateofProgression_dt: false,
                  Q44dateOfProgression_dtEmpty: false,
                  Q44ReasonOfProgressionEmpty: false,
                  Q44ReasonOfProgressionTxtEmpty: false,
                  Q44assessmentMethodEmpty: false,

                  Q45FR_tmtResponseStatusEmpty: false,
                  Q45FR_dateOfResponse_assessEmpty: false,
                  Q45FR_dateOfResponse_assess_dtEmpty: false,
                  Invalid_dateofResponse_assess_dt: false,
                  Q45FR_assessmentMethodEmpty: false,
                  //false,
                  Q45FRBR_DateMismatch:
                    lotOne.firstTreatmentresponseStatus ==
                      lotOne.bestTreatmentresponseStatus &&
                    lotOne.bestResponseAssessmentDate != null &&
                    lotOne.firstResponseAssessmentDate != null &&
                    lotOne.bestResponseAssessmentDate !=
                      lotOne.firstResponseAssessmentDate,

                  //false,
                  Q45BR_PD_DateMismatch:
                    lotOne.progressionDate &&
                    lotOne.bestTreatmentresponseStatus === 7 &&
                    lotOne.bestResponseAssessmentDate &&
                    lotOne.progressionDate != lotOne.bestResponseAssessmentDate,

                  Q45BR_tmtResponseStatusEmpty: false,
                  Q45BR_dateOfResponse_assessEmpty: false,
                  Q45BR_dateOfResponse_assess_dtEmpty: false,
                  Q45BR_assessmentMethodEmpty: false,
                  Invalid_BR_dateOfResponse_assess_dt: false,

                  Q44DateValidationError: false,

                  Q45FRDateValidationError: false,
                  Q45BRDateValidationError: false,

                  showQ51_52,

                  Q51dateOfProgressionEmpty: false,
                  Q51dateOfProgression_dtEmpty: false,
                  Invalid_Q51dateOfProgression_dt: false,

                  Q51ReasonOfProgressionEmpty: false,
                  Q51ReasonOfProgressionTxtEmpty: false,
                  Q51assessmentMethodEmpty: false,

                  Q51DateValidation: false,

                  Q52FR_tmtResponseStatusEmpty: false,
                  Q52FR_dateOfResponse_assessEmpty: false,
                  Q52FR_dateOfResponse_assess_dtEmpty: false,
                  Invalid_Q52FR_dateOfResponse_assess_dt: false,
                  Q52FR_assessmentMethodEmpty: false,

                  Q52FRDateValidation: false,

                  Q52BR_tmtResponseStatusEmpty: false,
                  Q52BR_dateOfResponse_assessEmpty: false,
                  Q52BR_dateOfResponse_assess_dtEmpty: false,
                  Invalid_Q52BR_dateOfResponse_assess_dt: false,
                  Q52BR_assessmentMethodEmpty: false,

                  Q52BRDateValidation: false,

                  //47-48
                  Q47dateOfProgressionEmpty: false,
                  Q47dateOfProgression_dtEmpty: false,
                  Invalid_Q47dateOfProgression_dt: false,

                  Q47ReasonOfProgressionEmpty: false,
                  Q47ReasonOfProgressionTxtEmpty: false,
                  Q47assessmentMethodEmpty: false,

                  Q47DateValidationError: false,

                  Q48FR_tmtResponseStatusEmpty: false,
                  Q48FR_dateOfResponse_assessEmpty: false,
                  Q48FR_dateOfResponse_assess_dtEmpty: false,
                  Q48FR_assessmentMethodEmpty: false,
                  Invalid_Q48FR_dateOfResponse_assess_dt: false,
                  Q48FRBR_DateMismatch: false,
                  Q48BR_PD_DateMismatch: false,

                  Q48FRDateValidation: false,

                  Q48BR_tmtResponseStatusEmpty: false,
                  Q48BR_dateOfResponse_assessEmpty: false,
                  Q48BR_dateOfResponse_assess_dtEmpty: false,
                  Invalid_Q48BR_dateOfResponse_assess_dt: false,
                  Q48BR_assessmentMethodEmpty: false,

                  Q48BRDateValidation: false,

                  //49-50

                  Q49dateOfProgressionEmpty: false,
                  Q49dateOfProgression_dtEmpty: false,
                  Invalid_Q49dateOfProgression_dt: false,
                  Q49ReasonOfProgressionEmpty: false,
                  Q49ReasonOfProgressionTxtEmpty: false,
                  Q49assessmentMethodEmpty: false,

                  Q49DateValidation: false,

                  Q50FR_tmtResponseStatusEmpty: false,
                  Q50FR_dateOfResponse_assessEmpty: false,
                  Q50FR_dateOfResponse_assess_dtEmpty: false,
                  Invalid_Q50FR_dateOfResponse_assess_dt: false,
                  Q50FR_assessmentMethodEmpty: false,

                  Q50FRBR_DateMismatch: false,
                  Q50BR_PD_DateMismatch: false,

                  Q50FRDateValidation: false,

                  Q50BR_tmtResponseStatusEmpty: false,
                  Q50BR_dateOfResponse_assessEmpty: false,
                  Q50BR_dateOfResponse_assess_dtEmpty: false,
                  Invalid_Q50BR_dateOfResponse_assess_dt: false,
                  Q50BR_assessmentMethodEmpty: false,

                  Q50BRDateValidation: false,
                });

                // Handle q46Row (MRD Assessment) for lotOne
                const filteredMRDData =
                  data.tmtResponseRptData?.filter(
                    (mrd) => mrd.cohorttreatmentid === cohortTreatmentId,
                  ) || [];

                const warnings = {};

                warnings[0] = { show105: false, show106: false };

                // filteredMRDData?.forEach(item => {
                const cohortId = filteredMRDData[0]?.cohorttreatmentid;

                const hasMRDNegativity105Tec =
                  data.ndmmrrmmAchievedMRD5Tec === true;
                const hasMRDNegativity105Tal =
                  data.ndmmrrmmAchievedMRD5Tal === true;
                const hasMRDNegativity105Elr =
                  data.ndmmrrmmAchievedMRD5Elr === true;
                const hasMRDNegativity105Lin =
                  data.ndmmrrmmAchievedMRD5Lin === true;

                const hasMismatch105Tec = filteredMRDData.some(
                  (mrd) =>
                    mrd.cohorttreatmentid === 9 &&
                    mrd.mrdStatus === 2 &&
                    mrd.mrdAssessmentSensitivity === 1,
                );

                const hasMismatch105Lin = filteredMRDData.some(
                  (mrd) =>
                    mrd.cohorttreatmentid === 12 &&
                    mrd.mrdStatus === 2 &&
                    mrd.mrdAssessmentSensitivity === 1,
                );

                const hasMismatch105Tal = filteredMRDData.some(
                  (mrd) =>
                    mrd.cohorttreatmentid === 10 &&
                    mrd.mrdStatus === 2 &&
                    mrd.mrdAssessmentSensitivity === 1,
                );

                const hasMismatch105Elr = filteredMRDData.some(
                  (mrd) =>
                    mrd.cohorttreatmentid === 11 &&
                    mrd.mrdStatus === 2 &&
                    mrd.mrdAssessmentSensitivity === 1,
                );

                const hasMRDNegativity106Tec =
                  data.ndmmrrmmAchievedMRD6Tec === true;
                const hasMRDNegativity106Tal =
                  data.ndmmrrmmAchievedMRD6Tal === true;
                const hasMRDNegativity106Elr =
                  data.ndmmrrmmAchievedMRD6Elr === true;
                const hasMRDNegativity106Lin =
                  data.ndmmrrmmAchievedMRD6Lin === true;

                const hasMismatch106Tec = filteredMRDData.some(
                  (mrd) =>
                    mrd.cohorttreatmentid === 9 &&
                    mrd.mrdStatus === 2 &&
                    mrd.mrdAssessmentSensitivity === 2,
                );

                const hasMismatch106Tal = filteredMRDData.some(
                  (mrd) =>
                    mrd.cohorttreatmentid === 10 &&
                    mrd.mrdStatus === 2 &&
                    mrd.mrdAssessmentSensitivity === 2,
                );

                const hasMismatch106Elr = filteredMRDData.some(
                  (mrd) =>
                    mrd.cohorttreatmentid === 11 &&
                    mrd.mrdStatus === 2 &&
                    mrd.mrdAssessmentSensitivity === 2,
                );

                const hasMismatch106Lin = filteredMRDData.some(
                  (mrd) =>
                    mrd.cohorttreatmentid === 12 &&
                    mrd.mrdStatus === 2 &&
                    mrd.mrdAssessmentSensitivity === 2,
                );

                warnings[cohortId] = {
                  show105Tec: hasMRDNegativity105Tec && !hasMismatch105Tec,
                  show106Tec: hasMRDNegativity106Tec && !hasMismatch106Tec,
                  show105Tal: hasMRDNegativity105Tal && !hasMismatch105Tal,
                  show106Tal: hasMRDNegativity106Tal && !hasMismatch106Tal,
                  show105Elr: hasMRDNegativity105Elr && !hasMismatch105Elr,
                  show106Elr: hasMRDNegativity106Elr && !hasMismatch106Elr,
                  show105Lin: hasMRDNegativity105Lin && !hasMismatch105Lin,
                  show106Lin: hasMRDNegativity106Lin && !hasMismatch106Lin,
                };
                // });

                setQ46MRDWarnings((prev) => ({
                  ...prev,
                  ...warnings,
                }));

                responseItem.q46Row =
                  filteredMRDData.length > 0
                    ? filteredMRDData.map((mrd) => ({
                        treatmentmrdassessmentbridgeid:
                          mrd.treatmentmrdassessmentbridgeid,
                        Q46dateofassessmentRd:
                          mrd.mrdNotAssessed === true
                            ? 1
                            : mrd.mrdAssessesDate
                              ? 2
                              : mrd.mrdAssessesDateUnk == true
                                ? 99
                                : null,
                        Q46dateofassessment_dt: mrd.mrdAssessesDate,
                        Q46assessmentmethodRd: mrd.mrdAssessmentmethod,
                        Q46sensitivityRd: mrd.mrdAssessmentSensitivity,
                        Q46mrdstatusRd: mrd.mrdStatus,

                        Q46MRD5WarningMsg:
                          data.cohortTreatmentModelList.filter(
                            (c) =>
                              c.cohortTreatmentID ===
                              responseItem.cohorttreatmentid,
                          ).ndmmrrmmAchievedMRD5 === true &&
                          mrd.mrdStatus != 1 &&
                          mrd.mrdAssessmentSensitivity != 1,
                        Q46MRD6WarningMsg:
                          data.cohortTreatmentModelList.filter(
                            (c) =>
                              c.cohortTreatmentID ===
                              responseItem.cohorttreatmentid,
                          ).ndmmrrmmAchievedMRD6 === true &&
                          mrd.mrdStatus != 2 &&
                          mrd.mrdAssessmentSensitivity != 2,

                        // Q46MRD5WarningMsgTec:mrd.ndmmrrmmAchievedMRD5Tec ==true && mrd.mrdStatus !=1 && mrd.mrdAssessmentSensitivity !=1, //&& lotOne.progressionDidnotoccur === true,
                        // Q46MRD6WarningMsgTec:mrd.ndmmrrmmAchievedMRD6Tec ==true  && mrd.mrdStatus !=2 && mrd.mrdAssessmentSensitivity !=2 , //&& lotOne.progressionDidnotoccur === true,

                        // Q46MRD5WarningMsgTal:mrd.ndmmrrmmAchievedMRD5Tal ==true && mrd.mrdStatus !=2 && mrd.mrdAssessmentSensitivity !=1, //&& lotOne.progressionDidnotoccur === true,
                        // Q46MRD6WarningMsgTal:mrd.ndmmrrmmAchievedMRD6Tal ==true && mrd.mrdStatus !=2 && mrd.mrdAssessmentSensitivity !=2  , //&& lotOne.progressionDidnotoccur === true,

                        // Q46MRD5WarningMsgElr:mrd.ndmmrrmmAchievedMRD5Elr ==true && mrd.mrdStatus !=2 && mrd.mrdAssessmentSensitivity !=1, //&& lotOne.progressionDidnotoccur === true,
                        // Q46MRD6WarningMsgElr:mrd.ndmmrrmmAchievedMRD6Elr ==true && mrd.mrdStatus !=2 && mrd.mrdAssessmentSensitivity !=2 , //&& lotOne.progressionDidnotoccur === true,

                        // Q46MRD5WarningMsgLin:mrd.ndmmrrmmAchievedMRD5Lin ==true && mrd.mrdStatus !=2 && mrd.mrdAssessmentSensitivity !=1, //&& lotOne.progressionDidnotoccur === true,
                        // Q46MRD6WarningMsgLin:mrd.ndmmrrmmAchievedMRD6Lin ==true && mrd.mrdStatus !=2 && mrd.mrdAssessmentSensitivity !=2 , //&& lotOne.progressionDidnotoccur === true,

                        ndmmrrmmAchievedMRD5Tec: mrd.ndmmrrmmAchievedMRD5Tec,
                        ndmmrrmmAchievedMRD6Tec: mrd.ndmmrrmmAchievedMRD6Tec,
                        ndmmrrmmAchievedMRD5Tal: mrd.ndmmrrmmAchievedMRD5Tal,
                        ndmmrrmmAchievedMRD6Tal: mrd.ndmmrrmmAchievedMRD6Tal,
                        ndmmrrmmAchievedMRD5Elr: mrd.ndmmrrmmAchievedMRD5Elr,
                        ndmmrrmmAchievedMRD6Elr: mrd.ndmmrrmmAchievedMRD6Elr,
                        ndmmrrmmAchievedMRD5Lin: mrd.ndmmrrmmAchievedMRD5Lin,
                        ndmmrrmmAchievedMRD6Lin: mrd.ndmmrrmmAchievedMRD6Lin,
                        //   setShowQ46Columns:(isStringEmpty(mrd.mrdAssessesDate) ||  mrd.mrdAssessesDateUnk===true )?true:false,

                        Q46dateofassessmentEmpty: false,
                        Q46dateofassessment_dtEmpty: false,
                        Invalid_dateofassessment_dt: false,
                        Q46assessmentmethodEmpty: false,
                        Q46sensitivityEmpty: false,
                        Q46mrdstatusEmpty: false,

                        Q46DateValidationError: false,
                      }))
                    : [
                        {
                          treatmentmrdassessmentbridgeid: 0,
                          Q46dateofassessmentRd: null,
                          Q46dateofassessment_dt: "",
                          Q46assessmentmethodRd: null,
                          Q46sensitivityRd: null,
                          Q46mrdstatusRd: null,

                          Q46dateofassessmentEmpty: false,
                          Q46dateofassessment_dtEmpty: false,
                          Invalid_dateofassessment_dt: false,
                          Q46assessmentmethodEmpty: false,
                          Q46sensitivityEmpty: false,
                          Q46mrdstatusEmpty: false,

                          Q46DateValidationError: false,
                        },
                      ];
              }

              if (lotTwo) {
                Object.assign(responseItem, {
                  // Questions 47-48
                  treatmentresponseprogressionid2:
                    lotTwo.treatmentresponseprogressionid,
                  Q47dateOfProgressionRd:
                    lotTwo.progressionDidnotoccur === true
                      ? 1
                      : lotTwo.progressionDate
                        ? 2
                        : lotTwo.progressionDateUnk === true
                          ? 99
                          : null,
                  Q47dateOfProgression_dt: lotTwo.progressionDate,
                  Q47q28WarningMsg:
                    data.ndmmrrmmDiseaseProgression28 == true &&
                    lotTwo.progressionDidnotoccur === true,
                  Q48q28WarningMsg:
                    data.ndmmrrmmInsufficientResponse28 == true &&
                    lotOne.progressionDidnotoccur === true,

                  Q47serum: lotTwo.progressionReasonSerum,
                  Q47uninary: lotTwo.progressionReasonUrinary,
                  Q47freelight: lotTwo.progressionReasonFreelight,
                  Q47plasma: lotTwo.progressionReasonPlasmacell,
                  Q47bonelesion: lotTwo.progressionReasonIncreasesizeBone,
                  Q47plasmacytomas:
                    lotTwo.progressionReasonIncreasesizePlasmacytomas,

                  Q47ReasonOfProgression_oth: lotTwo.progressionReasonOth,

                  Q47ReasonOfProgression_txt: lotTwo.progressionReasonOthTxt,
                  Q47ReasonOfProgression:
                    lotTwo.progressionReasonUnk === true ? 99 : null,
                  Q47assessmentMethodRd: lotTwo.assessmentmethodid,

                  // Q47ConditionMet:
                  //   lotTwo.progressionDidnotoccur === true ? false : true,
                  Q47ConditionMet:
                    lotTwo.progressionDate !== "" ||
                    lotTwo.progressionDateUnk === true
                      ? true
                      : false,

                  Q48FR_tmtResponseStatus: lotTwo.firstTreatmentresponseStatus,
                  Q48FR_dateOfResponse_assessRd:
                    lotTwo.firstResponseAssessmentDateUnk === true
                      ? 99
                      : lotTwo.firstResponseAssessmentDate
                        ? 1
                        : null,
                  Q48FR_dateOfResponse_assess_dt:
                    lotTwo.firstResponseAssessmentDate,
                  Q48FR_assessmentMethodRd: lotTwo.firstAssessmentmethodid,

                  Q48BR_tmtResponseStatus: lotTwo.bestTreatmentresponseStatus,
                  Q48BR_dateOfResponse_assessRd:
                    lotTwo.bestResponseAssessmentDateUnk === true
                      ? 99
                      : lotTwo.bestResponseAssessmentDate
                        ? 1
                        : null,
                  Q48BR_dateOfResponse_assess_dt:
                    lotTwo.bestResponseAssessmentDate,
                  Q48BR_assessmentMethodRd: lotTwo.bestAssessmentmethodid,

                  // Q47ConditionMet:false,
                  Q47dateOfProgressionEmpty: false,
                  Q47dateOfProgression_dtEmpty: false,
                  Invalid_Q47dateOfProgression_dt: false,

                  Q47ReasonOfProgressionEmpty: false,
                  Q47ReasonOfProgressionTxtEmpty: false,
                  Q47assessmentMethodEmpty: false,

                  Q47DateValidationError: false,

                  Q48FR_tmtResponseStatusEmpty: false,
                  Q48FR_dateOfResponse_assessEmpty: false,
                  Q48FR_dateOfResponse_assess_dtEmpty: false,
                  Q48FR_assessmentMethodEmpty: false,
                  Invalid_Q48FR_dateOfResponse_assess_dt: false,

                  Q48FRDateValidation: false,

                  Q48BR_tmtResponseStatusEmpty: false,
                  Q48BR_dateOfResponse_assessEmpty: false,
                  Q48BR_dateOfResponse_assess_dtEmpty: false,
                  Invalid_Q48BR_dateOfResponse_assess_dt: false,
                  Q48BR_assessmentMethodEmpty: false,
                  Q48PDDateMismatch: false,
                  Q48FRBR_DateMismatch:
                    lotTwo.firstTreatmentresponseStatus ==
                      lotTwo.bestTreatmentresponseStatus &&
                    lotTwo.bestResponseAssessmentDate != null &&
                    lotTwo.firstResponseAssessmentDate != null &&
                    lotTwo.bestResponseAssessmentDate !=
                      lotTwo.firstResponseAssessmentDate,

                  // false,
                  Q48BR_PD_DateMismatch:
                    lotTwo.progressionDate &&
                    lotTwo.bestTreatmentresponseStatus === 7 &&
                    lotTwo.bestResponseAssessmentDate &&
                    lotTwo.progressionDate != lotTwo.bestResponseAssessmentDate,

                  Q48BRDateValidation: false,
                });
              }

              if (lotThree) {
                Object.assign(responseItem, {
                  // Questions 49-50
                  treatmentresponseprogressionid3:
                    lotThree.treatmentresponseprogressionid,

                  Q49dateOfProgressionRd:
                    lotThree.progressionDidnotoccur === true
                      ? 1
                      : lotThree.progressionDate
                        ? 2
                        : lotThree.progressionDateUnk === true
                          ? 99
                          : null,
                  Q49dateOfProgression_dt: lotThree.progressionDate,
                  Q49q30WarningMsg:
                    data.ndmmrrmmDiseaseProgression30 == true &&
                    lotThree.progressionDidnotoccur === true,
                  Q50q30WarningMsg:
                    data.ndmmrrmmInsufficientResponse30 == true &&
                    (lotThree.bestTreatmentresponseStatus === 7 ||
                      lotThree.bestTreatmentresponseStatus === 8 ||
                      lotThree.bestTreatmentresponseStatus === 9),
                  Q49serum: lotThree.progressionReasonSerum,
                  Q49uninary: lotThree.progressionReasonUrinary,
                  Q49freelight: lotThree.progressionReasonFreelight,
                  Q49plasma: lotThree.progressionReasonPlasmacell,
                  Q49bonelesion: lotThree.progressionReasonIncreasesizeBone,
                  Q49plasmacytomas:
                    lotThree.progressionReasonIncreasesizePlasmacytomas,
                  Q49ReasonOfProgression_oth: lotThree.progressionReasonOth,
                  Q49ReasonOfProgression_txt: lotThree.progressionReasonOthTxt,
                  Q49ReasonOfProgression: lotThree.progressionReasonUnk
                    ? 99
                    : null,
                  Q49assessmentMethodRd: lotThree.assessmentmethodid,

                  // Q49ConditionMet:
                  //   lotThree.progressionDidnotoccur === true ? false : true,

                  Q49ConditionMet:
                    lotThree.progressionDate !== "" ||
                    lotThree.progressionDateUnk === true
                      ? true
                      : false,

                  Q50FR_tmtResponseStatus:
                    lotThree.firstTreatmentresponseStatus,
                  Q50FR_dateOfResponse_assessRd:
                    lotThree.firstResponseAssessmentDateUnk === true
                      ? 99
                      : lotThree.firstResponseAssessmentDate
                        ? 1
                        : null,
                  Q50FR_dateOfResponse_assess_dt:
                    lotThree.firstResponseAssessmentDate,
                  Q50FR_assessmentMethodRd: lotThree.firstAssessmentmethodid,

                  Q50BR_tmtResponseStatus: lotThree.bestTreatmentresponseStatus,
                  Q50BR_dateOfResponse_assessRd:
                    lotThree.bestResponseAssessmentDateUnk === true
                      ? 99
                      : lotThree.bestResponseAssessmentDate
                        ? 1
                        : null,
                  Q50BR_dateOfResponse_assess_dt:
                    lotThree.bestResponseAssessmentDate,
                  Q50BR_assessmentMethodRd: lotThree.bestAssessmentmethodid,

                  Q49dateOfProgressionEmpty: false,
                  Q49dateOfProgression_dtEmpty: false,
                  Invalid_Q49dateOfProgression_dt: false,
                  Q49ReasonOfProgressionEmpty: false,
                  Q49ReasonOfProgressionTxtEmpty: false,
                  Q49assessmentMethodEmpty: false,

                  Q49DateValidation: false,

                  Q50FR_tmtResponseStatusEmpty: false,
                  Q50FR_dateOfResponse_assessEmpty: false,
                  Q50FR_dateOfResponse_assess_dtEmpty: false,
                  Invalid_Q50FR_dateOfResponse_assess_dt: false,
                  Q50FR_assessmentMethodEmpty: false,

                  Q50FRDateValidation: false,

                  Q50BR_tmtResponseStatusEmpty: false,
                  Q50BR_dateOfResponse_assessEmpty: false,
                  Q50BR_dateOfResponse_assess_dtEmpty: false,
                  Invalid_Q50BR_dateOfResponse_assess_dt: false,
                  Q50BR_assessmentMethodEmpty: false,

                  Q50BRDateValidation: false,

                  Q50FRBR_DateMismatch:
                    lotThree.firstTreatmentresponseStatus ==
                      lotThree.bestTreatmentresponseStatus &&
                    lotThree.bestResponseAssessmentDate != null &&
                    lotThree.firstResponseAssessmentDate != null &&
                    lotThree.bestResponseAssessmentDate !=
                      lotThree.firstResponseAssessmentDate,

                  Q50BR_PD_DateMismatch:
                    lotThree.progressionDate &&
                    lotThree.bestTreatmentresponseStatus === 7 &&
                    lotThree.bestResponseAssessmentDate &&
                    lotThree.progressionDate !=
                      lotThree.bestResponseAssessmentDate,
                });
              }

              if (subsequentLot) {
                // let showQ51_52 = false;
                // if (
                //   data.cohortLotNumberListRRMM &&
                //   data.cohortLotNumberListRRMM.length > 0
                // ) {
                //   data.cohortLotNumberListRRMM.forEach((item) => {
                //     if (item.rrmmLotnumberids === true && item.lotStartdate !=null ) {
                //       showQ51_52 = true;
                //     }
                //   });
                // }
                const rrmmLot = data.cohortLotNumberListRRMM?.find(
                  (rrmmItem) =>
                    rrmmItem.cohorttreatmentid ===
                    responseItem.cohorttreatmentid,
                );
                const showQ51_52 = rrmmLot?.rrmmLotnumberids === true; // && rrmmLot?.lotStartdate !=null

                Object.assign(responseItem, {
                  // Questions 51-52
                  treatmentresponseprogressionid4:
                    subsequentLot.treatmentresponseprogressionid,
                  showQ51_52,
                  Q51dateOfProgressionRd:
                    subsequentLot.progressionDidnotoccur === true
                      ? 1
                      : subsequentLot.progressionDate
                        ? 2
                        : subsequentLot.progressionDateUnk === true
                          ? 99
                          : null,

                  Q52q33WarningMsg:
                    data.ndmmrrmmInsufficientResponse33 == true &&
                    (subsequentLot.bestTreatmentresponseStatus === 7 ||
                      subsequentLot.bestTreatmentresponseStatus === 8 ||
                      subsequentLot.bestTreatmentresponseStatus === 9),
                  Q51dateOfProgression_dt: subsequentLot.progressionDate,
                  // Q51q33WarningMsg:data.ndmmrrmmDiseaseProgression33 == true && subsequentLot.progressionDidnotoccur === true,

                  Q51q33WarningMsgTec:
                    data.ndmmrrmmDiseaseProgression33Tec == true &&
                    subsequentLot.progressionDidnotoccur === true,
                  Q51q33WarningMsgTal:
                    data.ndmmrrmmDiseaseProgression33Tal == true &&
                    subsequentLot.progressionDidnotoccur === true,
                  Q51q33WarningMsgElr:
                    data.ndmmrrmmDiseaseProgression33Elr == true &&
                    subsequentLot.progressionDidnotoccur === true,
                  Q51q33WarningMsgLin:
                    data.ndmmrrmmDiseaseProgression33Lin == true &&
                    subsequentLot.progressionDidnotoccur === true,
                  Q51q33WarningMsgCarvykti:
                    data.ndmmrrmmDiseaseProgression33Carvykti == true &&
                    subsequentLot.progressionDidnotoccur === true,
                  Q51q33WarningMsgAbecma:
                    data.ndmmrrmmDiseaseProgression33Abecma == true &&
                    subsequentLot.progressionDidnotoccur === true,

                  Q51serum: subsequentLot.progressionReasonSerum,
                  Q51uninary: subsequentLot.progressionReasonUrinary,
                  Q51freelight: subsequentLot.progressionReasonFreelight,
                  Q51plasma: subsequentLot.progressionReasonPlasmacell,
                  Q51bonelesion:
                    subsequentLot.progressionReasonIncreasesizeBone,
                  Q51plasmacytomas:
                    subsequentLot.progressionReasonIncreasesizePlasmacytomas,
                  Q51ReasonOfProgression_oth:
                    subsequentLot.progressionReasonOth,
                  Q51ReasonOfProgression_txt:
                    subsequentLot.progressionReasonOthTxt,
                  Q51ReasonOfProgression:
                    subsequentLot.progressionReasonUnk === true ? 99 : null,
                  Q51assessmentMethodRd: subsequentLot.assessmentmethodid,

                  Q51ConditionMet:
                    (subsequentLot.progressionDate !== "" ||
                      subsequentLot.progressionDateUnk === true) &&
                    subsequentLot.progressionDidnotoccur !== true
                      ? true
                      : false,

                  // subsequentLot.progressionDidnotoccur === true
                  //   ? false
                  //   : true,
                  Q52FR_tmtResponseStatus:
                    subsequentLot.firstTreatmentresponseStatus,
                  Q52FR_dateOfResponse_assessRd:
                    subsequentLot.firstResponseAssessmentDateUnk === true
                      ? 99
                      : subsequentLot.firstResponseAssessmentDate
                        ? 1
                        : null,
                  Q52FR_dateOfResponse_assess_dt:
                    subsequentLot.firstResponseAssessmentDate,
                  Q52FR_assessmentMethodRd:
                    subsequentLot.firstAssessmentmethodid,

                  Q52BR_tmtResponseStatus:
                    subsequentLot.bestTreatmentresponseStatus,
                  Q52BR_dateOfResponse_assessRd:
                    subsequentLot.bestResponseAssessmentDateUnk === true
                      ? 99
                      : subsequentLot.bestResponseAssessmentDate
                        ? 1
                        : null,
                  Q52BR_dateOfResponse_assess_dt:
                    subsequentLot.bestResponseAssessmentDate,
                  Q52BR_assessmentMethodRd:
                    subsequentLot.bestAssessmentmethodid,

                  Q51dateOfProgressionEmpty: false,
                  Q51dateOfProgression_dtEmpty: false,
                  Invalid_Q51dateOfProgression_dt: false,

                  Q51ReasonOfProgressionEmpty: false,
                  Q51ReasonOfProgressionTxtEmpty: false,
                  Q51assessmentMethodEmpty: false,

                  Q51DateValidation: false,

                  Q52FR_tmtResponseStatusEmpty: false,
                  Q52FR_dateOfResponse_assessEmpty: false,
                  Q52FR_dateOfResponse_assess_dtEmpty: false,
                  Invalid_Q52FR_dateOfResponse_assess_dt: false,
                  Q52FR_assessmentMethodEmpty: false,

                  Q52FRDateValidation: false,

                  Q52BR_tmtResponseStatusEmpty: false,
                  Q52BR_dateOfResponse_assessEmpty: false,
                  Q52BR_dateOfResponse_assess_dtEmpty: false,
                  Invalid_Q52BR_dateOfResponse_assess_dt: false,
                  Q52BR_assessmentMethodEmpty: false,

                  Q52BRDateValidation: false,

                  //false,
                  Q52FRBR_DateMismatch:
                    subsequentLot.firstTreatmentresponseStatus ==
                      subsequentLot.bestTreatmentresponseStatus &&
                    subsequentLot.bestResponseAssessmentDate != null &&
                    subsequentLot.firstResponseAssessmentDate != null &&
                    subsequentLot.bestResponseAssessmentDate !=
                      subsequentLot.firstResponseAssessmentDate,
                  //false,
                  Q52BR_PD_DateMismatch:
                    subsequentLot.progressionDate &&
                    subsequentLot.bestTreatmentresponseStatus === 7 &&
                    subsequentLot.bestResponseAssessmentDate &&
                    subsequentLot.progressionDate !=
                      subsequentLot.bestResponseAssessmentDate,
                });
              }

              const list = data.cohortLotNumberListNDMM || [];

              setShowQ47_48(
                list.some(
                  (x) => x.lotnumberid === 2 && x.notReceived === false,
                ),
              );
              setShowQ49_50(
                list.some(
                  (x) => x.lotnumberid === 3 && x.notReceived === false,
                ),
              );

              if (data.assessmentMethods && data.assessmentMethods.length > 0) {
                data.assessmentMethods.map((a) => {
                  TmtResponseProgressionRow.assessmentMethod.push({
                    assessmentMethodName: a.name,
                  });
                });
              }

              repeaterData.push(responseItem);
            });

            setTmtResponseProgression(repeaterData);

            // Merge with cohortTreatmentModelListt
            cohortTreatmentModelListt.forEach((cohort) => {
              if (
                !repeaterData.some(
                  (item) => item.cohorttreatmentid === cohort.cohortTreatmentID,
                )
              ) {
                const cohortTreatment =
                  cohortTreatmentMap.get(cohort.cohortTreatmentID) || {};

                repeaterData.push({
                  ...TmtResponseProgressionRow,
                  cohorttreatmentid: cohort.cohortTreatmentID,
                  cohortTreatmentName:
                    cohort.cohortTreatmentName === "DKRd (TE or TIE)"
                      ? cohort.cohortTreatmentSCT === 1
                        ? "DKRd (TE)"
                        : cohort.cohortTreatmentSCT === 2
                          ? "DKRd (TIE)"
                          : cohort.cohortTreatmentName
                      : cohort.cohortTreatmentName,
                  cohortIndexDate: cohort.earliestCohortIndexDate,

                  cohortTreatmentNameSuperscript:
                    cohort.cohortTreatmentNameSuperscript || null,
                  bispecificEOF: cohortTreatment.followUp || "",
                  bispecificEOFLabel: cohortTreatment.bispecificEOFLabel || "",
                  bispecificNextLOTStartDate:
                    cohortTreatment.bispecificNextLOTStartDate || "",
                });
              }
            });

            setTmtResponseProgression(repeaterData);
          } else {
            // No comorbidity data, use cohortTreatmentModelListt
            if (cohortTreatmentModelListt != null) {
              repeaterData = cohortTreatmentModelListt.map((item, index) => {
                const rrmmLot = data.cohortLotNumberListRRMM?.find(
                  (rrmmItem) =>
                    rrmmItem.cohorttreatmentid === item.cohortTreatmentID,
                );
                const showQ51_52 = rrmmLot?.rrmmLotnumberids === true; // && rrmmLot?.lotStartdate !=null
                const lotNum = data.cohortLotNumberListRRMM?.find(
                  (a) => a.cohorttreatmentid === item.cohortTreatmentID,
                )?.lotnumberid;
                const cohortTreatment =
                  cohortTreatmentMap.get(item.cohortTreatmentID) || {};

                return {
                  ...TmtResponseProgressionRow,
                  cohorttreatmentid: item.cohortTreatmentID,
                  cohortTreatmentName:
                    item.cohortTreatmentName === "DKRd (TE or TIE)"
                      ? item.cohortTreatmentSCT === 1
                        ? "DKRd (TE)"
                        : item.cohortTreatmentSCT === 2
                          ? "DKRd (TIE)"
                          : item.cohortTreatmentName
                      : item.cohortTreatmentName,
                  cohortIndexDate: item.earliestCohortIndexDate,
                  cohortTreatmentNameSuperscript:
                    item.cohortTreatmentNameSuperscript || null,
                  showQ51_52,
                  lotNum,
                  bispecificEOF: cohortTreatment.bispecificEOF || "",
                  bispecificEOFLabel: cohortTreatment.bispecificEOFLabel || "",
                  bispecificNextLOTStartDate:
                    cohortTreatment.bispecificNextLOTStartDate || "",
                };
              });

              if (
                data.cohortLotNumberListNDMM &&
                data.cohortLotNumberListNDMM.length > 0
              ) {
                data.cohortLotNumberListNDMM.forEach((item) => {
                  if (item.lotnumberid === 2 && item.notReceived === false) {
                    setShowQ47_48(true);
                  }
                  if (item.lotnumberid === 3 && item.notReceived === false) {
                    setShowQ49_50(true);
                  }
                });
              }

              setTmtResponseProgression(repeaterData);
            }
          }
        } else if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    } finally {
      ToggleLoader(false);
    }
  };

  const SetNavPaths = () => {
    const storedData = GetLocalStorageData("CohortTreatment");
    let cohortTreatmentModelListt = [];
    let newPaths = { ...navigatePaths };

    if (storedData) {
      cohortTreatmentModelListt = JSON.parse(storedData);
    }

    let eligibleCohorts = cohortTreatmentModelListt.filter(
      (c) => c.isEligible === true,
    );

    let rrmmCohorts = eligibleCohorts.filter((c) => !c.ndmm);

    if (rrmmCohorts.length > 0) {
      newPaths.nextPage = "/AdverseEvents";
    } else {
      newPaths.nextPage = "/AEReporting";
    }
    setNavigatePaths(newPaths);
  };

  const SavePage = async (validate) => {
    try {
      ToggleLoader(true);

      let isValid = validate ? ValidateForm() : true;

      if (isValid) {
        setShowTopErrMsg(false);

        // Prepare TreatmentResponseData
        const TreatmentResponseData = tmtResponseProgression.flatMap((row) => {
          const matchingItem = treatmentlist.find(
            (item) => item.cohortTreatmentID === row.cohorttreatmentid,
          );
          return [
            // Question 44-45
            {
              Treatmentresponseprogressionid:
                row.treatmentresponseprogressionid1 || 0,
              Lineoftreatmentid:
                matchingItem.ndmm === true ? 1 : matchingItem.lineOfTherapy, //1, // Set specific line of treatment id for 44-45
              Cohorttreatmentid: row.cohorttreatmentid,
              Ndmm: true,
              // Question 44
              ProgressionDidnotoccur:
                row.Q44dateOfProgressionRd === 1 ? true : null,
              ProgressionDate:
                row.Q44dateOfProgression_dt &&
                row.Q44dateOfProgression_dt !== "Invalid Date"
                  ? row.Q44dateOfProgression_dt
                  : "",
              ProgressionDateUnk:
                row.Q44dateOfProgressionRd === 99 ? true : null,

              ProgressionReasonSerum: row.Q44serum,
              ProgressionReasonUrinary: row.Q44uninary,
              ProgressionReasonFreelight: row.Q44freelight,
              ProgressionReasonPlasmacell: row.Q44plasma,
              ProgressionReasonIncreasesizeBone: row.Q44bonelesion,
              ProgressionReasonIncreasesizePlasmacytomas: row.Q44plasmacytomas,
              ProgressionReasonOth: row.Q44ReasonOfProgression_oth,
              ProgressionReasonOthTxt: row.Q44ReasonOfProgression_txt,

              ProgressionReasonUnk:
                row.Q44ReasonOfProgression === 99 ? true : null,
              Assessmentmethodid: row.Q44assessmentMethodRd,

              // Question 45
              FirstTreatmentresponseStatus: row.Q45FR_tmtResponseStatus,
              FirstResponseAssessmentDate:
                row.Q45FR_dateOfResponse_assess_dt &&
                row.Q45FR_dateOfResponse_assess_dt !== "Invalid Date"
                  ? row.Q45FR_dateOfResponse_assess_dt
                  : "",

              FirstResponseAssessmentDateUnk:
                row.Q45FR_dateOfResponse_assessRd === 99 ? true : null,

              FirstAssessmentmethodid: row.Q45FR_assessmentMethodRd,
              BestTreatmentresponseStatus: row.Q45BR_tmtResponseStatus,

              BestResponseAssessmentDate:
                row.Q45BR_dateOfResponse_assess_dt &&
                row.Q45BR_dateOfResponse_assess_dt !== "Invalid Date"
                  ? row.Q45BR_dateOfResponse_assess_dt
                  : "",

              BestResponseAssessmentDateUnk:
                row.Q45BR_dateOfResponse_assessRd === 99 ? true : null,
              BestAssessmentmethodid: row.Q45BR_assessmentMethodRd,
            },
            // Question 47-48
            {
              Treatmentresponseprogressionid:
                row.treatmentresponseprogressionid2 || 0,
              Lineoftreatmentid: 2, // Set specific line of treatment id for 47-48
              Cohorttreatmentid: row.cohorttreatmentid,
              Ndmm: matchingItem.ndmm === true ? true : false,
              // Question 47
              ProgressionDidnotoccur:
                row.Q47dateOfProgressionRd === 1 ? true : null,
              ProgressionDate:
                row.Q47dateOfProgression_dt &&
                row.Q47dateOfProgression_dt !== "Invalid Date"
                  ? row.Q47dateOfProgression_dt
                  : "",
              ProgressionDateUnk:
                row.Q47dateOfProgressionRd === 99 ? true : null,
              ProgressionReasonSerum: row.Q47serum,
              ProgressionReasonUrinary: row.Q47uninary,
              ProgressionReasonFreelight: row.Q47freelight,
              ProgressionReasonPlasmacell: row.Q47plasma,
              ProgressionReasonIncreasesizeBone: row.Q47bonelesion,
              ProgressionReasonIncreasesizePlasmacytomas: row.Q47plasmacytomas,
              ProgressionReasonOth: row.Q47ReasonOfProgression_oth,
              ProgressionReasonOthTxt: row.Q47ReasonOfProgression_txt,
              ProgressionReasonUnk:
                row.Q47ReasonOfProgression === 99 ? true : null,
              Assessmentmethodid: row.Q47assessmentMethodRd,

              // Question 48
              FirstTreatmentresponseStatus: row.Q48FR_tmtResponseStatus,
              FirstResponseAssessmentDate:
                row.Q48FR_dateOfResponse_assess_dt &&
                row.Q48FR_dateOfResponse_assess_dt !== "Invalid Date"
                  ? row.Q48FR_dateOfResponse_assess_dt
                  : "",
              FirstResponseAssessmentDateUnk:
                row.Q48FR_dateOfResponse_assessRd === 99 ? true : null,
              FirstAssessmentmethodid: row.Q48FR_assessmentMethodRd,
              BestTreatmentresponseStatus: row.Q48BR_tmtResponseStatus,
              BestResponseAssessmentDate:
                row.Q48BR_dateOfResponse_assess_dt &&
                row.Q48BR_dateOfResponse_assess_dt !== "Invalid Date"
                  ? row.Q48BR_dateOfResponse_assess_dt
                  : "",
              BestResponseAssessmentDateUnk:
                row.Q48BR_dateOfResponse_assessRd === 99 ? true : null,
              BestAssessmentmethodid: row.Q48BR_assessmentMethodRd,
            },
            // Question 49-50
            {
              Treatmentresponseprogressionid:
                row.treatmentresponseprogressionid3 || 0,
              Lineoftreatmentid: 3, // Set specific line of treatment id for 49-50
              Cohorttreatmentid: row.cohorttreatmentid,
              Ndmm: matchingItem.ndmm === true ? true : false,
              // Question 49
              ProgressionDidnotoccur:
                row.Q49dateOfProgressionRd === 1 ? true : null,
              ProgressionDate:
                row.Q49dateOfProgression_dt &&
                row.Q49dateOfProgression_dt !== "Invalid Date"
                  ? row.Q49dateOfProgression_dt
                  : "",
              ProgressionDateUnk:
                row.Q49dateOfProgressionRd === 99 ? true : null,
              ProgressionReasonSerum: row.Q49serum || false,
              ProgressionReasonUrinary: row.Q49uninary || false,
              ProgressionReasonFreelight: row.Q49freelight || false,
              ProgressionReasonPlasmacell: row.Q49plasma || false,
              ProgressionReasonIncreasesizeBone: row.Q49bonelesion || false,
              ProgressionReasonIncreasesizePlasmacytomas:
                row.Q49plasmacytomas || false,
              ProgressionReasonOth: row.Q49ReasonOfProgression_oth || false,
              ProgressionReasonOthTxt: row.Q49ReasonOfProgression_txt || null,
              ProgressionReasonUnk:
                row.Q49ReasonOfProgression === 99 ? true : null,
              Assessmentmethodid: row.Q49assessmentMethodRd,

              // Question 50
              FirstTreatmentresponseStatus: row.Q50FR_tmtResponseStatus || null,
              FirstResponseAssessmentDate:
                row.Q50FR_dateOfResponse_assess_dt &&
                row.Q50FR_dateOfResponse_assess_dt !== "Invalid Date"
                  ? row.Q50FR_dateOfResponse_assess_dt
                  : "",
              FirstResponseAssessmentDateUnk:
                row.Q50FR_dateOfResponse_assessRd === 99 ? true : null,
              FirstAssessmentmethodid: row.Q50FR_assessmentMethodRd || null,
              BestTreatmentresponseStatus: row.Q50BR_tmtResponseStatus || null,
              BestResponseAssessmentDate:
                row.Q50BR_dateOfResponse_assess_dt &&
                row.Q50BR_dateOfResponse_assess_dt !== "Invalid Date"
                  ? row.Q50BR_dateOfResponse_assess_dt
                  : "",
              BestResponseAssessmentDateUnk:
                row.Q50BR_dateOfResponse_assessRd === 99 ? true : null,
              BestAssessmentmethodid: row.Q50BR_assessmentMethodRd || null,
            },
            // Question 51-52
            {
              Treatmentresponseprogressionid:
                row.treatmentresponseprogressionid4 || 0,
              Lineoftreatmentid: row.showQ51_52 === true ? row.lotNum : 4, //4, // Set specific line of treatment id for 51-52
              Cohorttreatmentid: row.cohorttreatmentid,
              Ndmm: row.showQ51_52 === true ? true : false,
              // Question 51
              ProgressionDidnotoccur:
                row.Q51dateOfProgressionRd === 1 ? true : null,
              ProgressionDate:
                row.Q51dateOfProgression_dt &&
                row.Q51dateOfProgression_dt !== "Invalid Date"
                  ? row.Q51dateOfProgression_dt
                  : "",
              ProgressionDateUnk:
                row.Q51dateOfProgressionRd === 99 ? true : null,
              ProgressionReasonSerum: row.Q51serum,
              ProgressionReasonUrinary: row.Q51uninary,
              ProgressionReasonFreelight: row.Q51freelight,
              ProgressionReasonPlasmacell: row.Q51plasma,
              ProgressionReasonIncreasesizeBone: row.Q51bonelesion,
              ProgressionReasonIncreasesizePlasmacytomas: row.Q51plasmacytomas,
              ProgressionReasonOth: row.Q51ReasonOfProgression_oth,
              ProgressionReasonOthTxt: row.Q51ReasonOfProgression_txt,
              ProgressionReasonUnk:
                row.Q51ReasonOfProgression === 99 ? true : null,
              Assessmentmethodid: row.Q51assessmentMethodRd,

              // Question 52
              FirstTreatmentresponseStatus: row.Q52FR_tmtResponseStatus,
              FirstResponseAssessmentDate:
                row.Q52FR_dateOfResponse_assess_dt &&
                row.Q52FR_dateOfResponse_assess_dt !== "Invalid Date"
                  ? row.Q52FR_dateOfResponse_assess_dt
                  : "",
              FirstResponseAssessmentDateUnk:
                row.Q52FR_dateOfResponse_assessRd === 99 ? true : null,
              FirstAssessmentmethodid: row.Q52FR_assessmentMethodRd,
              BestTreatmentresponseStatus: row.Q52BR_tmtResponseStatus,
              BestResponseAssessmentDate:
                row.Q52BR_dateOfResponse_assess_dt &&
                row.Q52BR_dateOfResponse_assess_dt !== "Invalid Date"
                  ? row.Q52BR_dateOfResponse_assess_dt
                  : "",
              BestResponseAssessmentDateUnk:
                row.Q52BR_dateOfResponse_assessRd === 99 ? true : null,
              BestAssessmentmethodid: row.Q52BR_assessmentMethodRd,
              IsVisibleQ51_Q52: row.showQ51_52,
            },
          ];
        });

        // TmtResponseRptData

        const TmtResponseRptData = tmtResponseProgression.flatMap((row) => {
          const matchingItem = treatmentlist.find(
            (item) => item.cohortTreatmentID === row.cohorttreatmentid,
          );

          return row.q46Row.map((assessment) => ({
            Lineoftreatmentid:
              matchingItem.ndmm === true ? 1 : matchingItem.lineOfTherapy, // Set specific line of treatment id for 51-52
            Treatmentmrdassessmentbridgeid:
              assessment.treatmentmrdassessmentbridgeid,
            Cohorttreatmentid: row.cohorttreatmentid,

            // DateOfAssessment: assessment.Q46dateofassessment_dt ,
            MrdNotAssessed:
              assessment.Q46dateofassessmentRd === 1 ? true : null,
            MrdAssessesDate:
              assessment.Q46dateofassessment_dt &&
              assessment.Q46dateofassessment_dt !== "Invalid Date"
                ? assessment.Q46dateofassessment_dt
                : "",
            MrdAssessesDateUnk:
              assessment.Q46dateofassessmentRd === 99 ? true : null,

            MrdAssessmentmethod: assessment.Q46assessmentmethodRd,
            MrdAssessmentSensitivity: assessment.Q46sensitivityRd,
            MrdStatus: assessment.Q46mrdstatusRd,
          }));
        });

        const TreatmentResponseModel = {
          Patientid: pid,
          UserId: GetLoggedInUserID(),
          isValidated: validate,
          IsAdmin: IsAdmin(),
          TmtResponseRptData: TmtResponseRptData,
          TreatmentResponseData: TreatmentResponseData,

          IsVisibleQ47_Q48: showQ47_48,
          IsVisibleQ49_Q50: showQ49_50,
        };

        if (pid > 0) {
          let response = await ClinicalOutcomes.SaveTreatmentResponseData(
            TreatmentResponseModel,
          );

          if (response.status !== HTTPResponse.OK) {
            if (response?.status === HTTPResponse.Unauthorized) {
              HandleSessionTimeout();
            } else throw response.error;
          } else {
            ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
            await LoadData(pid);
          }

          ToggleLoader(false);
        }
        return true;
      } else {
        ToggleLoader(false);
        setShowTopErrMsg(true);
        return false;
      }
    } catch (error) {
      ToggleLoader(false);
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  function ValidateTreatmentResponseProgressionDate(
    indexDate,
    progressionDate,
    nextLOTDate,
    eofDate,
  ) {
    const index =
      !isStringEmpty(indexDate) && IsDateValid(indexDate) ? indexDate : null;
    const progress =
      !isStringEmpty(progressionDate) && IsDateValid(progressionDate)
        ? progressionDate
        : null;

    if (!progress) return true;

    if (index && !IsLessOrEqual(index, progress)) return false;

    const eof =
      !isStringEmpty(eofDate) && IsDateValid(eofDate) ? eofDate : null;
    const lot =
      !isStringEmpty(nextLOTDate) && IsDateValid(nextLOTDate)
        ? nextLOTDate
        : null;

    if (lot && !IsLessOrEqual(progress, lot)) return false;

    if (eof && !IsLessOrEqual(progress, eof)) return false;

    return true;
  }

  const ValidateForm = () => {
    let isValid = true;
    if (tmtResponseProgression && tmtResponseProgression.length > 0) {
      const updatedArray = tmtResponseProgression.map((item, index) => {
        let eofDate = endOfFollowUpDate;
        const nextLotStartDateQ44_Q46 =
          cohortNextLotDatesList
            ?.get(item.cohorttreatmentid)
            ?.get(TRPQuestionType.Q44_46) ?? "";

        //Q44
        let Q44EmptyError = item.Q44dateOfProgressionRd == null;

        let Q44dateOfProgression_dtEmpty = false;
        let Invalid_dateofProgression_dt = false;

        let Q44DateValidationError = false;

        let Q44ReasonOfProgressionEmpty = false;
        let Q44ReasonOfProgressionTxtEmpty = false;
        let Q44assessmentMethodEmpty = false;

        if (!Q44EmptyError) {
          if (item.Q44dateOfProgressionRd === 2) {
            if (isStringEmpty(item.Q44dateOfProgression_dt)) {
              Q44dateOfProgression_dtEmpty = true;
            } else if (!IsDateValid(item.Q44dateOfProgression_dt)) {
              Invalid_dateofProgression_dt = true;
            } else if (!isStringEmpty(item.cohortIndexDate)) {
              Q44DateValidationError =
                !ValidateTreatmentResponseProgressionDate(
                  item.cohortIndexDate,
                  item.Q44dateOfProgression_dt,
                  nextLotStartDateQ44_Q46,
                  eofDate,
                );
            }
          }

          if (
            item.Q44dateOfProgressionRd === 2 ||
            item.Q44dateOfProgressionRd === 99
          ) {
            if (
              item.Q44serum === false &&
              item.Q44uninary === false &&
              item.Q44freelight === false &&
              item.Q44plasma === false &&
              item.Q44bonelesion === false &&
              item.Q44plasmacytomas === false &&
              item.Q44ReasonOfProgression_oth === false &&
              item.Q44ReasonOfProgression == null
            ) {
              Q44ReasonOfProgressionEmpty = true;
            } else if (
              item.Q44ReasonOfProgression_oth === true &&
              item.Q44ReasonOfProgression_txt === ""
            ) {
              Q44ReasonOfProgressionTxtEmpty = true;
            }

            Q44assessmentMethodEmpty = item.Q44assessmentMethodRd == null;
          }
        }

        //Q45
        let Q45FR_tmtResponseStatusEmpty = item.Q45FR_tmtResponseStatus == null;

        let Q45FR_dateOfResponse_assessEmpty = false;

        let Q45FR_dateOfResponse_assess_dtEmpty = false;
        let Invalid_dateofResponse_assess_dt = false;

        let Q45FR_assessmentMethodEmpty = false;
        let Q45FRDateValidationError = false;

        // First Response
        if (
          item.Q45FR_tmtResponseStatus !== 5 &&
          item.Q45FR_tmtResponseStatus !== 8 &&
          item.Q45FR_tmtResponseStatus !== 9
        ) {
          //C
          Q45FR_dateOfResponse_assessEmpty =
            item.Q45FR_dateOfResponse_assessRd == null;

          if (!Q45FR_dateOfResponse_assessEmpty) {
            if (item.Q45FR_dateOfResponse_assessRd === 1) {
              if (isStringEmpty(item.Q45FR_dateOfResponse_assess_dt)) {
                Q45FR_dateOfResponse_assess_dtEmpty = true;
              } else if (!IsDateValid(item.Q45FR_dateOfResponse_assess_dt)) {
                Invalid_dateofResponse_assess_dt = true;
              } else if (!isStringEmpty(item.cohortIndexDate)) {
                Q45FRDateValidationError =
                  !ValidateTreatmentResponseProgressionDate(
                    item.cohortIndexDate,
                    item.Q45FR_dateOfResponse_assess_dt,
                    nextLotStartDateQ44_Q46,
                    eofDate,
                  );
              }
            }
          }
          //D
          Q45FR_assessmentMethodEmpty = item.Q45FR_assessmentMethodRd == null;
        }

        //Best Response
        let Q45BR_tmtResponseStatusEmpty = item.Q45BR_tmtResponseStatus == null;

        let Q45BR_dateOfResponse_assessEmpty = false;
        let Q45BR_dateOfResponse_assess_dtEmpty = false;
        let Invalid_BR_dateOfResponse_assess_dt = false;
        let Q45BR_assessmentMethodEmpty = false;
        let Q45BRDateValidationError = false;

        if (
          item.Q45BR_tmtResponseStatus !== 8 &&
          item.Q45BR_tmtResponseStatus !== 9
        ) {
          //C
          Q45BR_dateOfResponse_assessEmpty =
            item.Q45BR_dateOfResponse_assessRd == null;

          //C - Date
          if (item.Q45BR_dateOfResponse_assessRd === 1) {
            if (isStringEmpty(item.Q45BR_dateOfResponse_assess_dt)) {
              Q45BR_dateOfResponse_assess_dtEmpty = true;
            } else if (!IsDateValid(item.Q45BR_dateOfResponse_assess_dt)) {
              Invalid_BR_dateOfResponse_assess_dt = true;
            } else if (!isStringEmpty(item.cohortIndexDate)) {
              Q45BRDateValidationError =
                !ValidateTreatmentResponseProgressionDate(
                  item.cohortIndexDate,
                  item.Q45BR_dateOfResponse_assess_dt,
                  nextLotStartDateQ44_Q46,
                  eofDate,
                );
            }
          }

          //D
          Q45BR_assessmentMethodEmpty = item.Q45BR_assessmentMethodRd == null;
        }

        const nextLotStartDateQ47_Q48 =
          cohortNextLotDatesList
            ?.get(item.cohorttreatmentid)
            ?.get(TRPQuestionType.Q47_48) ?? "";

        //47
        let Q47dateOfProgressionEmpty = false;
        let Q47dateOfProgression_dtEmpty = false;
        let Invalid_Q47dateOfProgression_dt = false;
        let Q47DateValidationError = false;

        let Q47ReasonOfProgressionEmpty = false;
        let Q47ReasonOfProgressionTxtEmpty = false;
        let Q47assessmentMethodEmpty = false;

        if (showQ47_48 === true && item.cohorttreatmentid < 9) {
          Q47dateOfProgressionEmpty = item.Q47dateOfProgressionRd == null;

          if (!Q47dateOfProgressionEmpty) {
            if (item.Q47dateOfProgressionRd === 2) {
              if (isStringEmpty(item.Q47dateOfProgression_dt)) {
                Q47dateOfProgression_dtEmpty = true;
              } else if (!IsDateValid(item.Q47dateOfProgression_dt)) {
                Invalid_Q47dateOfProgression_dt = true;
              } else if (!isStringEmpty(item.cohortIndexDate)) {
                Q47DateValidationError =
                  !ValidateTreatmentResponseProgressionDate(
                    !isStringEmpty(ndmmSecondLotStartDate)
                      ? ndmmSecondLotStartDate
                      : item.cohortIndexDate,
                    item.Q47dateOfProgression_dt,
                    nextLotStartDateQ47_Q48,
                    eofDate,
                  );
              }
            }

            if (
              item.Q47dateOfProgressionRd === 2 ||
              item.Q47dateOfProgressionRd === 99
            ) {
              if (
                item.Q47serum === false &&
                item.Q47uninary === false &&
                item.Q47freelight === false &&
                item.Q47plasma === false &&
                item.Q47bonelesion === false &&
                item.Q47plasmacytomas === false &&
                item.Q47ReasonOfProgression_oth === false &&
                item.Q47ReasonOfProgression == null
              ) {
                Q47ReasonOfProgressionEmpty = true;
              }
              if (
                !Q47ReasonOfProgressionEmpty &&
                item.Q47ReasonOfProgression_oth === true &&
                isStringEmpty(item.Q47ReasonOfProgression_txt)
              ) {
                Q47ReasonOfProgressionTxtEmpty = true;
              }

              Q47assessmentMethodEmpty = item.Q47assessmentMethodRd == null;
            }
          }
        }

        //48
        let Q48FR_tmtResponseStatusEmpty = false;
        let Q48FR_dateOfResponse_assessEmpty = false;
        let Q48FR_dateOfResponse_assess_dtEmpty = false;
        let Invalid_Q48FR_dateOfResponse_assess_dt = false;
        let Q48FR_assessmentMethodEmpty = false;
        let Q48FRDateValidation = false;

        let Q48BR_tmtResponseStatusEmpty = false;
        let Q48BR_dateOfResponse_assessEmpty = false;
        let Q48BR_dateOfResponse_assess_dtEmpty = false;
        let Invalid_Q48BR_dateOfResponse_assess_dt = false;
        let Q48BR_assessmentMethodEmpty = false;

        let Q48BRDateValidation = false;

        if (showQ47_48 === true && item.cohorttreatmentid < 9) {
          //FR
          Q48FR_tmtResponseStatusEmpty = item.Q48FR_tmtResponseStatus == null;
          if (
            item.Q48FR_tmtResponseStatus !== 5 &&
            item.Q48FR_tmtResponseStatus !== 8 &&
            item.Q48FR_tmtResponseStatus !== 9
          ) {
            Q48FR_dateOfResponse_assessEmpty =
              item.Q48FR_dateOfResponse_assessRd == null;

            if (
              item.Q48FR_dateOfResponse_assessRd === 1 &&
              !Q48FR_dateOfResponse_assessEmpty
            ) {
              if (isStringEmpty(item.Q48FR_dateOfResponse_assess_dt)) {
                Q48FR_dateOfResponse_assess_dtEmpty = true;
              } else if (!IsDateValid(item.Q48FR_dateOfResponse_assess_dt)) {
                Invalid_Q48FR_dateOfResponse_assess_dt = true;
              } else if (!isStringEmpty(item.cohortIndexDate)) {
                Q48FRDateValidation = !ValidateTreatmentResponseProgressionDate(
                  !isStringEmpty(ndmmSecondLotStartDate)
                    ? ndmmSecondLotStartDate
                    : item.cohortIndexDate,
                  item.Q48FR_dateOfResponse_assess_dt,
                  nextLotStartDateQ47_Q48,
                  eofDate,
                );
              }
            }

            Q48FR_assessmentMethodEmpty = item.Q48FR_assessmentMethodRd == null;
          }

          //BR
          Q48BR_tmtResponseStatusEmpty = item.Q48BR_tmtResponseStatus == null;

          if (
            item.Q48BR_tmtResponseStatus !== 8 &&
            item.Q48BR_tmtResponseStatus !== 9
          ) {
            Q48BR_dateOfResponse_assessEmpty =
              item.Q48BR_dateOfResponse_assessRd == null;

            if (
              !Q48BR_dateOfResponse_assessEmpty &&
              item.Q48BR_dateOfResponse_assessRd === 1
            ) {
              if (isStringEmpty(item.Q48BR_dateOfResponse_assess_dt)) {
                Q48BR_dateOfResponse_assess_dtEmpty = true;
              } else if (!IsDateValid(item.Q48BR_dateOfResponse_assess_dt)) {
                Invalid_Q48BR_dateOfResponse_assess_dt = true;
              } else if (!isStringEmpty(item.cohortIndexDate)) {
                Q48BRDateValidation = !ValidateTreatmentResponseProgressionDate(
                  !isStringEmpty(ndmmSecondLotStartDate)
                    ? ndmmSecondLotStartDate
                    : item.cohortIndexDate,
                  item.Q48BR_dateOfResponse_assess_dt,
                  nextLotStartDateQ47_Q48,
                  eofDate,
                );
              }
            }

            Q48BR_assessmentMethodEmpty = item.Q48BR_assessmentMethodRd == null;
          }
        }

        const nextLotStartDateQ49_Q50 =
          cohortNextLotDatesList
            ?.get(item.cohorttreatmentid)
            ?.get(TRPQuestionType.Q49_50) ?? "";

        //Q49
        let Q49dateOfProgressionEmpty = false;
        let Q49dateOfProgression_dtEmpty = false;
        let Invalid_Q49dateOfProgression_dt = false;
        let Q49DateValidation = false;
        let Q49ReasonOfProgressionEmpty = false;
        let Q49ReasonOfProgressionTxtEmpty = false;
        let Q49assessmentMethodEmpty = false;

        if (showQ49_50 === true && item.cohorttreatmentid < 9) {
          Q49dateOfProgressionEmpty = item.Q49dateOfProgressionRd == null;

          if (!Q49dateOfProgressionEmpty) {
            if (item.Q49dateOfProgressionRd === 2) {
              if (isStringEmpty(item.Q49dateOfProgression_dt)) {
                Q49dateOfProgression_dtEmpty = true;
              } else if (!IsDateValid(item.Q49dateOfProgression_dt)) {
                Invalid_Q49dateOfProgression_dt = true;
              } else if (!isStringEmpty(item.cohortIndexDate)) {
                Q49DateValidation = !ValidateTreatmentResponseProgressionDate(
                  !isStringEmpty(ndmmThirdLotStartDate)
                    ? ndmmThirdLotStartDate
                    : item.cohortIndexDate,
                  item.Q49dateOfProgression_dt,
                  nextLotStartDateQ49_Q50,
                  eofDate,
                );
              }
            }

            if (
              item.Q49dateOfProgressionRd === 2 ||
              item.Q49dateOfProgressionRd === 99
            ) {
              if (
                item.Q49serum === false &&
                item.Q49uninary === false &&
                item.Q49freelight === false &&
                item.Q49plasma === false &&
                item.Q49bonelesion === false &&
                item.Q49plasmacytomas === false &&
                item.Q49ReasonOfProgression_oth === false &&
                item.Q49ReasonOfProgression == null
              ) {
                Q49ReasonOfProgressionEmpty = true;
              } else if (
                item.Q49ReasonOfProgression_oth === true &&
                item.Q49ReasonOfProgression_txt === ""
              ) {
                Q49ReasonOfProgressionTxtEmpty = true;
              }

              Q49assessmentMethodEmpty = item.Q49assessmentMethodRd == null;
            }
          }
        }

        //50
        let Q50FR_tmtResponseStatusEmpty = false;
        let Q50FR_dateOfResponse_assessEmpty = false;
        let Q50FR_dateOfResponse_assess_dtEmpty = false;
        let Invalid_Q50FR_dateOfResponse_assess_dt = false;
        let Q50FR_assessmentMethodEmpty = false;
        let Q50FRDateValidation = false;

        let Q50BR_tmtResponseStatusEmpty = false;
        let Q50BR_dateOfResponse_assessEmpty = false;
        let Q50BR_dateOfResponse_assess_dtEmpty = false;
        let Invalid_Q50BR_dateOfResponse_assess_dt = false;
        let Q50BR_assessmentMethodEmpty = false;
        let Q50BRDateValidation = false;

        if (showQ49_50 === true && item.cohorttreatmentid < 9) {
          Q50FR_tmtResponseStatusEmpty = item.Q50FR_tmtResponseStatus == null;

          if (
            item.Q50FR_tmtResponseStatus !== 5 &&
            item.Q50FR_tmtResponseStatus !== 8 &&
            item.Q50FR_tmtResponseStatus !== 9
          ) {
            Q50FR_dateOfResponse_assessEmpty =
              item.Q50FR_dateOfResponse_assessRd == null;

            if (item.Q50FR_dateOfResponse_assessRd === 1) {
              if (isStringEmpty(item.Q50FR_dateOfResponse_assess_dt)) {
                Q50FR_dateOfResponse_assess_dtEmpty = true;
              } else if (!IsDateValid(item.Q50FR_dateOfResponse_assess_dt)) {
                Invalid_Q50FR_dateOfResponse_assess_dt = true;
              } else if (!isStringEmpty(item.cohortIndexDate)) {
                Q50FRDateValidation = !ValidateTreatmentResponseProgressionDate(
                  !isStringEmpty(ndmmThirdLotStartDate)
                    ? ndmmThirdLotStartDate
                    : item.cohortIndexDate,
                  item.Q50FR_dateOfResponse_assess_dt,
                  nextLotStartDateQ49_Q50,
                  eofDate,
                );
              }
            }

            Q50FR_assessmentMethodEmpty = item.Q50FR_assessmentMethodRd == null;
          }

          //BR
          Q50BR_tmtResponseStatusEmpty = item.Q50BR_tmtResponseStatus == null;

          if (
            item.Q50BR_tmtResponseStatus !== 8 &&
            item.Q50BR_tmtResponseStatus !== 9
          ) {
            Q50BR_dateOfResponse_assessEmpty =
              item.Q50BR_dateOfResponse_assessRd == null;

            if (item.Q50BR_dateOfResponse_assessRd === 1) {
              if (isStringEmpty(item.Q50BR_dateOfResponse_assess_dt)) {
                Q50BR_dateOfResponse_assess_dtEmpty = true;
              } else if (!IsDateValid(item.Q50BR_dateOfResponse_assess_dt)) {
                Invalid_Q50BR_dateOfResponse_assess_dt = true;
              } else if (!isStringEmpty(item.cohortIndexDate)) {
                Q50BRDateValidation = !ValidateTreatmentResponseProgressionDate(
                  !isStringEmpty(ndmmThirdLotStartDate)
                    ? ndmmThirdLotStartDate
                    : item.cohortIndexDate,
                  item.Q50BR_dateOfResponse_assess_dt,
                  nextLotStartDateQ49_Q50,
                  eofDate,
                );
              }
            }

            Q50BR_assessmentMethodEmpty = item.Q50BR_assessmentMethodRd == null;
          }
        }

        //Q51

        const nextLotStartDateQ51_Q52 =
          cohortNextLotDatesList
            ?.get(item.cohorttreatmentid)
            ?.get(TRPQuestionType.Q51_52) ?? "";

        let Q51dateOfProgressionEmpty = false;
        let Q51dateOfProgression_dtEmpty = false;
        let Invalid_Q51dateOfProgression_dt = false;
        let Q51DateValidation = false;
        let Q51ReasonOfProgressionEmpty = false;
        let Q51ReasonOfProgressionTxtEmpty = false;
        let Q51assessmentMethodEmpty = false;

        if (item.cohorttreatmentid >= 9 && item.showQ51_52 === true) {
          Q51dateOfProgressionEmpty = item.Q51dateOfProgressionRd == null;
          if (!Q51dateOfProgressionEmpty) {
            if (item.Q51dateOfProgressionRd === 2) {
              if (isStringEmpty(item.Q51dateOfProgression_dt)) {
                Q51dateOfProgression_dtEmpty = true;
              } else if (!IsDateValid(item.Q51dateOfProgression_dt)) {
                Invalid_Q51dateOfProgression_dt = true;
              } else if (!isStringEmpty(item.cohortIndexDate)) {
                Q51DateValidation = !ValidateTreatmentResponseProgressionDate(
                  !isStringEmpty(item.bispecificNextLOTStartDate)
                    ? item.bispecificNextLOTStartDate
                    : item.cohortIndexDate,
                  item.Q51dateOfProgression_dt,
                  nextLotStartDateQ51_Q52,
                  eofDate,
                );
              }
            }

            if (
              item.Q51ConditionMet &&
              (item.Q51dateOfProgressionRd === 2 ||
                item.Q51dateOfProgressionRd === 99)
            ) {
              if (
                item.Q51serum === false &&
                item.Q51uninary === false &&
                item.Q51freelight === false &&
                item.Q51plasma === false &&
                item.Q51bonelesion === false &&
                item.Q51plasmacytomas === false &&
                item.Q51ReasonOfProgression_oth === false &&
                item.Q51ReasonOfProgression == null
              ) {
                Q51ReasonOfProgressionEmpty = true;
              } else if (isStringEmpty(item.Q51ReasonOfProgression_txt)) {
                Q51ReasonOfProgressionTxtEmpty = true;
              }

              Q51assessmentMethodEmpty = item.Q51assessmentMethodRd == null;
            }
          }
        }

        //Q52
        let Q52FR_tmtResponseStatusEmpty = false;
        let Q52FR_dateOfResponse_assessEmpty = false;
        let Q52FR_dateOfResponse_assess_dtEmpty = false;
        let Invalid_Q52FR_dateOfResponse_assess_dt = false;
        let Q52FR_assessmentMethodEmpty = false;
        let Q52FRDateValidation = false;

        let Q52BR_tmtResponseStatusEmpty = false;
        let Q52BR_dateOfResponse_assessEmpty = false;
        let Q52BR_dateOfResponse_assess_dtEmpty = false;
        let Invalid_Q52BR_dateOfResponse_assess_dt = false;
        let Q52BR_assessmentMethodEmpty = false;
        let Q52BRDateValidation = false;

        if (item.cohorttreatmentid >= 9 && item.showQ51_52 === true) {
          Q52FR_tmtResponseStatusEmpty = item.Q52FR_tmtResponseStatus == null;

          if (
            item.Q52FR_tmtResponseStatus !== 5 &&
            item.Q52FR_tmtResponseStatus !== 8 &&
            item.Q52FR_tmtResponseStatus !== 9
          ) {
            Q52FR_dateOfResponse_assessEmpty =
              item.Q52FR_dateOfResponse_assessRd == null;

            if (item.Q52FR_dateOfResponse_assessRd === 1) {
              if (isStringEmpty(item.Q52FR_dateOfResponse_assess_dt)) {
                Q52FR_dateOfResponse_assess_dtEmpty = true;
              } else if (!IsDateValid(item.Q52FR_dateOfResponse_assess_dt)) {
                Invalid_Q52FR_dateOfResponse_assess_dt = true;
              } else if (!isStringEmpty(item.cohortIndexDate)) {
                Q52FRDateValidation = !ValidateTreatmentResponseProgressionDate(
                  !isStringEmpty(item.bispecificNextLOTStartDate)
                    ? item.bispecificNextLOTStartDate
                    : item.cohortIndexDate,
                  item.Q52FR_dateOfResponse_assess_dt,
                  nextLotStartDateQ51_Q52,
                  eofDate,
                );
              }
            }
            Q52FR_assessmentMethodEmpty = item.Q52FR_assessmentMethodRd == null;
          }

          //BR
          Q52BR_tmtResponseStatusEmpty = item.Q52BR_tmtResponseStatus == null;

          if (
            item.Q52BR_tmtResponseStatus !== 8 &&
            item.Q52BR_tmtResponseStatus !== 9
          ) {
            Q52BR_dateOfResponse_assessEmpty =
              item.Q52BR_dateOfResponse_assessRd == null;

            if (item.Q52BR_dateOfResponse_assessRd === 1) {
              if (isStringEmpty(item.Q52BR_dateOfResponse_assess_dt)) {
                Q52BR_dateOfResponse_assess_dtEmpty = true;
              } else if (!IsDateValid(item.Q52BR_dateOfResponse_assess_dt)) {
                Invalid_Q52BR_dateOfResponse_assess_dt = true;
              } else if (!isStringEmpty(item.cohortIndexDate)) {
                Q52BRDateValidation = !ValidateTreatmentResponseProgressionDate(
                  !isStringEmpty(item.bispecificNextLOTStartDate)
                    ? item.bispecificNextLOTStartDate
                    : item.cohortIndexDate,
                  item.Q52BR_dateOfResponse_assess_dt,
                  nextLotStartDateQ51_Q52,
                  eofDate,
                );
              }
            }
            Q52BR_assessmentMethodEmpty = item.Q52BR_assessmentMethodRd == null;
          }
        }

        if (
          Q44EmptyError ||
          Invalid_dateofProgression_dt ||
          Q44dateOfProgression_dtEmpty ||
          Q44ReasonOfProgressionEmpty ||
          Q44ReasonOfProgressionTxtEmpty ||
          Q44assessmentMethodEmpty ||
          Q45FR_tmtResponseStatusEmpty ||
          Q45FR_dateOfResponse_assessEmpty ||
          Q45FR_dateOfResponse_assess_dtEmpty ||
          Invalid_dateofResponse_assess_dt ||
          Q45FR_assessmentMethodEmpty ||
          Q45BR_tmtResponseStatusEmpty ||
          Q45BR_dateOfResponse_assess_dtEmpty ||
          Invalid_BR_dateOfResponse_assess_dt ||
          Q45BR_assessmentMethodEmpty ||
          Q47dateOfProgressionEmpty ||
          Q47dateOfProgression_dtEmpty ||
          Invalid_Q47dateOfProgression_dt ||
          Q47ReasonOfProgressionEmpty ||
          Q47ReasonOfProgressionTxtEmpty ||
          Q48FR_tmtResponseStatusEmpty ||
          Q48FR_dateOfResponse_assessEmpty ||
          Q48FR_dateOfResponse_assess_dtEmpty ||
          Invalid_Q48FR_dateOfResponse_assess_dt ||
          Q48FR_assessmentMethodEmpty ||
          Q48BR_tmtResponseStatusEmpty ||
          Q48BR_dateOfResponse_assessEmpty ||
          Q48BR_dateOfResponse_assess_dtEmpty ||
          Invalid_Q48BR_dateOfResponse_assess_dt ||
          Q48BR_assessmentMethodEmpty ||
          Q49dateOfProgressionEmpty ||
          Q49dateOfProgression_dtEmpty ||
          Invalid_Q49dateOfProgression_dt ||
          Q49ReasonOfProgressionEmpty ||
          Q49ReasonOfProgressionTxtEmpty ||
          Q50FR_tmtResponseStatusEmpty ||
          Q50FR_dateOfResponse_assessEmpty ||
          Q50FR_dateOfResponse_assess_dtEmpty ||
          Invalid_Q50FR_dateOfResponse_assess_dt ||
          Q50FR_assessmentMethodEmpty ||
          Q50BR_tmtResponseStatusEmpty ||
          Q50BR_dateOfResponse_assessEmpty ||
          Q50BR_dateOfResponse_assess_dtEmpty ||
          Invalid_Q50BR_dateOfResponse_assess_dt ||
          Q50BR_assessmentMethodEmpty ||
          Q51dateOfProgressionEmpty ||
          Q51dateOfProgression_dtEmpty ||
          Invalid_Q51dateOfProgression_dt ||
          Q51ReasonOfProgressionEmpty ||
          Q51ReasonOfProgressionTxtEmpty ||
          Q51assessmentMethodEmpty ||
          Q52FR_tmtResponseStatusEmpty ||
          Q52FR_dateOfResponse_assessEmpty ||
          Q52FR_dateOfResponse_assess_dtEmpty ||
          Invalid_Q52FR_dateOfResponse_assess_dt ||
          Q52FR_assessmentMethodEmpty ||
          Q52BR_tmtResponseStatusEmpty ||
          Q52BR_dateOfResponse_assessEmpty ||
          Q52BR_dateOfResponse_assess_dtEmpty ||
          Invalid_Q52BR_dateOfResponse_assess_dt ||
          Q52BR_assessmentMethodEmpty ||
          Q44DateValidationError ||
          Q45FRDateValidationError ||
          Q45BRDateValidationError ||
          Q47DateValidationError ||
          Q48FRDateValidation ||
          Q48BRDateValidation ||
          Q49DateValidation ||
          Q50FRDateValidation ||
          Q50BRDateValidation ||
          Q51DateValidation ||
          Q52FRDateValidation ||
          Q52BRDateValidation
        ) {
          isValid = false;
        }

        //Q46
        let innerArr = [];
        if (tmtResponseProgression && tmtResponseProgression.length > 0) {
          if (item.q46Row && item.q46Row.length > 0) {
            innerArr = item.q46Row.map((c) => {
              const Q46dateofassessmentEmpty = c.Q46dateofassessmentRd == null;
              let Q46dateofassessment_dtEmpty = false;
              let Invalid_dateofassessment_dt = false;
              let Q46DateValidationError = false;

              let Q46assessmentmethodEmpty = false;
              let Q46sensitivityEmpty = false;
              let Q46mrdstatusEmpty = false;

              if (!Q46dateofassessmentEmpty) {
                if (c.Q46dateofassessmentRd === 2) {
                  if (isStringEmpty(c.Q46dateofassessment_dt)) {
                    Q46dateofassessment_dtEmpty = true;
                  } else if (!IsDateValid(c.Q46dateofassessment_dt)) {
                    Invalid_dateofassessment_dt = true;
                  } else if (!isStringEmpty(item.cohortIndexDate)) {
                    Q46DateValidationError =
                      !ValidateTreatmentResponseProgressionDate(
                        c.cohortIndexDate,
                        c.Q46dateofassessment_dt,
                        nextLotStartDateQ44_Q46,
                        eofDate,
                      );
                  }
                }
                if (
                  c.Q46dateofassessmentRd === 2 ||
                  c.Q46dateofassessmentRd === 99
                ) {
                  Q46assessmentmethodEmpty = c.Q46assessmentmethodRd == null;
                  Q46sensitivityEmpty = c.Q46sensitivityRd == null;
                  Q46mrdstatusEmpty = c.Q46mrdstatusRd == null;
                }
              }

              if (
                Q46dateofassessmentEmpty ||
                Q46dateofassessment_dtEmpty ||
                Q46assessmentmethodEmpty ||
                Q46sensitivityEmpty ||
                Q46mrdstatusEmpty ||
                Q46DateValidationError ||
                Invalid_dateofassessment_dt
              ) {
                isValid = false;
              }

              return {
                ...c,
                Q46dateofassessmentEmpty,
                Q46dateofassessment_dtEmpty,
                Q46assessmentmethodEmpty,
                Q46sensitivityEmpty,
                Q46mrdstatusEmpty,
                Q46DateValidationError,
                Invalid_dateofassessment_dt,
              };
            });
          }
        }

        return {
          ...item,

          Q44EmptyError,
          Invalid_dateofProgression_dt,
          Q44dateOfProgression_dtEmpty,
          Q44ReasonOfProgressionEmpty,
          Q44ReasonOfProgressionTxtEmpty,
          Q44assessmentMethodEmpty,
          Q45FR_tmtResponseStatusEmpty,
          Q45FR_dateOfResponse_assessEmpty,
          Q45FR_dateOfResponse_assess_dtEmpty,
          Invalid_dateofResponse_assess_dt,
          Q45FR_assessmentMethodEmpty,

          Q45BR_tmtResponseStatusEmpty,
          Q45BR_dateOfResponse_assessEmpty,
          Q45BR_dateOfResponse_assess_dtEmpty,
          Invalid_BR_dateOfResponse_assess_dt,
          Q45BR_assessmentMethodEmpty,

          Q47dateOfProgressionEmpty,
          Q47dateOfProgression_dtEmpty,
          Invalid_Q47dateOfProgression_dt,
          Q47ReasonOfProgressionEmpty,
          Q47ReasonOfProgressionTxtEmpty,
          Q47assessmentMethodEmpty,

          Q48FR_tmtResponseStatusEmpty,
          Q48FR_dateOfResponse_assessEmpty,
          Q48FR_dateOfResponse_assess_dtEmpty,
          Invalid_Q48FR_dateOfResponse_assess_dt,
          Q48FR_assessmentMethodEmpty,

          Q48BR_tmtResponseStatusEmpty,
          Q48BR_dateOfResponse_assessEmpty,
          Q48BR_dateOfResponse_assess_dtEmpty,
          Invalid_Q48BR_dateOfResponse_assess_dt,
          Q48BR_assessmentMethodEmpty,

          Q49dateOfProgressionEmpty,
          Q49dateOfProgression_dtEmpty,
          Invalid_Q49dateOfProgression_dt,
          Q49ReasonOfProgressionEmpty,
          Q49ReasonOfProgressionTxtEmpty,
          Q49assessmentMethodEmpty,

          Q50FR_tmtResponseStatusEmpty,
          Q50FR_dateOfResponse_assessEmpty,
          Q50FR_dateOfResponse_assess_dtEmpty,
          Invalid_Q50FR_dateOfResponse_assess_dt,
          Q50FR_assessmentMethodEmpty,

          Q50BR_tmtResponseStatusEmpty,
          Q50BR_dateOfResponse_assessEmpty,
          Q50BR_dateOfResponse_assess_dtEmpty,
          Invalid_Q50BR_dateOfResponse_assess_dt,
          Q50BR_assessmentMethodEmpty,

          Q51dateOfProgressionEmpty,
          Q51dateOfProgression_dtEmpty,
          Invalid_Q51dateOfProgression_dt,
          Q51ReasonOfProgressionEmpty,
          Q51ReasonOfProgressionTxtEmpty,
          Q51assessmentMethodEmpty,

          Q52FR_tmtResponseStatusEmpty,
          Q52FR_dateOfResponse_assessEmpty,
          Q52FR_dateOfResponse_assess_dtEmpty,
          Invalid_Q52FR_dateOfResponse_assess_dt,
          Q52FR_assessmentMethodEmpty,

          Q52BR_tmtResponseStatusEmpty,
          Q52BR_dateOfResponse_assessEmpty,
          Q52BR_dateOfResponse_assess_dtEmpty,
          Invalid_Q52BR_dateOfResponse_assess_dt,
          Q52BR_assessmentMethodEmpty,

          q46Row: innerArr,

          Q44DateValidationError,

          Q45FRDateValidationError,

          Q45BRDateValidationError,

          Q47DateValidationError,

          Q48FRDateValidation,

          Q48BRDateValidation,

          Q49DateValidation,

          Q50FRDateValidation,

          Q50BRDateValidation,

          Q51DateValidation,

          Q52FRDateValidation,
          Q52BRDateValidation,
        };
      });

      setTmtResponseProgression(updatedArray);
    }

    return isValid;
  };

  useEffect(() => {
    async function FetchData() {
      SetNavPaths();
      if (!isNaN(pid) && Number(pid) !== 0) {
        //ToggleLoader(true);
        await LoadData();
        // ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  const DeleteQ46Row = (entryIndex, rowIndex) => {
    setTmtResponseProgression((prevState) =>
      prevState.map((entry, index) => {
        if (index !== entryIndex) return entry;

        /* -------- DELETE -------- */
        const innerArr = [...entry.q46Row];
        innerArr.splice(rowIndex, 1);
        let cohortData = treatmentlist.filter(
          (c) => c.cohortTreatmentID === entry.cohorttreatmentid,
        )[0];

        /* -------- MRD5 -------- */
        const blockMRD5 =
          cohortData.ndmmrrmmAchievedMRD5 === true &&
          innerArr.some(
            (row) => row.Q46sensitivityRd === 1 && row.Q46mrdstatusRd === 2,
          );

        const requireMRD5 =
          cohortData.ndmmrrmmAchievedMRD5 === true &&
          innerArr.some(
            (row) => row.Q46sensitivityRd === 1 && row.Q46mrdstatusRd !== 2,
          );

        const finalMRD5Warning = !blockMRD5 && requireMRD5;

        /* -------- MRD6 -------- */
        const blockMRD6 =
          cohortData.ndmmrrmmAchievedMRD6 === true &&
          innerArr.some(
            (row) => row.Q46sensitivityRd === 2 && row.Q46mrdstatusRd === 2,
          );

        const requireMRD6 =
          cohortData.ndmmrrmmAchievedMRD6 === true &&
          innerArr.some(
            (row) => row.Q46sensitivityRd === 2 && row.Q46mrdstatusRd !== 2,
          );

        const finalMRD6Warning = !blockMRD6 && requireMRD6;

        /* -------- APPLY -------- */
        const hasMultipleRows = innerArr.length > 1;
        const isSingleRow = innerArr.length === 1;

        const updatedInnerArr = innerArr.map((row) => {
          const keepMRD5 = hasMultipleRows && row.Q46MRD5WarningMsg === true;

          const setMRD5 =
            isSingleRow &&
            !blockMRD5 &&
            cohortData.ndmmrrmmAchievedMRD5 === true;

          const keepMRD6 = hasMultipleRows && row.Q46MRD6WarningMsg === true;

          const setMRD6 =
            isSingleRow &&
            !blockMRD6 &&
            cohortData.ndmmrrmmAchievedMRD6 === true;

          return {
            ...row,
            Q46MRD5WarningMsg: keepMRD5 || setMRD5 || finalMRD5Warning,
            Q46MRD6WarningMsg: keepMRD6 || setMRD6 || finalMRD6Warning,
          };
        });

        return {
          ...entry,
          q46Row: updatedInnerArr,
        };
      }),
    );
  };

  // Function to add a new row for a specific entry based on its index
  const AddQ46Row = (entryIndex) => {
    // Create a new row with the default structure
    const newRow = {
      Q46dateofassessmentRd: null,
      Q46dateofassessment_dt: "",
      Q46assessmentmethodRd: null,
      Q46sensitivityRd: null,
      Q46mrdstatusRd: null,
      Q46dateofassessmentEmpty: false,
      Q46dateofassessment_dtEmpty: false,
      Invalid_dateofassessment_dt: false,
      Q46assessmentmethodEmpty: false,
      Q46sensitivityEmpty: false,
      Q46mrdstatusEmpty: false,

      Q46DateValidationError: false,

      Q46MRD5WarningMsg: false,
      Q46MRD6WarningMsg: false,
    };

    // Update the state with the new row for the specific entry
    setTmtResponseProgression((prevState) => {
      // Clone the current state to avoid mutation
      const updatedState = prevState.map((entry, index) => {
        if (index === entryIndex) {
          // Add the new row only to the specified entry
          return {
            ...entry,
            q46Row: [...entry.q46Row, newRow], // Append the new row
          };
        }
        return entry; // Return unchanged entries
      });

      return updatedState;
    });
  };

  const sidebar = document.getElementById("mySidebar");
  const main = document.getElementById("main");

  const toggleNav = () => {
    if (isSideMenuActive === true) {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
      setIsSideMenuActive(false);
    } else if (isSideMenuActive === false) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
      setIsSideMenuActive(true);
    }
  };

  useEffect(() => {
    const sidebar = document.getElementById("mySidebar");
    const main = document.getElementById("main");

    if (isSideMenuActive === true) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
    } else {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
    }
  });
  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>

      <section className="main-survey-section">
        <div>
          <SideBarMenu
            activePageId={SideMenuItems.TreatmentResponseProgression}
          />

          <>
            <button
              className={isSideMenuActive ? "openbtn" : "openbtn active"}
              onClick={() => toggleNav()}
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>

          <div className="col-pad-left" id="main">
            <div className="survey-section-content">
              <div className="survey-section-content-header">
                <h4> Treatment Response and Progression </h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}
              <div className="survey-question-section">
                <div className="survey-question-content">
                  <div className="question-answer">
                    {tmtResponseProgression &&
                      tmtResponseProgression.length > 0 &&
                      tmtResponseProgression.map((data, idx) => (
                        <div
                          className="dependent-section"
                          key={idx}
                          style={{ paddingTop: 0 }}
                        >
                          <div className="cohort-header">
                            <span>
                              {data.cohortTreatmentName}
                              {data.cohortTreatmentNameSuperscript == null ? (
                                ""
                              ) : (
                                <>
                                  <sup className="supscript">
                                    {data.cohortTreatmentNameSuperscript.slice(
                                      0,
                                      2,
                                    )}
                                  </sup>
                                  {data.cohortTreatmentNameSuperscript.slice(2)}
                                </>
                              )}
                            </span>
                          </div>
                          <>
                            <div className="question-bot-sapce">
                              <div className=" question-weight">
                                <span>Q44. </span>
                                Provide information for{" "}
                                <span
                                  className="modal-popup"
                                  data-tooltip-id="encounterTip"
                                  onClick={() =>
                                    setShowHideHyperlinkModalIMWG(true)
                                  }
                                >
                                  disease progression
                                </span>{" "}
                                conducted during the patient’s treatment with{" "}
                                {""}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                    fontWeight: "bolder",
                                  }}
                                >
                                  {data.cohortTreatmentName}
                                  {data.cohortTreatmentNameSuperscript ==
                                  null ? (
                                    ""
                                  ) : (
                                    <>
                                      <sup className="supscript">
                                        {data.cohortTreatmentNameSuperscript.slice(
                                          0,
                                          2,
                                        )}
                                      </sup>
                                      {data.cohortTreatmentNameSuperscript.slice(
                                        2,
                                      )}
                                    </>
                                  )}
                                </span>{" "}
                                (i.e., from{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                    fontWeight: "bolder",
                                  }}
                                >
                                  {" "}
                                  {data.cohortIndexDate}{" "}
                                </span>{" "}
                                to{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                    fontWeight: "bolder",
                                  }}
                                >
                                  {data.cohorttreatmentid < 9
                                    ? ndmmEndofFollowupDate
                                    : data.bispecificEOFLabel}
                                </span>
                                ).
                              </div>

                              <div className="sub-question custom-error">
                                <table
                                  style={{
                                    border: "1px solid black",
                                    borderCollapse: "collapse",
                                    width: "100%",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        Assessment
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        <span style={{ textAlign: "center" }}>
                                          Date of progression assessment
                                        </span>
                                      </th>

                                      {data.Q44ConditionMet && (
                                        <>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Reason for progression
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Method of assessment
                                          </th>
                                        </>
                                      )}
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                        }}
                                      >
                                        <span className="quest-text-pad">
                                          Disease progression
                                        </span>
                                      </td>

                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                        }}
                                      >
                                        <div>
                                          <div className="option-without-input">
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={
                                                  "Q44dateOfProgressionRd" + idx
                                                }
                                                value={1}
                                                checked={
                                                  data.Q44dateOfProgressionRd ===
                                                  1
                                                }
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohorttreatmentid,
                                                  )
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Disease progression did not
                                                occur
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            {" "}
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={
                                                  "Q44dateOfProgressionRd" + idx
                                                }
                                                value={2}
                                                checked={
                                                  data.Q44dateOfProgressionRd ===
                                                  2
                                                }
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohorttreatmentid,
                                                  )
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Disease progression occurred on:
                                              </span>
                                            </label>
                                          </div>
                                          <span
                                            className="radio-text-padding"
                                            style={{
                                              paddingLeft: "41px",
                                              marginLeft: "5px",
                                            }}
                                          >
                                            <DatePickerComponent
                                              ctrlId={
                                                "Q44dateOfProgression_dt-" + idx
                                              }
                                              HandleDateChange={
                                                HandleRepeaterDateChange
                                              }
                                              optionId={1}
                                              minDate={dayjs("01-01-1920")}
                                              maxDate={dayjs()}
                                              locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                              date={
                                                data.Q44dateOfProgression_dt
                                              }
                                            />
                                          </span>
                                          {/* </div> */}
                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={
                                                  "Q44dateOfProgressionRd" + idx
                                                }
                                                value={99}
                                                checked={
                                                  data.Q44dateOfProgressionRd ===
                                                  99
                                                }
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohorttreatmentid,
                                                  )
                                                }
                                              />

                                              <span
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Disease progression occurred but{" "}
                                                {""}
                                                date of assessment unknown
                                              </span>
                                            </label>
                                          </div>

                                          <ErrorField
                                            show={data.Q44EmptyError}
                                            message={
                                              TreatmentResponseProgression_Msgs.RadioEmtypError
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />

                                          <ErrorField
                                            show={
                                              data.Invalid_dateofProgression_dt
                                            }
                                            message={
                                              CommonError_Msgs.InvalidDate
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />

                                          <ErrorField
                                            show={
                                              data.Q44dateOfProgression_dtEmpty
                                            }
                                            message={
                                              TreatmentResponseProgression_Msgs.Q44DateEmpty
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />

                                          <ErrorField
                                            show={data.Q44DateValidationError}
                                            message={
                                              TreatmentResponseProgression_Msgs.Q44DateOutOfBoundError
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                        </div>
                                      </td>

                                      {data.Q44ConditionMet && (
                                        <>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div className="">
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label>
                                                    <input
                                                      type="checkbox"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={"Q44serum" + idx}
                                                      checked={data.Q44serum}
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Serum M protein
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>

                                              <div className="">
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label>
                                                    <input
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      type="checkbox"
                                                      id={idx}
                                                      name={"Q44uninary" + idx}
                                                      checked={data.Q44uninary}
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Urinary M protein
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>

                                              <div className="">
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label>
                                                    <input
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      type="checkbox"
                                                      id={idx}
                                                      name={
                                                        "Q44freelight" + idx
                                                      }
                                                      checked={
                                                        data.Q44freelight
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Free light chain
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>

                                              <div className="">
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label>
                                                    <input
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      type="checkbox"
                                                      id={idx}
                                                      name={"Q44plasma" + idx}
                                                      checked={data.Q44plasma}
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Plasma cell increase
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>

                                              <div className="">
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      type="checkbox"
                                                      id={idx}
                                                      name={
                                                        "Q44bonelesion" + idx
                                                      }
                                                      checked={
                                                        data.Q44bonelesion
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "15px",
                                                      }}
                                                    >
                                                      Increase in size and/or
                                                      new bone lesion
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>

                                              <div className="">
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      type="checkbox"
                                                      id={idx}
                                                      name={
                                                        "Q44plasmacytomas" + idx
                                                      }
                                                      checked={
                                                        data.Q44plasmacytomas
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "15px",
                                                      }}
                                                    >
                                                      Increase in size and/or
                                                      new plasmacytomas
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>

                                              <div className="">
                                                <div>
                                                  <label>
                                                    <input
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      type="checkbox"
                                                      id={idx}
                                                      name={
                                                        "Q44ReasonOfProgression_oth" +
                                                        idx
                                                      }
                                                      checked={
                                                        data.Q44ReasonOfProgression_oth
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      Other, please specify:
                                                    </span>
                                                  </label>

                                                  <div
                                                    style={{
                                                      paddingLeft: "28px",
                                                    }}
                                                  >
                                                    <textarea
                                                      name={
                                                        "Q44ReasonOfProgression_txt" +
                                                        idx
                                                      }
                                                      className="input-dash"
                                                      type="text"
                                                      value={
                                                        data.Q44ReasonOfProgression_txt
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                      maxLength={300}
                                                      id={idx}
                                                    />
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label>
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={
                                                      "Q44ReasonOfProgression" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q44ReasonOfProgression ===
                                                      99
                                                    }
                                                    onChange={(e) =>
                                                      HandleRepeaterFieldChange(
                                                        e,
                                                        data.cohorttreatmentid,
                                                      )
                                                    }
                                                  />

                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>
                                              <ErrorField
                                                show={
                                                  data.Q44ReasonOfProgressionEmpty
                                                }
                                                message={
                                                  TreatmentResponseProgression_Msgs.Q44Reason
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />

                                              <ErrorField
                                                show={
                                                  data.Q44ReasonOfProgressionTxtEmpty
                                                }
                                                message={
                                                  TreatmentResponseProgression_Msgs.ProgressionReasonTextEmpty
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </div>
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div>
                                                {assessmentMethods &&
                                                  assessmentMethods.length >
                                                    0 &&
                                                  assessmentMethods.map(
                                                    (item, index) => (
                                                      <div
                                                        key={index}
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q44assessmentMethodRd" +
                                                              idx
                                                            }
                                                            value={
                                                              item.assessmentmethodid
                                                            }
                                                            checked={
                                                              data.Q44assessmentMethodRd ===
                                                              item.assessmentmethodid
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          {item.assessmentmethodid ===
                                                          1 ? (
                                                            <span
                                                              className="radio-text-padding modal-popup"
                                                              data-tooltip-id="encounterTip"
                                                              onClick={() =>
                                                                setShowHideHyperlinkModalIMWG(
                                                                  true,
                                                                )
                                                              }
                                                            >
                                                              {item.name}
                                                            </span>
                                                          ) : (
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              {item.name}
                                                            </span>
                                                          )}
                                                        </label>
                                                      </div>
                                                    ),
                                                  )}
                                              </div>
                                              <ErrorField
                                                show={
                                                  data.Q44assessmentMethodEmpty
                                                }
                                                message={
                                                  TreatmentResponseProgression_Msgs.RadioEmtypError
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </div>
                                          </td>
                                        </>
                                      )}
                                    </tr>
                                  </tbody>
                                </table>
                                <ErrorField
                                  show={data.Q44WarningMsg}
                                  message={
                                    TreatmentResponseProgression_Msgs.Q44WarningDiseaseProgression
                                  }
                                />
                              </div>
                            </div>
                            <div className="question-bot-sapce">
                              <div className=" question-weight">
                                <span>Q45. </span>
                                Provide information for{" "}
                                <span
                                  className="modal-popup"
                                  data-tooltip-id="encounterTip"
                                  onClick={() =>
                                    setShowHideHyperlinkModalIMWG(true)
                                  }
                                >
                                  assessments of treatment response
                                </span>{" "}
                                conducted during the patient’s treatment with{" "}
                                {""}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                    fontWeight: "bolder",
                                  }}
                                >
                                  {data.cohortTreatmentName}
                                  {data.cohortTreatmentNameSuperscript ==
                                  null ? (
                                    ""
                                  ) : (
                                    <>
                                      <sup className="supscript">
                                        {data.cohortTreatmentNameSuperscript.slice(
                                          0,
                                          2,
                                        )}
                                      </sup>
                                      {data.cohortTreatmentNameSuperscript.slice(
                                        2,
                                      )}
                                    </>
                                  )}
                                </span>{" "}
                                (i.e., from{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                    fontWeight: "bolder",
                                  }}
                                >
                                  {" "}
                                  {data.cohortIndexDate}{" "}
                                </span>{" "}
                                to{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                    fontWeight: "bolder",
                                  }}
                                >
                                  {data.cohorttreatmentid < 9
                                    ? ndmmEndofFollowupDate
                                    : data.bispecificEOFLabel}
                                </span>
                                ).
                              </div>

                              <div className="sub-question">
                                <table
                                  style={{
                                    border: "1px solid black",
                                    borderCollapse: "collapse",
                                    width: "100%",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                          // width:"4%"
                                        }}
                                      >
                                        Assessment
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                          //   width: "29%"
                                        }}
                                      >
                                        <span style={{ textAlign: "center" }}>
                                          Treatment response status
                                        </span>
                                      </th>

                                      {!(
                                        (data.Q45FR_tmtResponseStatus === 5 ||
                                          data.Q45FR_tmtResponseStatus === 8 ||
                                          data.Q45FR_tmtResponseStatus === 9) &&
                                        (data.Q45BR_tmtResponseStatus === 8 ||
                                          data.Q45BR_tmtResponseStatus === 9)
                                      ) && (
                                        <>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              // width:"36%"
                                            }}
                                          >
                                            Date of response assessment
                                          </th>
                                          <th
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                              textAlign: "center",
                                              //  width:"28%"
                                            }}
                                          >
                                            Method of assessment
                                          </th>
                                        </>
                                      )}
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                        }}
                                      >
                                        <span className="quest-text-pad">
                                          First positive response
                                        </span>
                                      </td>

                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                        }}
                                      >
                                        <div>
                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={
                                                  "Q45FR_tmtResponseStatus" +
                                                  idx
                                                }
                                                value={1}
                                                checked={
                                                  data.Q45FR_tmtResponseStatus ===
                                                  1
                                                }
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohorttreatmentid,
                                                  )
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Stringent complete response
                                                (sCR)
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={
                                                  "Q45FR_tmtResponseStatus" +
                                                  idx
                                                }
                                                value={2}
                                                checked={
                                                  data.Q45FR_tmtResponseStatus ===
                                                  2
                                                }
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohorttreatmentid,
                                                  )
                                                }
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Complete response (CR)
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={
                                                  "Q45FR_tmtResponseStatus" +
                                                  idx
                                                }
                                                value={3}
                                                checked={
                                                  data.Q45FR_tmtResponseStatus ===
                                                  3
                                                }
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohorttreatmentid,
                                                  )
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Very good partial response
                                                (VGPR)
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={
                                                  "Q45FR_tmtResponseStatus" +
                                                  idx
                                                }
                                                value={4}
                                                checked={
                                                  data.Q45FR_tmtResponseStatus ===
                                                  4
                                                }
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohorttreatmentid,
                                                  )
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Partial response (PR)
                                              </span>
                                            </label>
                                          </div>
                                        </div>

                                        <div
                                          className="option-without-input"
                                          style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                          }}
                                        >
                                          <label className="long-text-option">
                                            <input
                                              type="radio"
                                              style={{ marginTop: "6px" }}
                                              id={idx}
                                              name={
                                                "Q45FR_tmtResponseStatus" + idx
                                              }
                                              value={5}
                                              checked={
                                                data.Q45FR_tmtResponseStatus ===
                                                5
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohorttreatmentid,
                                                )
                                              }
                                            />

                                            <span
                                              className="radio-text-padding"
                                              style={{
                                                paddingLeft: "10px",
                                              }}
                                            >
                                              No positive response achieved
                                            </span>
                                          </label>
                                        </div>

                                        <div
                                          className="option-without-input"
                                          style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                          }}
                                        >
                                          <label className="long-text-option">
                                            <input
                                              type="radio"
                                              style={{ marginTop: "6px" }}
                                              id={idx}
                                              name={
                                                "Q45FR_tmtResponseStatus" + idx
                                              }
                                              value={8}
                                              checked={
                                                data.Q45FR_tmtResponseStatus ===
                                                8
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohorttreatmentid,
                                                )
                                              }
                                            />

                                            <span
                                              className="radio-text-padding"
                                              style={{
                                                paddingLeft: "10px",
                                              }}
                                            >
                                              Unknown
                                            </span>
                                          </label>
                                        </div>
                                        <div
                                          className="option-without-input"
                                          style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                          }}
                                        >
                                          <label className="long-text-option">
                                            <input
                                              type="radio"
                                              style={{ marginTop: "6px" }}
                                              id={idx}
                                              name={
                                                "Q45FR_tmtResponseStatus" + idx
                                              }
                                              value={9}
                                              checked={
                                                data.Q45FR_tmtResponseStatus ===
                                                9
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohorttreatmentid,
                                                )
                                              }
                                            />

                                            <span
                                              className="radio-text-padding"
                                              style={{
                                                paddingLeft: "10px",
                                              }}
                                            >
                                              Not assessed
                                            </span>
                                          </label>
                                        </div>
                                        <ErrorField
                                          show={
                                            data.Q45FR_tmtResponseStatusEmpty
                                          }
                                          message={
                                            TreatmentResponseProgression_Msgs.RadioEmtypError
                                          }
                                          style={{ paddingLeft: "0px" }}
                                        />
                                      </td>

                                      {!(
                                        data.Q45FR_tmtResponseStatus === 5 ||
                                        data.Q45FR_tmtResponseStatus === 8 ||
                                        data.Q45FR_tmtResponseStatus === 9
                                      ) ? (
                                        <>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={
                                                      "Q45FR_dateOfResponse_assessRd" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.Q45FR_dateOfResponse_assessRd ===
                                                      1
                                                    }
                                                    onChange={(e) =>
                                                      HandleRepeaterFieldChange(
                                                        e,
                                                        data.cohorttreatmentid,
                                                      )
                                                    }
                                                  />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    First positive response
                                                    assessed on:
                                                  </span>
                                                </label>
                                              </div>

                                              {/* <div
                                                            className="option-without-input"
                                                            style={{ display: "flex" }}
                                                            >
                                                                */}

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "41px",
                                                  marginLeft: "5px",
                                                }}
                                              >
                                                {/* <DateControl
                                              ctrlId={
                                                "Q45FR_dateOfResponse_assess_dt-" +
                                                idx
                                              }
                                              HandleDateChange={
                                                HandleRepeaterDateChange
                                              }
                                              date={
                                                data.Q45FR_dateOfResponse_assess_dt
                                              }
                                            /> */}

                                                <DatePickerComponent
                                                  ctrlId={
                                                    "Q45FR_dateOfResponse_assess_dt-" +
                                                    idx
                                                  }
                                                  // selectedDate={selectedDate}
                                                  //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                  HandleDateChange={
                                                    HandleRepeaterDateChange
                                                  }
                                                  optionId={1}
                                                  minDate={dayjs("01-01-1920")}
                                                  maxDate={dayjs()}
                                                  locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                  date={
                                                    data.Q45FR_dateOfResponse_assess_dt
                                                  }
                                                />
                                              </span>
                                              {/* </div> */}
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={
                                                      "Q45FR_dateOfResponse_assessRd" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q45FR_dateOfResponse_assessRd ===
                                                      99
                                                    }
                                                    onChange={(e) =>
                                                      HandleRepeaterFieldChange(
                                                        e,
                                                        data.cohorttreatmentid,
                                                      )
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    First positive response
                                                    occurred but date of
                                                    assessment unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q45FR_dateOfResponse_assessEmpty
                                                }
                                                message={
                                                  TreatmentResponseProgression_Msgs.RadioEmtypError
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />

                                              <ErrorField
                                                show={data.Q45FRBR_DateMismatch}
                                                message={
                                                  TreatmentResponseProgression_Msgs.Q45DateMismatch
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />

                                              <ErrorField
                                                show={
                                                  data.Q45FR_dateOfResponse_assess_dtEmpty
                                                }
                                                message={
                                                  TreatmentResponseProgression_Msgs.Q45DateEmpty
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />

                                              <ErrorField
                                                show={
                                                  data.Invalid_dateofResponse_assess_dt
                                                }
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />

                                              <ErrorField
                                                show={
                                                  data.Q45FRDateValidationError
                                                }
                                                message={
                                                  TreatmentResponseProgression_Msgs.Q45DateOutOfBoundError
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </div>
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div>
                                                {assessmentMethods &&
                                                  assessmentMethods.length >
                                                    0 &&
                                                  assessmentMethods.map(
                                                    (item, index) => (
                                                      <div
                                                        key={index}
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q45FR_assessmentMethodRd" +
                                                              idx
                                                            }
                                                            value={
                                                              item.assessmentmethodid
                                                            }
                                                            checked={
                                                              data.Q45FR_assessmentMethodRd ===
                                                              item.assessmentmethodid
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          {item.assessmentmethodid ===
                                                          1 ? (
                                                            <span
                                                              className="radio-text-padding modal-popup"
                                                              data-tooltip-id="encounterTip"
                                                              onClick={() =>
                                                                setShowHideHyperlinkModalIMWG(
                                                                  true,
                                                                )
                                                              }
                                                            >
                                                              {item.name}
                                                            </span>
                                                          ) : (
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              {item.name}
                                                            </span>
                                                          )}
                                                        </label>
                                                      </div>
                                                    ),
                                                  )}
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q45FR_assessmentMethodEmpty
                                                }
                                                message={
                                                  TreatmentResponseProgression_Msgs.RadioEmtypError
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </div>
                                          </td>
                                        </>
                                      ) : (
                                        <td
                                          colSpan={2}
                                          style={{
                                            border: "1px solid black",
                                            textAlign: "center",
                                            padding: "8px",
                                          }}
                                        >
                                          <span
                                            style={{ textAlign: "center" }}
                                            className="not-applicable"
                                          >
                                            Not applicable
                                          </span>
                                        </td>
                                      )}
                                    </tr>

                                    <tr>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                        }}
                                      >
                                        <span className="quest-text-pad">
                                          Best response
                                        </span>
                                      </td>

                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                        }}
                                      >
                                        <div>
                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={
                                                  "Q45BR_tmtResponseStatus" +
                                                  idx
                                                }
                                                value={1}
                                                checked={
                                                  data.Q45BR_tmtResponseStatus ===
                                                  1
                                                }
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohorttreatmentid,
                                                  )
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Stringent complete response
                                                (sCR)
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={
                                                  "Q45BR_tmtResponseStatus" +
                                                  idx
                                                }
                                                value={2}
                                                checked={
                                                  data.Q45BR_tmtResponseStatus ===
                                                  2
                                                }
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohorttreatmentid,
                                                  )
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Complete response (CR)
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={
                                                  "Q45BR_tmtResponseStatus" +
                                                  idx
                                                }
                                                value={3}
                                                checked={
                                                  data.Q45BR_tmtResponseStatus ===
                                                  3
                                                }
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohorttreatmentid,
                                                  )
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Very good partial response
                                                (VGPR)
                                              </span>
                                            </label>
                                          </div>

                                          {/* <div
                                                            className="option-without-input"
                                                            style={{ display: "flex" }}
                                                            >
                                                                */}

                                          {/* </div> */}
                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <label className="long-text-option">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={
                                                  "Q45BR_tmtResponseStatus" +
                                                  idx
                                                }
                                                value={4}
                                                checked={
                                                  data.Q45BR_tmtResponseStatus ===
                                                  4
                                                }
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohorttreatmentid,
                                                  )
                                                }
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Partial response (PR)
                                              </span>
                                            </label>
                                          </div>
                                        </div>

                                        <div
                                          className="option-without-input"
                                          style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                          }}
                                        >
                                          <label className="long-text-option">
                                            <input
                                              type="radio"
                                              style={{ marginTop: "6px" }}
                                              id={idx}
                                              name={
                                                "Q45BR_tmtResponseStatus" + idx
                                              }
                                              value={5}
                                              checked={
                                                data.Q45BR_tmtResponseStatus ===
                                                5
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohorttreatmentid,
                                                )
                                              }
                                            />

                                            <span
                                              className="radio-text-padding"
                                              style={{
                                                paddingLeft: "10px",
                                              }}
                                            >
                                              Minimal response (MR)
                                            </span>
                                          </label>
                                        </div>

                                        <div
                                          className="option-without-input"
                                          style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                          }}
                                        >
                                          <label className="long-text-option">
                                            <input
                                              type="radio"
                                              style={{ marginTop: "6px" }}
                                              id={idx}
                                              name={
                                                "Q45BR_tmtResponseStatus" + idx
                                              }
                                              value={6}
                                              checked={
                                                data.Q45BR_tmtResponseStatus ===
                                                6
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohorttreatmentid,
                                                )
                                              }
                                            />

                                            <span
                                              className="radio-text-padding"
                                              style={{
                                                paddingLeft: "10px",
                                              }}
                                            >
                                              Stable disease (SD)
                                            </span>
                                          </label>
                                        </div>

                                        <div
                                          className="option-without-input"
                                          style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                          }}
                                        >
                                          <label className="long-text-option">
                                            <input
                                              type="radio"
                                              style={{ marginTop: "6px" }}
                                              id={idx}
                                              name={
                                                "Q45BR_tmtResponseStatus" + idx
                                              }
                                              value={7}
                                              checked={
                                                data.Q45BR_tmtResponseStatus ===
                                                7
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohorttreatmentid,
                                                )
                                              }
                                            />

                                            <span
                                              className="radio-text-padding"
                                              style={{
                                                paddingLeft: "10px",
                                              }}
                                            >
                                              Progressive disease (PD)
                                            </span>
                                          </label>
                                        </div>

                                        <div
                                          className="option-without-input"
                                          style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                          }}
                                        >
                                          <label className="long-text-option">
                                            <input
                                              type="radio"
                                              style={{ marginTop: "6px" }}
                                              id={idx}
                                              name={
                                                "Q45BR_tmtResponseStatus" + idx
                                              }
                                              value={8}
                                              checked={
                                                data.Q45BR_tmtResponseStatus ===
                                                8
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohorttreatmentid,
                                                )
                                              }
                                            />

                                            <span
                                              className="radio-text-padding"
                                              style={{
                                                paddingLeft: "10px",
                                              }}
                                            >
                                              Unknown
                                            </span>
                                          </label>
                                        </div>
                                        <div
                                          className="option-without-input"
                                          style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                          }}
                                        >
                                          <label className="long-text-option">
                                            <input
                                              type="radio"
                                              style={{ marginTop: "6px" }}
                                              id={idx}
                                              name={
                                                "Q45BR_tmtResponseStatus" + idx
                                              }
                                              value={9}
                                              checked={
                                                data.Q45BR_tmtResponseStatus ===
                                                9
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohorttreatmentid,
                                                )
                                              }
                                            />

                                            <span
                                              className="radio-text-padding"
                                              style={{
                                                paddingLeft: "10px",
                                              }}
                                            >
                                              Not assessed
                                            </span>
                                          </label>
                                        </div>

                                        <ErrorField
                                          show={
                                            data.Q45BR_tmtResponseStatusEmpty
                                          }
                                          message={
                                            TreatmentResponseProgression_Msgs.RadioEmtypError
                                          }
                                          style={{ paddingLeft: "0px" }}
                                        />
                                      </td>

                                      {!(
                                        data.Q45BR_tmtResponseStatus === 8 ||
                                        data.Q45BR_tmtResponseStatus === 9
                                      ) ? (
                                        <>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={
                                                      "Q45BR_dateOfResponse_assessRd" +
                                                      idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.Q45BR_dateOfResponse_assessRd ===
                                                      1
                                                    }
                                                    onChange={(e) =>
                                                      HandleRepeaterFieldChange(
                                                        e,
                                                        data.cohorttreatmentid,
                                                      )
                                                    }
                                                  />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Best response assessed on:
                                                  </span>
                                                </label>
                                              </div>

                                              {/* <div
                                                            className="option-without-input"
                                                            style={{ display: "flex" }}
                                                            >
                                                                */}

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "41px",
                                                  marginLeft: "5px",
                                                }}
                                              >
                                                {/* <DateControl
                                              ctrlId={
                                                "Q45BR_dateOfResponse_assess_dt-" +
                                                idx
                                              }
                                              HandleDateChange={
                                                HandleRepeaterDateChange
                                              }
                                              date={
                                                data.Q45BR_dateOfResponse_assess_dt
                                              }
                                            /> */}
                                                <DatePickerComponent
                                                  ctrlId={
                                                    "Q45BR_dateOfResponse_assess_dt-" +
                                                    idx
                                                  }
                                                  // selectedDate={selectedDate}
                                                  //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                  HandleDateChange={
                                                    HandleRepeaterDateChange
                                                  }
                                                  optionId={1}
                                                  minDate={dayjs("01-01-1920")}
                                                  maxDate={dayjs()}
                                                  locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                  date={
                                                    data.Q45BR_dateOfResponse_assess_dt
                                                  }
                                                />
                                              </span>
                                              {/* </div> */}
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={
                                                      "Q45BR_dateOfResponse_assessRd" +
                                                      idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.Q45BR_dateOfResponse_assessRd ===
                                                      99
                                                    }
                                                    onChange={(e) =>
                                                      HandleRepeaterFieldChange(
                                                        e,
                                                        data.cohorttreatmentid,
                                                      )
                                                    }
                                                  />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Best response occurred but
                                                    date of assessment unknown
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q45BR_dateOfResponse_assessEmpty
                                                }
                                                message={
                                                  TreatmentResponseProgression_Msgs.RadioEmtypError
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />

                                              <ErrorField
                                                show={data.Q45FRBR_DateMismatch}
                                                message={
                                                  TreatmentResponseProgression_Msgs.Q45DateMismatch
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />

                                              <ErrorField
                                                show={
                                                  data.Q45BR_PD_DateMismatch
                                                }
                                                message={
                                                  TreatmentResponseProgression_Msgs.Q45PDDateMismatch
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />

                                              <ErrorField
                                                show={
                                                  data.Q45BR_dateOfResponse_assess_dtEmpty
                                                }
                                                message={
                                                  TreatmentResponseProgression_Msgs.Q45DateEmpty
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />

                                              <ErrorField
                                                show={
                                                  data.Invalid_BR_dateOfResponse_assess_dt
                                                }
                                                message={
                                                  CommonError_Msgs.InvalidDate
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />

                                              <ErrorField
                                                show={
                                                  data.Q45BRDateValidationError
                                                }
                                                message={
                                                  TreatmentResponseProgression_Msgs.Q45DateOutOfBoundError
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </div>
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "8px",
                                            }}
                                          >
                                            <div>
                                              <div>
                                                {assessmentMethods &&
                                                  assessmentMethods.length >
                                                    0 &&
                                                  assessmentMethods.map(
                                                    (item, index) => (
                                                      <div
                                                        key={index}
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q45BR_assessmentMethodRd" +
                                                              idx
                                                            }
                                                            value={
                                                              item.assessmentmethodid
                                                            }
                                                            checked={
                                                              data.Q45BR_assessmentMethodRd ===
                                                              item.assessmentmethodid
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          {item.assessmentmethodid ===
                                                          1 ? (
                                                            <span
                                                              className="radio-text-padding modal-popup"
                                                              data-tooltip-id="encounterTip"
                                                              onClick={() =>
                                                                setShowHideHyperlinkModalIMWG(
                                                                  true,
                                                                )
                                                              }
                                                            >
                                                              {item.name}
                                                            </span>
                                                          ) : (
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              {item.name}
                                                            </span>
                                                          )}
                                                        </label>
                                                      </div>
                                                    ),
                                                  )}
                                              </div>

                                              <ErrorField
                                                show={
                                                  data.Q45BR_assessmentMethodEmpty
                                                }
                                                message={
                                                  TreatmentResponseProgression_Msgs.RadioEmtypError
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </div>
                                          </td>
                                        </>
                                      ) : (
                                        <td
                                          colSpan={2}
                                          style={{
                                            border: "1px solid black",
                                            textAlign: "center",
                                            padding: "8px",
                                          }}
                                        >
                                          <span
                                            style={{ textAlign: "center" }}
                                            className="not-applicable"
                                          >
                                            Not applicable
                                          </span>
                                        </td>
                                      )}
                                    </tr>
                                  </tbody>
                                </table>
                                <ErrorField
                                  show={data.Q45WarningMsg}
                                  message={
                                    TreatmentResponseProgression_Msgs.Q45WarningAchievedCR
                                  }
                                />
                                <ErrorField
                                  show={data.Q45VGPRWarningMsg}
                                  message={
                                    TreatmentResponseProgression_Msgs.Q45WarningAchievedVGPR
                                  }
                                />
                                <ErrorField
                                  show={data.Q45PRWarningMsg}
                                  message={
                                    TreatmentResponseProgression_Msgs.Q45WarningAchievedSuboptimalResponse
                                  }
                                />
                              </div>
                            </div>

                            <div className="question-bot-sapce">
                              <div className=" question-weight">
                                <span>Q46. </span>
                                Provide details of each minimum residual disease
                                (MRD) assessment during treatment with{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                    fontWeight: "bolder",
                                  }}
                                >
                                  {data.cohortTreatmentName}
                                  {data.cohortTreatmentNameSuperscript ==
                                  null ? (
                                    ""
                                  ) : (
                                    <>
                                      <sup className="supscript">
                                        {data.cohortTreatmentNameSuperscript.slice(
                                          0,
                                          2,
                                        )}
                                      </sup>
                                      {data.cohortTreatmentNameSuperscript.slice(
                                        2,
                                      )}
                                    </>
                                  )}
                                </span>{" "}
                                (i.e., from{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                    fontWeight: "bolder",
                                  }}
                                >
                                  {" "}
                                  {data.cohortIndexDate}{" "}
                                </span>{" "}
                                to{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                    fontWeight: "bolder",
                                  }}
                                >
                                  {data.cohorttreatmentid < 9
                                    ? ndmmEndofFollowupDate
                                    : data.bispecificEOFLabel}
                                </span>
                                ).
                              </div>
                              {(() => {
                                const finalMRD5Warning = data.q46Row?.some(
                                  (r) => r.Q46MRD5WarningMsg,
                                );
                                const finalMRD6Warning = data.q46Row?.some(
                                  (r) => r.Q46MRD6WarningMsg,
                                );

                                return (
                                  <>
                                    {finalMRD5Warning && (
                                      <ErrorField
                                        show={true}
                                        message={
                                          TreatmentResponseProgression_Msgs.Q46Achievednegativity105
                                        }
                                      />
                                    )}

                                    {finalMRD6Warning && (
                                      <ErrorField
                                        show={true}
                                        message={
                                          TreatmentResponseProgression_Msgs.Q46Achievednegativity106
                                        }
                                      />
                                    )}
                                  </>
                                );
                              })()}

                              <div
                                className="dependent-section"
                                style={{ paddingTop: 0 }}
                              >
                                {data.q46Row &&
                                  data.q46Row.length > 0 &&
                                  data.q46Row.map((child, index) => (
                                    <div
                                      className="loop-section-ul"
                                      key={index}
                                    >
                                      <div className="loop-head">
                                        <span
                                          className="question-weight"
                                          style={{ float: "inline-start" }}
                                        >
                                          {GetOrdinal(index + 1)}{" "}
                                          Assessment{" "}
                                        </span>

                                        {index != 0 && (
                                          <div
                                            className="delete-btn-div"
                                            style={{ float: "inline-end" }}
                                          >
                                            <img
                                              width="16px"
                                              src="../Assets/images/Icon-material-delete.png"
                                              alt=""
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                DeleteQ46Row(idx, index)
                                              }
                                            />
                                          </div>
                                        )}
                                      </div>

                                      {/* TECVAYLI® */}
                                      <div className="question-bot-sapce">
                                        <div className="sub-question">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Date of assessment
                                                </th>
                                                {(child.Q46dateofassessmentRd ===
                                                  2 ||
                                                  child.Q46dateofassessmentRd ===
                                                    99) && (
                                                  <>
                                                    <th
                                                      style={{
                                                        border:
                                                          "1px solid black",
                                                        padding: "8px",
                                                        textAlign: "center",
                                                        width: "20%",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        Method of assessment
                                                      </span>
                                                    </th>

                                                    <th
                                                      style={{
                                                        border:
                                                          "1px solid black",
                                                        padding: "8px",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      Sensitivity of assessment
                                                    </th>
                                                    <th
                                                      style={{
                                                        border:
                                                          "1px solid black",
                                                        padding: "8px",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      MRD status
                                                    </th>
                                                  </>
                                                )}
                                              </tr>
                                            </thead>

                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={index}
                                                          name={
                                                            "Q46dateofassessmentRd" +
                                                            index +
                                                            "-" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            child.Q46dateofassessmentRd ===
                                                            1
                                                          }
                                                          onChange={(e) =>
                                                            HandleRepeaterFieldChange(
                                                              e,
                                                              data.cohorttreatmentid,
                                                            )
                                                          }
                                                        />

                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          MRD was not assessed
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={index}
                                                          name={
                                                            "Q46dateofassessmentRd" +
                                                            index +
                                                            "-" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            child.Q46dateofassessmentRd ===
                                                            2
                                                          }
                                                          onChange={(e) =>
                                                            HandleRepeaterFieldChange(
                                                              e,
                                                              data.cohorttreatmentid,
                                                            )
                                                          }
                                                        />

                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          MRD assessed on:
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "12px",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={
                                                          "Q46dateofassessment_dt-" +
                                                          index +
                                                          "-" +
                                                          idx
                                                        }
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        optionId={index}
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                        date={
                                                          child.Q46dateofassessment_dt
                                                        }
                                                      />
                                                    </span>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={index}
                                                          name={
                                                            "Q46dateofassessmentRd" +
                                                            index +
                                                            "-" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            child.Q46dateofassessmentRd ===
                                                            99
                                                          }
                                                          onChange={(e) =>
                                                            HandleRepeaterFieldChange(
                                                              e,
                                                              data.cohorttreatmentid,
                                                            )
                                                          }
                                                        />

                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          MRD assessed but date
                                                          of assessment unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        child.Q46dateofassessmentEmpty
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.RadioEmtypError
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={
                                                        child.Q46dateofassessment_dtEmpty
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.Q46DateEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        child.Invalid_dateofassessment_dt
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        child.Q46DateValidationError
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.Q46DateOutOfBoundError
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                                {(child.Q46dateofassessmentRd ===
                                                  2 ||
                                                  child.Q46dateofassessmentRd ===
                                                    99) && (
                                                  <>
                                                    <td
                                                      style={{
                                                        border:
                                                          "1px solid black",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={index}
                                                            name={
                                                              "Q46assessmentmethodRd" +
                                                              index +
                                                              "-" +
                                                              idx
                                                            }
                                                            value={1}
                                                            checked={
                                                              child.Q46assessmentmethodRd ===
                                                              1
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Multiparameter flow
                                                            cytometry
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={index}
                                                            name={
                                                              "Q46assessmentmethodRd" +
                                                              index +
                                                              "-" +
                                                              idx
                                                            }
                                                            value={2}
                                                            checked={
                                                              child.Q46assessmentmethodRd ===
                                                              2
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Next-generation
                                                            sequencing (NGS)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={index}
                                                            name={
                                                              "Q46assessmentmethodRd" +
                                                              index +
                                                              "-" +
                                                              idx
                                                            }
                                                            value={3}
                                                            checked={
                                                              child.Q46assessmentmethodRd ===
                                                              3
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Next-generation flow
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={index}
                                                            name={
                                                              "Q46assessmentmethodRd" +
                                                              index +
                                                              "-" +
                                                              idx
                                                              //index
                                                            }
                                                            value={4}
                                                            checked={
                                                              child.Q46assessmentmethodRd ===
                                                              4
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Polymerase Chain
                                                            Reaction (PCR)
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={index}
                                                            name={
                                                              "Q46assessmentmethodRd" +
                                                              index +
                                                              "-" +
                                                              idx
                                                              // index
                                                            }
                                                            value={5}
                                                            checked={
                                                              child.Q46assessmentmethodRd ===
                                                              5
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Bone marrow biopsy
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={index}
                                                            name={
                                                              "Q46assessmentmethodRd" +
                                                              index +
                                                              "-" +
                                                              idx
                                                              // index
                                                            }
                                                            value={6}
                                                            checked={
                                                              child.Q46assessmentmethodRd ===
                                                              6
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Other
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          child.Q46assessmentmethodEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.RadioEmtypError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </td>

                                                    <td
                                                      style={{
                                                        border:
                                                          "1px solid black",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      <div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={index}
                                                              name={
                                                                "Q46sensitivityRd" +
                                                                index +
                                                                "-" +
                                                                idx
                                                              }
                                                              value={1}
                                                              checked={
                                                                child.Q46sensitivityRd ===
                                                                1
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                                // marginLeft: "-5px",
                                                              }}
                                                            >
                                                              {" "}
                                                              10<sup>-5</sup>
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              id={index}
                                                              name={
                                                                "Q46sensitivityRd" +
                                                                index +
                                                                "-" +
                                                                idx
                                                              }
                                                              value={2}
                                                              checked={
                                                                child.Q46sensitivityRd ===
                                                                2
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />

                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              10<sup>-6</sup>
                                                            </span>
                                                          </label>
                                                        </div>

                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              id={index}
                                                              name={
                                                                "Q46sensitivityRd" +
                                                                index +
                                                                "-" +
                                                                idx
                                                              }
                                                              value={3}
                                                              checked={
                                                                child.Q46sensitivityRd ===
                                                                3
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />

                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              {" "}
                                                              Unknown
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <ErrorField
                                                          show={
                                                            child.Q46sensitivityEmpty
                                                          }
                                                          message={
                                                            TreatmentResponseProgression_Msgs.Q46Sensitivity
                                                          }
                                                          style={{
                                                            paddingLeft: "0px",
                                                          }}
                                                        />
                                                      </div>
                                                    </td>

                                                    <td
                                                      style={{
                                                        border:
                                                          "1px solid black",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      <div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              id={index}
                                                              name={
                                                                "Q46mrdstatusRd" +
                                                                index +
                                                                "-" +
                                                                idx
                                                              }
                                                              value={1}
                                                              checked={
                                                                child.Q46mrdstatusRd ===
                                                                1
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                                // marginLeft: "-5px",
                                                              }}
                                                            >
                                                              {" "}
                                                              Positive
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              id={index}
                                                              name={
                                                                "Q46mrdstatusRd" +
                                                                index +
                                                                "-" +
                                                                idx
                                                              }
                                                              value={2}
                                                              checked={
                                                                child.Q46mrdstatusRd ===
                                                                2
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />

                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              Negative
                                                            </span>
                                                          </label>
                                                        </div>

                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              type="radio"
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              id={index}
                                                              name={
                                                                "Q46mrdstatusRd" +
                                                                index +
                                                                "-" +
                                                                idx
                                                              }
                                                              value={99}
                                                              checked={
                                                                child.Q46mrdstatusRd ===
                                                                99
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />

                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              {" "}
                                                              Unknown
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <ErrorField
                                                          show={
                                                            child.Q46mrdstatusEmpty
                                                          }
                                                          message={
                                                            TreatmentResponseProgression_Msgs.Q46MRDStatus
                                                          }
                                                          style={{
                                                            paddingLeft: "0px",
                                                          }}
                                                        />
                                                      </div>
                                                    </td>
                                                  </>
                                                )}
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  ))}

                                {data.q46Row &&
                                  data.q46Row.length > 0 &&
                                  data.q46Row.length < 550 && (
                                    <div className="sub-question-bot-sapce-ul mt-2">
                                      {!data.q46Row.some(
                                        (row) =>
                                          row?.Q46dateofassessmentRd === 1,
                                      ) && (
                                        <div
                                          className="answer-list-text"
                                          onClick={() => {
                                            AddQ46Row(idx);
                                          }}
                                        >
                                          <a>
                                            <img
                                              width="18px"
                                              src="../Assets/images/plus.png"
                                              alt=""
                                            />
                                          </a>
                                          <a className="radio-text-padding">
                                            Click here to add another assessment
                                          </a>
                                        </div>
                                      )}
                                    </div>
                                  )}
                              </div>
                              {/* )} */}

                              <br />

                              {showQ47_48 &&
                                data.cohorttreatmentid <
                                  RRMMCohortTreatment.TECVAYLI && (
                                  <>
                                    <div>
                                      <b>
                                        Response Assessments in 2<sup>nd</sup>{" "}
                                        Line of Treatment{" "}
                                      </b>
                                    </div>
                                    <div className="question-bot-sapce">
                                      <div className=" question-weight">
                                        <span> Q47. </span>
                                        Provide information for{" "}
                                        <span
                                          className="modal-popup"
                                          data-tooltip-id="encounterTip"
                                          onClick={() =>
                                            setShowHideHyperlinkModalIMWG(true)
                                          }
                                        >
                                          disease progression
                                        </span>{" "}
                                        assessed during the patient’s 2
                                        <sup>nd</sup> line of treatment.
                                      </div>

                                      <div className="sub-question">
                                        <table
                                          style={{
                                            border: "1px solid black",
                                            borderCollapse: "collapse",
                                            width: "100%",
                                          }}
                                        >
                                          <thead>
                                            <tr>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Assessment
                                              </th>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Date of progression assessment
                                                </span>
                                              </th>

                                              {data.Q47ConditionMet && (
                                                <>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Reason for progression
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    Method of assessment
                                                  </th>
                                                </>
                                              )}
                                            </tr>
                                          </thead>

                                          <tbody>
                                            <tr>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="quest-text-pad">
                                                  Disease progression
                                                </span>
                                              </td>

                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q47dateOfProgressionRd" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.Q47dateOfProgressionRd ===
                                                          1
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Disease progression did
                                                        not occur
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q47dateOfProgressionRd" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.Q47dateOfProgressionRd ===
                                                          2
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Disease progression
                                                        occurred on:
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "41px",
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    <DatePickerComponent
                                                      ctrlId={
                                                        "Q47dateOfProgression_dt-" +
                                                        idx
                                                      }
                                                      HandleDateChange={
                                                        HandleRepeaterDateChange
                                                      }
                                                      optionId={1}
                                                      minDate={dayjs(
                                                        "01-01-1920",
                                                      )}
                                                      maxDate={dayjs()}
                                                      locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                      date={
                                                        data.Q47dateOfProgression_dt
                                                      }
                                                    />
                                                  </span>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q47dateOfProgressionRd" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.Q47dateOfProgressionRd ===
                                                          99
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Disease progression
                                                        occurred but date of
                                                        assessment unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.Q47dateOfProgressionEmpty
                                                    }
                                                    message={
                                                      TreatmentResponseProgression_Msgs.RadioEmtypError
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.Q47dateOfProgression_dtEmpty
                                                    }
                                                    message={
                                                      TreatmentResponseProgression_Msgs.Q47DateEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.Invalid_Q47dateOfProgression_dt
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.Q47DateValidationError
                                                    }
                                                    message={
                                                      TreatmentResponseProgression_Msgs.Q47NDMMDateOutOfBoundError
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              </td>

                                              {data.Q47ConditionMet && (
                                                <>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div className="">
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              type="checkbox"
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              id={idx}
                                                              name={
                                                                "Q47serum" + idx
                                                              }
                                                              checked={
                                                                data.Q47serum
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Serum M protein
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                      <div className="">
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              type="checkbox"
                                                              id={idx}
                                                              name={
                                                                "Q47uninary" +
                                                                idx
                                                              }
                                                              checked={
                                                                data.Q47uninary
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Urinary M protein
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                      <div className="">
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              type="checkbox"
                                                              id={idx}
                                                              name={
                                                                "Q47freelight" +
                                                                idx
                                                              }
                                                              checked={
                                                                data.Q47freelight
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Free light chain
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                      <div className="">
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              type="checkbox"
                                                              id={idx}
                                                              name={
                                                                "Q47plasma" +
                                                                idx
                                                              }
                                                              checked={
                                                                data.Q47plasma
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Plasma cell
                                                              increase
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                      <div className="">
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              type="checkbox"
                                                              id={idx}
                                                              name={
                                                                "Q47bonelesion" +
                                                                idx
                                                              }
                                                              checked={
                                                                data.Q47bonelesion
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Increase in size
                                                              and/or new bone
                                                              lesion
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                      <div className="">
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              type="checkbox"
                                                              id={idx}
                                                              name={
                                                                "Q47plasmacytomas" +
                                                                idx
                                                              }
                                                              checked={
                                                                data.Q47plasmacytomas
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Increase in size
                                                              and/or new
                                                              plasmacytomas
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                      <div className="">
                                                        <div
                                                        //   style={{display:"flex", alignItems:"flex-start"}}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              type="checkbox"
                                                              id={idx}
                                                              name={
                                                                "Q47ReasonOfProgression_oth" +
                                                                idx
                                                              }
                                                              checked={
                                                                data.Q47ReasonOfProgression_oth
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Other, please
                                                              specify:
                                                            </span>
                                                          </label>

                                                          <div
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            <textarea
                                                              name={
                                                                "Q47ReasonOfProgression_txt" +
                                                                idx
                                                              }
                                                              className="input-dash"
                                                              type="text"
                                                              value={
                                                                data.Q47ReasonOfProgression_txt
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                              maxLength={300}
                                                              id={idx}
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q47ReasonOfProgression" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.Q47ReasonOfProgression ===
                                                              99
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.Q47ReasonOfProgressionEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q47Reason
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q47ReasonOfProgressionTxtEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.ProgressionReasonTextEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div>
                                                        {assessmentMethods &&
                                                          assessmentMethods.length >
                                                            0 &&
                                                          assessmentMethods.map(
                                                            (item, index) => (
                                                              <div
                                                                key={index}
                                                                className="option-without-input"
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "flex-start",
                                                                }}
                                                              >
                                                                <label className="long-text-option">
                                                                  <input
                                                                    type="radio"
                                                                    style={{
                                                                      marginTop:
                                                                        "6px",
                                                                    }}
                                                                    id={idx}
                                                                    name={
                                                                      "Q47assessmentMethodRd" +
                                                                      idx
                                                                    }
                                                                    value={
                                                                      item.assessmentmethodid
                                                                    }
                                                                    checked={
                                                                      data.Q47assessmentMethodRd ===
                                                                      item.assessmentmethodid
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      HandleRepeaterFieldChange(
                                                                        e,
                                                                        data.cohorttreatmentid,
                                                                      )
                                                                    }
                                                                  />

                                                                  {item.assessmentmethodid ===
                                                                  1 ? (
                                                                    <span
                                                                      className="radio-text-padding modal-popup"
                                                                      data-tooltip-id="encounterTip"
                                                                      onClick={() =>
                                                                        setShowHideHyperlinkModalIMWG(
                                                                          true,
                                                                        )
                                                                      }
                                                                    >
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </span>
                                                                  ) : (
                                                                    <span
                                                                      className="radio-text-padding"
                                                                      style={{
                                                                        paddingLeft:
                                                                          "10px",
                                                                      }}
                                                                    >
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </span>
                                                                  )}
                                                                </label>
                                                              </div>
                                                            ),
                                                          )}
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.Q47assessmentMethodEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.RadioEmtypError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                </>
                                              )}
                                            </tr>
                                          </tbody>
                                        </table>
                                        {data.Q47q28WarningMsg && (
                                          <ErrorField
                                            message={
                                              TreatmentResponseProgression_Msgs.Q47WarningMsg
                                            }
                                          />
                                        )}
                                      </div>
                                    </div>

                                    <div className="question-bot-sapce">
                                      <div className=" question-weight">
                                        <span>Q48. </span>
                                        Provide information for{" "}
                                        <span
                                          className="modal-popup"
                                          data-tooltip-id="encounterTip"
                                          onClick={() =>
                                            setShowHideHyperlinkModalIMWG(true)
                                          }
                                        >
                                          assessments of treatment response
                                        </span>{" "}
                                        conducted during the patient’s 2nd{" "}
                                        <span
                                          data-tooltip-id="encounterTip"
                                          className="modal-popup"
                                          onClick={() =>
                                            setShowHideHyperlinkModal(true)
                                          }
                                        >
                                          line of therapy
                                        </span>
                                        .
                                      </div>

                                      <div className="sub-question">
                                        <table
                                          style={{
                                            border: "1px solid black",
                                            borderCollapse: "collapse",
                                            width: "100%",
                                          }}
                                        >
                                          <thead>
                                            <tr>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                  // width:"4%"
                                                }}
                                              >
                                                Assessment
                                              </th>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                  //   width: "29%"
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Treatment response status
                                                </span>
                                              </th>

                                              {!(
                                                (data.Q48FR_tmtResponseStatus ===
                                                  5 ||
                                                  data.Q48FR_tmtResponseStatus ===
                                                    8 ||
                                                  data.Q48FR_tmtResponseStatus ===
                                                    9) &&
                                                (data.Q48BR_tmtResponseStatus ===
                                                  8 ||
                                                  data.Q48BR_tmtResponseStatus ===
                                                    9)
                                              ) && (
                                                <>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      // width:"36%"
                                                    }}
                                                  >
                                                    Date of response assessment
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      //  width:"28%"
                                                    }}
                                                  >
                                                    Method of assessment
                                                  </th>
                                                </>
                                              )}
                                            </tr>
                                          </thead>

                                          <tbody>
                                            <tr>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="quest-text-pad">
                                                  First positive response
                                                </span>
                                              </td>

                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q48FR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.Q48FR_tmtResponseStatus ===
                                                          1
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Stringent complete
                                                        response (sCR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q48FR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.Q48FR_tmtResponseStatus ===
                                                          2
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Complete response (CR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q48FR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          data.Q48FR_tmtResponseStatus ===
                                                          3
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Very good partial
                                                        response (VGPR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  {/* <div
                                                            className="option-without-input"
                                                            style={{ display: "flex" }}
                                                            >
                                                                */}

                                                  {/* </div> */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q48FR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={4}
                                                        checked={
                                                          data.Q48FR_tmtResponseStatus ===
                                                          4
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Partial response (PR)
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q48FR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={5}
                                                      checked={
                                                        data.Q48FR_tmtResponseStatus ===
                                                        5
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      No positive response
                                                      achieved
                                                    </span>
                                                  </label>
                                                </div>

                                                {/* <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  style={{ marginTop: "6px" }}
                                                  id={idx}
                                                  name={
                                                    "Q48FR_tmtResponseStatus" +
                                                    idx
                                                  }
                                                  value={6}
                                                  checked={
                                                    data.Q48FR_tmtResponseStatus ===
                                                    6
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Stable disease (SD)
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  style={{ marginTop: "6px" }}
                                                  id={idx}
                                                  name={
                                                    "Q48FR_tmtResponseStatus" +
                                                    idx
                                                  }
                                                  value={7}
                                                  checked={
                                                    data.Q48FR_tmtResponseStatus ===
                                                    7
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Progressive disease (PD)
                                                  </span>
                                                </label>
                                              </div> */}

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q48FR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={8}
                                                      checked={
                                                        data.Q48FR_tmtResponseStatus ===
                                                        8
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q48FR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={9}
                                                      checked={
                                                        data.Q48FR_tmtResponseStatus ===
                                                        9
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Not assessed
                                                    </span>
                                                  </label>
                                                </div>

                                                <ErrorField
                                                  show={
                                                    data.Q48FR_tmtResponseStatusEmpty
                                                  }
                                                  message={
                                                    TreatmentResponseProgression_Msgs.RadioEmtypError
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />
                                              </td>
                                              {!(
                                                data.Q48FR_tmtResponseStatus ===
                                                  5 ||
                                                data.Q48FR_tmtResponseStatus ===
                                                  8 ||
                                                data.Q48FR_tmtResponseStatus ===
                                                  9
                                              ) ? (
                                                <>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q48FR_dateOfResponse_assessRd" +
                                                              idx
                                                            }
                                                            value={1}
                                                            checked={
                                                              data.Q48FR_dateOfResponse_assessRd ===
                                                              1
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            First positive
                                                            response assessed
                                                            on:
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* <div
                                                            className="option-without-input"
                                                            style={{ display: "flex" }}
                                                            >
                                                                */}

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "41px",
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        {/* <DateControl
                                                    ctrlId={
                                                      "Q48FR_dateOfResponse_assess_dt-" +
                                                      idx
                                                    }
                                                    HandleDateChange={
                                                      HandleRepeaterDateChange
                                                    }
                                                    date={
                                                      data.Q48FR_dateOfResponse_assess_dt
                                                    }
                                                  /> */}

                                                        <DatePickerComponent
                                                          ctrlId={
                                                            "Q48FR_dateOfResponse_assess_dt-" +
                                                            idx
                                                          }
                                                          // selectedDate={selectedDate}
                                                          //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          // optionId={1}
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                          date={
                                                            data.Q48FR_dateOfResponse_assess_dt
                                                          }
                                                        />
                                                      </span>
                                                      {/* </div> */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q48FR_dateOfResponse_assessRd" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.Q48FR_dateOfResponse_assessRd ===
                                                              99
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            First positive
                                                            response occurred
                                                            but date of
                                                            assessment unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <ErrorField
                                                        show={
                                                          data.Q48FR_dateOfResponse_assessEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.RadioEmtypError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q48FRBR_DateMismatch
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q48DateMismatch
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q48FR_dateOfResponse_assess_dtEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q48DateEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Invalid_Q48FR_dateOfResponse_assess_dt
                                                        }
                                                        message={
                                                          CommonError_Msgs.InvalidDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q48FRDateValidation
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q48NDMMDateOutOfBoundError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div>
                                                        {assessmentMethods &&
                                                          assessmentMethods.length >
                                                            0 &&
                                                          assessmentMethods.map(
                                                            (item, index) => (
                                                              <div
                                                                key={index}
                                                                className="option-without-input"
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "flex-start",
                                                                }}
                                                              >
                                                                <label className="long-text-option">
                                                                  <input
                                                                    type="radio"
                                                                    style={{
                                                                      marginTop:
                                                                        "6px",
                                                                    }}
                                                                    id={idx}
                                                                    name={
                                                                      "Q48FR_assessmentMethodRd" +
                                                                      idx
                                                                    }
                                                                    value={
                                                                      item.assessmentmethodid
                                                                    }
                                                                    checked={
                                                                      data.Q48FR_assessmentMethodRd ===
                                                                      item.assessmentmethodid
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      HandleRepeaterFieldChange(
                                                                        e,
                                                                        data.cohorttreatmentid,
                                                                      )
                                                                    }
                                                                  />

                                                                  {item.assessmentmethodid ===
                                                                  1 ? (
                                                                    <span
                                                                      className="radio-text-padding modal-popup"
                                                                      data-tooltip-id="encounterTip"
                                                                      onClick={() =>
                                                                        setShowHideHyperlinkModalIMWG(
                                                                          true,
                                                                        )
                                                                      }
                                                                    >
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </span>
                                                                  ) : (
                                                                    <span
                                                                      className="radio-text-padding"
                                                                      style={{
                                                                        paddingLeft:
                                                                          "10px",
                                                                      }}
                                                                    >
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </span>
                                                                  )}
                                                                </label>
                                                              </div>
                                                            ),
                                                          )}
                                                      </div>

                                                      <ErrorField
                                                        show={
                                                          data.Q48FR_assessmentMethodEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.RadioEmtypError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                </>
                                              ) : (
                                                <td
                                                  colSpan={2}
                                                  style={{
                                                    border: "1px solid black",
                                                    textAlign: "center",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                    className="not-applicable"
                                                  >
                                                    Not applicable
                                                  </span>
                                                </td>
                                              )}
                                            </tr>

                                            <tr>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="quest-text-pad">
                                                  Best response
                                                </span>
                                              </td>

                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q48BR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.Q48BR_tmtResponseStatus ===
                                                          1
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Stringent complete
                                                        response (sCR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q48BR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.Q48BR_tmtResponseStatus ===
                                                          2
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Complete response (CR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q48BR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          data.Q48BR_tmtResponseStatus ===
                                                          3
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Very good partial
                                                        response (VGPR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  {/* <div
                                                            className="option-without-input"
                                                            style={{ display: "flex" }}
                                                            >
                                                                */}

                                                  {/* </div> */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q48BR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={4}
                                                        checked={
                                                          data.Q48BR_tmtResponseStatus ===
                                                          4
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Partial response (PR)
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q48BR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={5}
                                                      checked={
                                                        data.Q48BR_tmtResponseStatus ===
                                                        5
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Minimal response (MR)
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q48BR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={6}
                                                      checked={
                                                        data.Q48BR_tmtResponseStatus ===
                                                        6
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Stable disease (SD)
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q48BR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={7}
                                                      checked={
                                                        data.Q48BR_tmtResponseStatus ===
                                                        7
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Progressive disease (PD)
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q48BR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={8}
                                                      checked={
                                                        data.Q48BR_tmtResponseStatus ===
                                                        8
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q48BR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={9}
                                                      checked={
                                                        data.Q48BR_tmtResponseStatus ===
                                                        9
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Not assessed
                                                    </span>
                                                  </label>
                                                </div>

                                                <ErrorField
                                                  show={
                                                    data.Q48BR_tmtResponseStatusEmpty
                                                  }
                                                  message={
                                                    TreatmentResponseProgression_Msgs.RadioEmtypError
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />
                                              </td>

                                              {!(
                                                data.Q48BR_tmtResponseStatus ===
                                                  8 ||
                                                data.Q48BR_tmtResponseStatus ===
                                                  9
                                              ) ? (
                                                <>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q48BR_dateOfResponse_assessRd" +
                                                              idx
                                                            }
                                                            value={1}
                                                            checked={
                                                              data.Q48BR_dateOfResponse_assessRd ===
                                                              1
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Best response
                                                            assessed on:
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "41px",
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        <DatePickerComponent
                                                          ctrlId={
                                                            "Q48BR_dateOfResponse_assess_dt-" +
                                                            idx
                                                          }
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                          date={
                                                            data.Q48BR_dateOfResponse_assess_dt
                                                          }
                                                        />
                                                      </span>
                                                      {/* </div> */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q48BR_dateOfResponse_assessRd" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.Q48BR_dateOfResponse_assessRd ===
                                                              99
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Best response
                                                            occurred but date of
                                                            assessment unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.Q48PDDateMismatch
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q48WarningInsufficientResponse
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q48BR_dateOfResponse_assessEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.RadioEmtypError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q48FRBR_DateMismatch
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q48DateMismatch
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q48BR_dateOfResponse_assess_dtEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q48DateEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Invalid_Q48BR_dateOfResponse_assess_dt
                                                        }
                                                        message={
                                                          CommonError_Msgs.InvalidDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q48BR_PD_DateMismatch
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q48PDDateMismatch
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q48BRDateValidation
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q48NDMMDateOutOfBoundError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div>
                                                        {assessmentMethods &&
                                                          assessmentMethods.length >
                                                            0 &&
                                                          assessmentMethods.map(
                                                            (item, index) => (
                                                              <div
                                                                key={index}
                                                                className="option-without-input"
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "flex-start",
                                                                }}
                                                              >
                                                                <label className="long-text-option">
                                                                  <input
                                                                    type="radio"
                                                                    style={{
                                                                      marginTop:
                                                                        "6px",
                                                                    }}
                                                                    id={idx}
                                                                    name={
                                                                      "Q48BR_assessmentMethodRd" +
                                                                      idx
                                                                    }
                                                                    value={
                                                                      item.assessmentmethodid
                                                                    }
                                                                    checked={
                                                                      data.Q48BR_assessmentMethodRd ===
                                                                      item.assessmentmethodid
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      HandleRepeaterFieldChange(
                                                                        e,
                                                                        data.cohorttreatmentid,
                                                                      )
                                                                    }
                                                                  />

                                                                  {item.assessmentmethodid ===
                                                                  1 ? (
                                                                    <span
                                                                      className="radio-text-padding modal-popup"
                                                                      data-tooltip-id="encounterTip"
                                                                      onClick={() =>
                                                                        setShowHideHyperlinkModalIMWG(
                                                                          true,
                                                                        )
                                                                      }
                                                                    >
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </span>
                                                                  ) : (
                                                                    <span
                                                                      className="radio-text-padding"
                                                                      style={{
                                                                        paddingLeft:
                                                                          "10px",
                                                                      }}
                                                                    >
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </span>
                                                                  )}
                                                                </label>
                                                              </div>
                                                            ),
                                                          )}
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.Q48BR_assessmentMethodEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.RadioEmtypError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                </>
                                              ) : (
                                                <td
                                                  colSpan={2}
                                                  style={{
                                                    border: "1px solid black",
                                                    textAlign: "center",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                    className="not-applicable"
                                                  >
                                                    Not applicable
                                                  </span>
                                                </td>
                                              )}
                                            </tr>
                                          </tbody>
                                        </table>
                                        <ErrorField
                                          show={data.Q48q28WarningMsg}
                                          message={
                                            TreatmentResponseProgression_Msgs.Q48WarningInsufficientResponse
                                          }
                                        />
                                      </div>
                                    </div>

                                    <br />
                                  </>
                                )}

                              {showQ49_50 &&
                                data.cohorttreatmentid <
                                  RRMMCohortTreatment.TECVAYLI && (
                                  <>
                                    <div>
                                      <b>
                                        Response Assessments in 3<sup>rd</sup>{" "}
                                        Line of Treatment{" "}
                                      </b>
                                    </div>

                                    {/* 49-50 */}

                                    <div className="question-bot-sapce">
                                      <div className=" question-weight">
                                        <span> Q49. </span>
                                        Provide information for{" "}
                                        <span
                                          className="modal-popup"
                                          data-tooltip-id="encounterTip"
                                          onClick={() =>
                                            setShowHideHyperlinkModalIMWG(true)
                                          }
                                        >
                                          disease progression
                                        </span>{" "}
                                        assessed during the patient’s 3
                                        <sup>rd</sup>{" "}
                                        <span
                                          data-tooltip-id="encounterTip"
                                          className="modal-popup"
                                          onClick={() =>
                                            setShowHideHyperlinkModal(true)
                                          }
                                        >
                                          line of therapy
                                        </span>
                                        .
                                      </div>

                                      <div className="sub-question">
                                        <table
                                          style={{
                                            border: "1px solid black",
                                            borderCollapse: "collapse",
                                            width: "100%",
                                          }}
                                        >
                                          <thead>
                                            <tr>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                  // width:"4%"
                                                }}
                                              >
                                                Assessment
                                              </th>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                  //   width: "29%"
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Date of progression assessment
                                                </span>
                                              </th>

                                              {data.Q49ConditionMet && (
                                                <>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      // width:"36%"
                                                    }}
                                                  >
                                                    Reason for progression
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      //  width:"28%"
                                                    }}
                                                  >
                                                    Method of assessment
                                                  </th>
                                                </>
                                              )}
                                            </tr>
                                          </thead>

                                          <tbody>
                                            <tr>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="quest-text-pad">
                                                  Disease progression
                                                </span>
                                              </td>

                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q49dateOfProgressionRd" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.Q49dateOfProgressionRd ===
                                                          1
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Disease progression did
                                                        not occur
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q49dateOfProgressionRd" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.Q49dateOfProgressionRd ===
                                                          2
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Disease progression
                                                        occurred on:
                                                      </span>
                                                    </label>
                                                  </div>

                                                  {/* <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                            >
                                                */}

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "41px",
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    {/* <DateControl
                                                    ctrlId={
                                                      "Q49dateOfProgression_dt-" +
                                                      idx
                                                    }
                                                    HandleDateChange={
                                                      HandleRepeaterDateChange
                                                    }
                                                    date={
                                                      data.Q49dateOfProgression_dt
                                                    }
                                                  /> */}
                                                    <DatePickerComponent
                                                      ctrlId={
                                                        "Q49dateOfProgression_dt-" +
                                                        idx
                                                      }
                                                      // selectedDate={selectedDate}
                                                      //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                      HandleDateChange={
                                                        HandleRepeaterDateChange
                                                      }
                                                      // optionId={1}
                                                      minDate={dayjs(
                                                        "01-01-1920",
                                                      )}
                                                      maxDate={dayjs()}
                                                      locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                      date={
                                                        data.Q49dateOfProgression_dt
                                                      }
                                                    />
                                                  </span>
                                                  {/* </div> */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q49dateOfProgressionRd" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.Q49dateOfProgressionRd ===
                                                          99
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Disease progression
                                                        occurred but date of
                                                        assessment unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.Q49dateOfProgressionEmpty
                                                    }
                                                    message={
                                                      TreatmentResponseProgression_Msgs.RadioEmtypError
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.Q49dateOfProgression_dtEmpty
                                                    }
                                                    message={
                                                      TreatmentResponseProgression_Msgs.Q49DateEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.Invalid_Q49dateOfProgression_dt
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.Q49DateValidation
                                                    }
                                                    message={
                                                      TreatmentResponseProgression_Msgs.Q49NDMMDateOutOfBoundError
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              </td>

                                              {data.Q49ConditionMet && (
                                                <>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div className="">
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              type="checkbox"
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              id={idx}
                                                              name={
                                                                "Q49serum" + idx
                                                              }
                                                              checked={
                                                                data.Q49serum
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Serum M protein
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                      <div className="">
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              type="checkbox"
                                                              id={idx}
                                                              name={
                                                                "Q49uninary" +
                                                                idx
                                                              }
                                                              checked={
                                                                data.Q49uninary
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Urinary M protein
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                      <div className="">
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              type="checkbox"
                                                              id={idx}
                                                              name={
                                                                "Q49freelight" +
                                                                idx
                                                              }
                                                              checked={
                                                                data.Q49freelight
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Free light chain
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                      <div className="">
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              type="checkbox"
                                                              id={idx}
                                                              name={
                                                                "Q49plasma" +
                                                                idx
                                                              }
                                                              checked={
                                                                data.Q49plasma
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Plasma cell
                                                              increase
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                      <div className="">
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              type="checkbox"
                                                              id={idx}
                                                              name={
                                                                "Q49bonelesion" +
                                                                idx
                                                              }
                                                              checked={
                                                                data.Q49bonelesion
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Increase in size
                                                              and/or new bone
                                                              lesion
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                      <div className="">
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              type="checkbox"
                                                              id={idx}
                                                              name={
                                                                "Q49plasmacytomas" +
                                                                idx
                                                              }
                                                              checked={
                                                                data.Q49plasmacytomas
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Increase in size
                                                              and/or new
                                                              plasmacytomas
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                      <div className="">
                                                        <div
                                                        //   style={{display:"flex", alignItems:"flex-start"}}
                                                        >
                                                          <label className="long-text-option">
                                                            <input
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                              type="checkbox"
                                                              id={idx}
                                                              name={
                                                                "Q49ReasonOfProgression_oth" +
                                                                idx
                                                              }
                                                              checked={
                                                                data.Q49ReasonOfProgression_oth
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                            />
                                                            <span className="radio-text-padding">
                                                              Other, please
                                                              specify:
                                                            </span>
                                                          </label>

                                                          <div
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            <textarea
                                                              name={
                                                                "Q49ReasonOfProgression_txt" +
                                                                idx
                                                              }
                                                              className="input-dash"
                                                              type="text"
                                                              value={
                                                                data.Q49ReasonOfProgression_txt
                                                              }
                                                              onChange={(e) =>
                                                                HandleRepeaterFieldChange(
                                                                  e,
                                                                  data.cohorttreatmentid,
                                                                )
                                                              }
                                                              maxLength={300}
                                                              id={idx}
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q49ReasonOfProgression" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.Q49ReasonOfProgression ===
                                                              99
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.Q49ReasonOfProgressionEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q49Reason
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q49ReasonOfProgressionTxtEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.ProgressionReasonTextEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div>
                                                        {assessmentMethods &&
                                                          assessmentMethods.length >
                                                            0 &&
                                                          assessmentMethods.map(
                                                            (item, index) => (
                                                              <div
                                                                key={index}
                                                                className="option-without-input"
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "flex-start",
                                                                }}
                                                              >
                                                                <label className="long-text-option">
                                                                  <input
                                                                    type="radio"
                                                                    style={{
                                                                      marginTop:
                                                                        "6px",
                                                                    }}
                                                                    id={idx}
                                                                    name={
                                                                      "Q49assessmentMethodRd" +
                                                                      idx
                                                                    }
                                                                    value={
                                                                      item.assessmentmethodid
                                                                    }
                                                                    checked={
                                                                      data.Q49assessmentMethodRd ===
                                                                      item.assessmentmethodid
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      HandleRepeaterFieldChange(
                                                                        e,
                                                                        data.cohorttreatmentid,
                                                                      )
                                                                    }
                                                                  />

                                                                  {item.assessmentmethodid ===
                                                                  1 ? (
                                                                    <span
                                                                      className="radio-text-padding modal-popup"
                                                                      data-tooltip-id="encounterTip"
                                                                      onClick={() =>
                                                                        setShowHideHyperlinkModalIMWG(
                                                                          true,
                                                                        )
                                                                      }
                                                                    >
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </span>
                                                                  ) : (
                                                                    <span
                                                                      className="radio-text-padding"
                                                                      style={{
                                                                        paddingLeft:
                                                                          "10px",
                                                                      }}
                                                                    >
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </span>
                                                                  )}
                                                                </label>
                                                              </div>
                                                            ),
                                                          )}
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.Q49assessmentMethodEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.RadioEmtypError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                </>
                                              )}
                                            </tr>
                                          </tbody>
                                        </table>
                                        <ErrorField
                                          show={data.Q49q30WarningMsg}
                                          message={
                                            TreatmentResponseProgression_Msgs.Q49WarningDiseaseProgression
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div className="question-bot-sapce">
                                      <div className=" question-weight">
                                        <span>Q50. </span>
                                        Provide information for{" "}
                                        <span
                                          className="modal-popup"
                                          data-tooltip-id="encounterTip"
                                          onClick={() =>
                                            setShowHideHyperlinkModalIMWG(true)
                                          }
                                        >
                                          assessments of treatment response
                                        </span>{" "}
                                        conducted during the patient’s 3
                                        <sup>rd </sup>{" "}
                                        <span
                                          data-tooltip-id="encounterTip"
                                          className="modal-popup"
                                          onClick={() =>
                                            setShowHideHyperlinkModal(true)
                                          }
                                        >
                                          line of therapy
                                        </span>
                                        .
                                      </div>

                                      <div className="sub-question">
                                        <table
                                          style={{
                                            border: "1px solid black",
                                            borderCollapse: "collapse",
                                            width: "100%",
                                          }}
                                        >
                                          <thead>
                                            <tr>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                  // width:"4%"
                                                }}
                                              >
                                                Assessment
                                              </th>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                  //   width: "29%"
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Treatment response status
                                                </span>
                                              </th>

                                              {!(
                                                (data.Q50FR_tmtResponseStatus ===
                                                  5 ||
                                                  data.Q50FR_tmtResponseStatus ===
                                                    8 ||
                                                  data.Q50FR_tmtResponseStatus ===
                                                    9) &&
                                                (data.Q50BR_tmtResponseStatus ===
                                                  8 ||
                                                  data.Q50BR_tmtResponseStatus ===
                                                    9)
                                              ) && (
                                                <>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      // width:"36%"
                                                    }}
                                                  >
                                                    Date of response assessment
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      //  width:"28%"
                                                    }}
                                                  >
                                                    Method of assessment
                                                  </th>
                                                </>
                                              )}
                                            </tr>
                                          </thead>

                                          <tbody>
                                            <tr>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="quest-text-pad">
                                                  First positive response
                                                </span>
                                              </td>

                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q50FR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.Q50FR_tmtResponseStatus ===
                                                          1
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Stringent complete
                                                        response (sCR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q50FR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.Q50FR_tmtResponseStatus ===
                                                          2
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Complete response (CR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q50FR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          data.Q50FR_tmtResponseStatus ===
                                                          3
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Very good partial
                                                        response (VGPR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  {/* <div
                                                            className="option-without-input"
                                                            style={{ display: "flex" }}
                                                            >
                                                                */}

                                                  {/* </div> */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q50FR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={4}
                                                        checked={
                                                          data.Q50FR_tmtResponseStatus ===
                                                          4
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Partial response (PR)
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q50FR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={5}
                                                      checked={
                                                        data.Q50FR_tmtResponseStatus ===
                                                        5
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      No positive response
                                                      achieved
                                                    </span>
                                                  </label>
                                                </div>

                                                {/* <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  style={{ marginTop: "6px" }}
                                                  id={idx}
                                                  name={
                                                    "Q50FR_tmtResponseStatus" +
                                                    idx
                                                  }
                                                  value={6}
                                                  checked={
                                                    data.Q50FR_tmtResponseStatus ===
                                                    6
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Stable disease (SD)
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  style={{ marginTop: "6px" }}
                                                  id={idx}
                                                  name={
                                                    "Q50FR_tmtResponseStatus" +
                                                    idx
                                                  }
                                                  value={7}
                                                  checked={
                                                    data.Q50FR_tmtResponseStatus ===
                                                    7
                                                  }
                                                  onChange={
                                                    HandleRepeaterFieldChange
                                                  }
                                                />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Progressive disease (PD)
                                                  </span>
                                                </label>
                                              </div> */}

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q50FR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={8}
                                                      checked={
                                                        data.Q50FR_tmtResponseStatus ===
                                                        8
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q50FR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={9}
                                                      checked={
                                                        data.Q50FR_tmtResponseStatus ===
                                                        9
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Not assessed
                                                    </span>
                                                  </label>
                                                </div>
                                                <ErrorField
                                                  show={
                                                    data.Q50FR_tmtResponseStatusEmpty
                                                  }
                                                  message={
                                                    TreatmentResponseProgression_Msgs.RadioEmtypError
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />
                                              </td>

                                              {!(
                                                data.Q50FR_tmtResponseStatus ===
                                                  5 ||
                                                data.Q50FR_tmtResponseStatus ===
                                                  8 ||
                                                data.Q50FR_tmtResponseStatus ===
                                                  9
                                              ) ? (
                                                <>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q50FR_dateOfResponse_assessRd" +
                                                              idx
                                                            }
                                                            value={1}
                                                            checked={
                                                              data.Q50FR_dateOfResponse_assessRd ===
                                                              1
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            First positive
                                                            response assessed
                                                            on:
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* <div
                                                            className="option-without-input"
                                                            style={{ display: "flex" }}
                                                            >
                                                                */}

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "41px",
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        {/* <DateControl
                                                    ctrlId={
                                                      "Q50FR_dateOfResponse_assess_dt-" +
                                                      idx
                                                    }
                                                    HandleDateChange={
                                                      HandleRepeaterDateChange
                                                    }
                                                    date={
                                                      data.Q50FR_dateOfResponse_assess_dt
                                                    }
                                                  /> */}
                                                        <DatePickerComponent
                                                          ctrlId={
                                                            "Q50FR_dateOfResponse_assess_dt-" +
                                                            idx
                                                          }
                                                          // selectedDate={selectedDate}
                                                          //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          optionId={1}
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                          date={
                                                            data.Q50FR_dateOfResponse_assess_dt
                                                          }
                                                        />
                                                      </span>
                                                      {/* </div> */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q50FR_dateOfResponse_assessRd" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.Q50FR_dateOfResponse_assessRd ===
                                                              99
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            First positive
                                                            response occurred
                                                            but date of
                                                            assessment unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <ErrorField
                                                        show={
                                                          data.Q50FR_dateOfResponse_assessEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.RadioEmtypError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          data.Q50FRBR_DateMismatch
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q50DateMismatch
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q50FR_dateOfResponse_assess_dtEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q50DateEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Invalid_Q50FR_dateOfResponse_assess_dt
                                                        }
                                                        message={
                                                          CommonError_Msgs.InvalidDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q50FRDateValidation
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q50NDMMDateOutOfBoundError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div className="option-without-input">
                                                        {assessmentMethods &&
                                                          assessmentMethods.length >
                                                            0 &&
                                                          assessmentMethods.map(
                                                            (item, index) => (
                                                              <div
                                                                key={index}
                                                                className="option-without-input"
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "flex-start",
                                                                }}
                                                              >
                                                                <label className="long-text-option">
                                                                  <input
                                                                    type="radio"
                                                                    style={{
                                                                      marginTop:
                                                                        "6px",
                                                                    }}
                                                                    id={idx}
                                                                    name={
                                                                      "Q50FR_assessmentMethodRd" +
                                                                      idx
                                                                    }
                                                                    value={
                                                                      item.assessmentmethodid
                                                                    }
                                                                    checked={
                                                                      data.Q50FR_assessmentMethodRd ===
                                                                      item.assessmentmethodid
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      HandleRepeaterFieldChange(
                                                                        e,
                                                                        data.cohorttreatmentid,
                                                                      )
                                                                    }
                                                                  />

                                                                  {item.assessmentmethodid ===
                                                                  1 ? (
                                                                    <span
                                                                      className="radio-text-padding modal-popup"
                                                                      data-tooltip-id="encounterTip"
                                                                      onClick={() =>
                                                                        setShowHideHyperlinkModalIMWG(
                                                                          true,
                                                                        )
                                                                      }
                                                                    >
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </span>
                                                                  ) : (
                                                                    <span
                                                                      className="radio-text-padding"
                                                                      style={{
                                                                        paddingLeft:
                                                                          "10px",
                                                                      }}
                                                                    >
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </span>
                                                                  )}
                                                                </label>
                                                              </div>
                                                            ),
                                                          )}
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.Q50FR_assessmentMethodEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.RadioEmtypError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                </>
                                              ) : (
                                                <td
                                                  colSpan={2}
                                                  style={{
                                                    border: "1px solid black",
                                                    textAlign: "center",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                    className="not-applicable"
                                                  >
                                                    Not applicable
                                                  </span>
                                                </td>
                                              )}
                                            </tr>

                                            <tr>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="quest-text-pad">
                                                  Best response
                                                </span>
                                              </td>

                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q50BR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.Q50BR_tmtResponseStatus ===
                                                          1
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Stringent complete
                                                        response (sCR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q50BR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.Q50BR_tmtResponseStatus ===
                                                          2
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Complete response (CR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q50BR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={3}
                                                        checked={
                                                          data.Q50BR_tmtResponseStatus ===
                                                          3
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Very good partial
                                                        response (VGPR)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  {/* <div
                                                            className="option-without-input"
                                                            style={{ display: "flex" }}
                                                            >
                                                                */}

                                                  {/* </div> */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="long-text-option">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "Q50BR_tmtResponseStatus" +
                                                          idx
                                                        }
                                                        value={4}
                                                        checked={
                                                          data.Q50BR_tmtResponseStatus ===
                                                          4
                                                        }
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohorttreatmentid,
                                                          )
                                                        }
                                                      />

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Partial response (PR)
                                                      </span>
                                                    </label>
                                                  </div>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q50BR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={5}
                                                      checked={
                                                        data.Q50BR_tmtResponseStatus ===
                                                        5
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Minimal response (MR)
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q50BR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={6}
                                                      checked={
                                                        data.Q50BR_tmtResponseStatus ===
                                                        6
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Stable disease (SD)
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q50BR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={7}
                                                      checked={
                                                        data.Q50BR_tmtResponseStatus ===
                                                        7
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Progressive disease (PD)
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q50BR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={8}
                                                      checked={
                                                        data.Q50BR_tmtResponseStatus ===
                                                        8
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q50BR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={9}
                                                      checked={
                                                        data.Q50BR_tmtResponseStatus ===
                                                        9
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Not assessed
                                                    </span>
                                                  </label>
                                                </div>

                                                <ErrorField
                                                  show={
                                                    data.Q50BR_tmtResponseStatusEmpty
                                                  }
                                                  message={
                                                    TreatmentResponseProgression_Msgs.RadioEmtypError
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />
                                              </td>

                                              {!(
                                                data.Q50BR_tmtResponseStatus ===
                                                  8 ||
                                                data.Q50BR_tmtResponseStatus ===
                                                  9
                                              ) ? (
                                                <>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q50BR_dateOfResponse_assessRd" +
                                                              idx
                                                            }
                                                            value={1}
                                                            checked={
                                                              data.Q50BR_dateOfResponse_assessRd ===
                                                              1
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Best response
                                                            assessed on:
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* <div
                                                            className="option-without-input"
                                                            style={{ display: "flex" }}
                                                            >
                                                                */}

                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "41px",
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        {/* <DateControl
                                                    ctrlId={
                                                      "Q50BR_dateOfResponse_assess_dt-" +
                                                      idx
                                                    }
                                                    HandleDateChange={
                                                      HandleRepeaterDateChange
                                                    }
                                                    date={
                                                      data.Q50BR_dateOfResponse_assess_dt
                                                    }
                                                  /> */}
                                                        <DatePickerComponent
                                                          ctrlId={
                                                            "Q50BR_dateOfResponse_assess_dt-" +
                                                            idx
                                                          }
                                                          // selectedDate={selectedDate}
                                                          //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          // optionId={1}
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                          date={
                                                            data.Q50BR_dateOfResponse_assess_dt
                                                          }
                                                        />
                                                      </span>
                                                      {/* </div> */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q50BR_dateOfResponse_assessRd" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.Q50BR_dateOfResponse_assessRd ===
                                                              99
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />

                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Best response
                                                            occurred but date of
                                                            assessment unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <ErrorField
                                                        show={
                                                          data.Q50BR_dateOfResponse_assessEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.RadioEmtypError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q50FRBR_DateMismatch
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q50DateMismatch
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q50BR_PD_DateMismatch
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q50PDDateMismatch
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q50BR_dateOfResponse_assess_dtEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q50DateEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Invalid_Q50BR_dateOfResponse_assess_dt
                                                        }
                                                        message={
                                                          CommonError_Msgs.InvalidDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Q50BRDateValidation
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.Q50NDMMDateOutOfBoundError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div>
                                                        {assessmentMethods &&
                                                          assessmentMethods.length >
                                                            0 &&
                                                          assessmentMethods.map(
                                                            (item, index) => (
                                                              <div
                                                                key={index}
                                                                className="option-without-input"
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "flex-start",
                                                                }}
                                                              >
                                                                <label className="long-text-option">
                                                                  <input
                                                                    type="radio"
                                                                    style={{
                                                                      marginTop:
                                                                        "6px",
                                                                    }}
                                                                    id={idx}
                                                                    name={
                                                                      "Q50BR_assessmentMethodRd" +
                                                                      idx
                                                                    }
                                                                    value={
                                                                      item.assessmentmethodid
                                                                    }
                                                                    checked={
                                                                      data.Q50BR_assessmentMethodRd ===
                                                                      item.assessmentmethodid
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      HandleRepeaterFieldChange(
                                                                        e,
                                                                        data.cohorttreatmentid,
                                                                      )
                                                                    }
                                                                  />

                                                                  {item.assessmentmethodid ===
                                                                  1 ? (
                                                                    <span
                                                                      className="radio-text-padding modal-popup"
                                                                      data-tooltip-id="encounterTip"
                                                                      onClick={() =>
                                                                        setShowHideHyperlinkModalIMWG(
                                                                          true,
                                                                        )
                                                                      }
                                                                    >
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </span>
                                                                  ) : (
                                                                    <span
                                                                      className="radio-text-padding"
                                                                      style={{
                                                                        paddingLeft:
                                                                          "10px",
                                                                      }}
                                                                    >
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </span>
                                                                  )}
                                                                </label>
                                                              </div>
                                                            ),
                                                          )}
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.Q50BR_assessmentMethodEmpty
                                                        }
                                                        message={
                                                          TreatmentResponseProgression_Msgs.RadioEmtypError
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                </>
                                              ) : (
                                                <td
                                                  colSpan={2}
                                                  style={{
                                                    border: "1px solid black",
                                                    textAlign: "center",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                    className="not-applicable"
                                                  >
                                                    Not applicable
                                                  </span>
                                                </td>
                                              )}
                                            </tr>
                                          </tbody>
                                        </table>
                                        <ErrorField
                                          show={data.Q50q30WarningMsg}
                                          message={
                                            TreatmentResponseProgression_Msgs.Q50WarningInsufficientResponse
                                          }
                                        />
                                      </div>
                                    </div>
                                  </>
                                )}
                            </div>

                            {/* 51-52 */}
                            {data.showQ51_52 &&
                              data.cohorttreatmentid >=
                                RRMMCohortTreatment.TECVAYLI && (
                                <>
                                  <div>
                                    <b>
                                      Response Assessments in{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {data.lotNum ? (
                                          GetOrdinal(data.lotNum)
                                        ) : (
                                          <>[Bispecifics/CAR-T LOT + 1]</>
                                        )}
                                      </span>{" "}
                                      Line of Treatment{" "}
                                    </b>
                                  </div>
                                  <div className="question-bot-sapce">
                                    <div className=" question-weight">
                                      <span> Q51. </span>
                                      Provide information for{" "}
                                      <span
                                        className="modal-popup"
                                        data-tooltip-id="encounterTip"
                                        onClick={() =>
                                          setShowHideHyperlinkModalIMWG(true)
                                        }
                                      >
                                        disease progression
                                      </span>{" "}
                                      assessed during the patient’s{" "}
                                      <strong>
                                        <u>subsequent</u>
                                      </strong>
                                      {" ("}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                          fontWeight: "bolder",
                                        }}
                                      >
                                        {data.lotNum ? (
                                          GetOrdinal(data.lotNum)
                                        ) : (
                                          <>[Bispecifics/CAR-T LOT + 1]</>
                                        )}
                                      </span>
                                      {") "}
                                      <span
                                        data-tooltip-id="encounterTip"
                                        className="modal-popup"
                                        onClick={() =>
                                          setShowHideHyperlinkModal(true)
                                        }
                                      >
                                        line of therapy
                                      </span>
                                      .{" "}
                                    </div>

                                    <div className="sub-question">
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                // width:"4%"
                                              }}
                                            >
                                              Assessment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                //   width: "29%"
                                              }}
                                            >
                                              <span
                                                style={{ textAlign: "center" }}
                                              >
                                                Date of progression assessment
                                              </span>
                                            </th>

                                            {data.Q51ConditionMet && (
                                              <>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    // width:"36%"
                                                  }}
                                                >
                                                  Reason for progression
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    //  width:"28%"
                                                  }}
                                                >
                                                  Method of assessment
                                                </th>
                                              </>
                                            )}
                                          </tr>
                                        </thead>

                                        <tbody>
                                          <tr>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span className="quest-text-pad">
                                                Disease progression
                                              </span>
                                            </td>

                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q51dateOfProgressionRd" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.Q51dateOfProgressionRd ===
                                                        1
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Disease progression did
                                                      not occur
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q51dateOfProgressionRd" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        data.Q51dateOfProgressionRd ===
                                                        2
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Disease progression
                                                      occurred on:
                                                    </span>
                                                  </label>
                                                </div>

                                                {/* <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                            >
                                                */}

                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "41px",
                                                    marginLeft: "5px",
                                                  }}
                                                >
                                                  {/* <DateControl
                                                  ctrlId={
                                                    "Q51dateOfProgression_dt-" +
                                                    idx
                                                  }
                                                  HandleDateChange={
                                                    HandleRepeaterDateChange
                                                  }
                                                  date={
                                                    data.Q51dateOfProgression_dt
                                                  }
                                                /> */}

                                                  <DatePickerComponent
                                                    ctrlId={
                                                      "Q51dateOfProgression_dt-" +
                                                      idx
                                                    }
                                                    // selectedDate={selectedDate}
                                                    //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                    HandleDateChange={
                                                      HandleRepeaterDateChange
                                                    }
                                                    // optionId={1}
                                                    minDate={dayjs(
                                                      "01-01-1920",
                                                    )}
                                                    maxDate={dayjs()}
                                                    locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                    date={
                                                      data.Q51dateOfProgression_dt
                                                    }
                                                  />
                                                </span>
                                                {/* </div> */}
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q51dateOfProgressionRd" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.Q51dateOfProgressionRd ===
                                                        99
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Disease progression
                                                      occurred but date of
                                                      assessment unknown
                                                    </span>
                                                  </label>
                                                </div>

                                                <ErrorField
                                                  show={
                                                    data.Q51dateOfProgressionEmpty
                                                  }
                                                  message={
                                                    TreatmentResponseProgression_Msgs.RadioEmtypError
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />
                                                <ErrorField
                                                  show={
                                                    data.Q51dateOfProgression_dtEmpty
                                                  }
                                                  message={
                                                    TreatmentResponseProgression_Msgs.Q51DateEmpty
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />

                                                <ErrorField
                                                  show={
                                                    data.Invalid_Q51dateOfProgression_dt
                                                  }
                                                  message={
                                                    CommonError_Msgs.InvalidDate
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />

                                                <ErrorField
                                                  show={data.Q51DateValidation}
                                                  message={
                                                    TreatmentResponseProgression_Msgs.Q51DateOutOfBoundError
                                                  }
                                                  style={{ paddingLeft: "0px" }}
                                                />
                                              </div>
                                            </td>

                                            {data.Q51ConditionMet && (
                                              <>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="">
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            type="checkbox"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "Q51serum" + idx
                                                            }
                                                            checked={
                                                              data.Q51serum
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Serum M protein
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>

                                                    <div className="">
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "Q51uninary" + idx
                                                            }
                                                            checked={
                                                              data.Q51uninary
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Urinary M protein
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>

                                                    <div className="">
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "Q51freelight" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.Q51freelight
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Free light chain
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>

                                                    <div className="">
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "Q51plasma" + idx
                                                            }
                                                            checked={
                                                              data.Q51plasma
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Plasma cell increase
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>

                                                    <div className="">
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "Q51bonelesion" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.Q51bonelesion
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Increase in size
                                                            and/or new bone
                                                            lesion
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>

                                                    <div className="">
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "Q51plasmacytomas" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.Q51plasmacytomas
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Increase in size
                                                            and/or new
                                                            plasmacytomas
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>

                                                    <div className="">
                                                      <div
                                                      //   style={{display:"flex", alignItems:"flex-start"}}
                                                      >
                                                        <label className="long-text-option">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "Q51ReasonOfProgression_oth" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.Q51ReasonOfProgression_oth
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Other, please
                                                            specify:
                                                          </span>
                                                        </label>

                                                        <div
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          <textarea
                                                            name={
                                                              "Q51ReasonOfProgression_txt" +
                                                              idx
                                                            }
                                                            className="input-dash"
                                                            type="text"
                                                            value={
                                                              data.Q51ReasonOfProgression_txt
                                                            }
                                                            onChange={(e) =>
                                                              HandleRepeaterFieldChange(
                                                                e,
                                                                data.cohorttreatmentid,
                                                              )
                                                            }
                                                            maxLength={300}
                                                            id={idx}
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "Q51ReasonOfProgression" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            data.Q51ReasonOfProgression ===
                                                            99
                                                          }
                                                          onChange={(e) =>
                                                            HandleRepeaterFieldChange(
                                                              e,
                                                              data.cohorttreatmentid,
                                                            )
                                                          }
                                                        />

                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <ErrorField
                                                      show={
                                                        data.Q51ReasonOfProgressionEmpty
                                                      }
                                                      message={"Choose option"}
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.Q51ReasonOfProgressionTxtEmpty
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.ProgressionReasonTextEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      {assessmentMethods &&
                                                        assessmentMethods.length >
                                                          0 &&
                                                        assessmentMethods.map(
                                                          (item, index) => (
                                                            <div
                                                              key={index}
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="radio"
                                                                  style={{
                                                                    marginTop:
                                                                      "6px",
                                                                  }}
                                                                  id={idx}
                                                                  name={
                                                                    "Q51assessmentMethodRd" +
                                                                    idx
                                                                  }
                                                                  value={
                                                                    item.assessmentmethodid
                                                                  }
                                                                  checked={
                                                                    data.Q51assessmentMethodRd ===
                                                                    item.assessmentmethodid
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    HandleRepeaterFieldChange(
                                                                      e,
                                                                      data.cohorttreatmentid,
                                                                    )
                                                                  }
                                                                />

                                                                {item.assessmentmethodid ===
                                                                1 ? (
                                                                  <span
                                                                    className="radio-text-padding modal-popup"
                                                                    data-tooltip-id="encounterTip"
                                                                    onClick={() =>
                                                                      setShowHideHyperlinkModalIMWG(
                                                                        true,
                                                                      )
                                                                    }
                                                                  >
                                                                    {item.name}
                                                                  </span>
                                                                ) : (
                                                                  <span
                                                                    className="radio-text-padding"
                                                                    style={{
                                                                      paddingLeft:
                                                                        "10px",
                                                                    }}
                                                                  >
                                                                    {item.name}
                                                                  </span>
                                                                )}
                                                              </label>
                                                            </div>
                                                          ),
                                                        )}
                                                    </div>
                                                    <ErrorField
                                                      show={
                                                        data.Q51assessmentMethodEmpty
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.RadioEmtypError
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </>
                                            )}
                                          </tr>
                                        </tbody>
                                      </table>
                                      {data.Q51q33WarningMsgTec &&
                                        data.cohorttreatmentid ===
                                          RRMMCohortTreatment.TECVAYLI && (
                                          <ErrorField
                                            message={
                                              TreatmentResponseProgression_Msgs.Q51WarningDiseaseProgression
                                            }
                                          />
                                        )}
                                      {data.Q51q33WarningMsgTal &&
                                        data.cohorttreatmentid ===
                                          RRMMCohortTreatment.TALVEY && (
                                          <ErrorField
                                            message={
                                              TreatmentResponseProgression_Msgs.Q51WarningDiseaseProgression
                                            }
                                          />
                                        )}
                                      {data.Q51q33WarningMsgLin &&
                                        data.cohorttreatmentid ===
                                          RRMMCohortTreatment.Linvoseltamab && (
                                          <ErrorField
                                            message={
                                              TreatmentResponseProgression_Msgs.Q51WarningDiseaseProgression
                                            }
                                          />
                                        )}
                                      {data.Q51q33WarningMsgElr &&
                                        data.cohorttreatmentid ===
                                          RRMMCohortTreatment.ELREXFIO && (
                                          <ErrorField
                                            message={
                                              TreatmentResponseProgression_Msgs.Q51WarningDiseaseProgression
                                            }
                                          />
                                        )}
                                      {data.Q51q33WarningMsgAbecma &&
                                        data.cohorttreatmentid ===
                                          RRMMCohortTreatment.ABECMA && (
                                          <ErrorField
                                            message={
                                              TreatmentResponseProgression_Msgs.Q51WarningDiseaseProgression
                                            }
                                          />
                                        )}
                                      {data.Q51q33WarningMsgCarvykti &&
                                        data.cohorttreatmentid ===
                                          RRMMCohortTreatment.CARVYKTI && (
                                          <ErrorField
                                            message={
                                              TreatmentResponseProgression_Msgs.Q51WarningDiseaseProgression
                                            }
                                          />
                                        )}
                                    </div>
                                  </div>

                                  <div className="question-bot-sapce">
                                    <div className=" question-weight">
                                      <span>Q52. </span>
                                      Provide information for{" "}
                                      <span
                                        className="modal-popup"
                                        data-tooltip-id="encounterTip"
                                        onClick={() =>
                                          setShowHideHyperlinkModalIMWG(true)
                                        }
                                      >
                                        assessments of treatment response
                                      </span>{" "}
                                      conducted during the patient’s{" "}
                                      <strong>
                                        <u>subsequent</u>
                                      </strong>
                                      {" ("}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                          fontWeight: "bolder",
                                        }}
                                      >
                                        {data.lotNum ? (
                                          GetOrdinal(data.lotNum)
                                        ) : (
                                          <>[Bispecifics/CAR-T LOT + 1]</>
                                        )}
                                      </span>
                                      {") "}
                                      {""}
                                      <span
                                        data-tooltip-id="encounterTip"
                                        className="modal-popup"
                                        onClick={() =>
                                          setShowHideHyperlinkModal(true)
                                        }
                                      >
                                        line of therapy
                                      </span>
                                      .
                                    </div>

                                    <div className="sub-question">
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                // width:"4%"
                                              }}
                                            >
                                              Assessment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                //   width: "29%"
                                              }}
                                            >
                                              <span
                                                style={{ textAlign: "center" }}
                                              >
                                                Treatment response status
                                              </span>
                                            </th>
                                            {!(
                                              (data.Q52FR_tmtResponseStatus ===
                                                5 ||
                                                data.Q52FR_tmtResponseStatus ===
                                                  8 ||
                                                data.Q52FR_tmtResponseStatus ===
                                                  9) &&
                                              (data.Q52BR_tmtResponseStatus ===
                                                8 ||
                                                data.Q52BR_tmtResponseStatus ===
                                                  9)
                                            ) && (
                                              <>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    // width:"36%"
                                                  }}
                                                >
                                                  Date of response assessment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    //  width:"28%"
                                                  }}
                                                >
                                                  Method of assessment
                                                </th>
                                              </>
                                            )}
                                          </tr>
                                        </thead>

                                        <tbody>
                                          <tr>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span className="quest-text-pad">
                                                First positive response
                                              </span>
                                            </td>

                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q52FR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.Q52FR_tmtResponseStatus ===
                                                        1
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Stringent complete
                                                      response (sCR)
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q52FR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        data.Q52FR_tmtResponseStatus ===
                                                        2
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Complete response (CR)
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q52FR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={3}
                                                      checked={
                                                        data.Q52FR_tmtResponseStatus ===
                                                        3
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Very good partial response
                                                      (VGPR)
                                                    </span>
                                                  </label>
                                                </div>

                                                {/* <div
                                                            className="option-without-input"
                                                            style={{ display: "flex" }}
                                                            >
                                                                */}

                                                {/* </div> */}
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q52FR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={4}
                                                      checked={
                                                        data.Q52FR_tmtResponseStatus ===
                                                        4
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Partial response (PR)
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={
                                                      "Q52FR_tmtResponseStatus" +
                                                      idx
                                                    }
                                                    value={5}
                                                    checked={
                                                      data.Q52FR_tmtResponseStatus ===
                                                      5
                                                    }
                                                    onChange={(e) =>
                                                      HandleRepeaterFieldChange(
                                                        e,
                                                        data.cohorttreatmentid,
                                                      )
                                                    }
                                                  />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    No positive response
                                                    achieved
                                                  </span>
                                                </label>
                                              </div>

                                              {/* <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                              }}
                                            >
                                              <label className="long-text-option">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={
                                                  "Q52FR_tmtResponseStatus" +
                                                  idx
                                                }
                                                value={6}
                                                checked={
                                                  data.Q52FR_tmtResponseStatus ===
                                                  6
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />

                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                  }}
                                                >
                                                  Stable disease (SD)
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                              }}
                                            >
                                              <label className="long-text-option">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={
                                                  "Q52FR_tmtResponseStatus" +
                                                  idx
                                                }
                                                value={7}
                                                checked={
                                                  data.Q52FR_tmtResponseStatus ===
                                                  7
                                                }
                                                onChange={
                                                  HandleRepeaterFieldChange
                                                }
                                              />

                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                  }}
                                                >
                                                  Progressive disease (PD)
                                                </span>
                                              </label>
                                            </div> */}

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={
                                                      "Q52FR_tmtResponseStatus" +
                                                      idx
                                                    }
                                                    value={8}
                                                    checked={
                                                      data.Q52FR_tmtResponseStatus ===
                                                      8
                                                    }
                                                    onChange={(e) =>
                                                      HandleRepeaterFieldChange(
                                                        e,
                                                        data.cohorttreatmentid,
                                                      )
                                                    }
                                                  />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={
                                                      "Q52FR_tmtResponseStatus" +
                                                      idx
                                                    }
                                                    value={9}
                                                    checked={
                                                      data.Q52FR_tmtResponseStatus ===
                                                      9
                                                    }
                                                    onChange={(e) =>
                                                      HandleRepeaterFieldChange(
                                                        e,
                                                        data.cohorttreatmentid,
                                                      )
                                                    }
                                                  />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Not assessed
                                                  </span>
                                                </label>
                                              </div>
                                              <ErrorField
                                                show={
                                                  data.Q52FR_tmtResponseStatusEmpty
                                                }
                                                message={
                                                  TreatmentResponseProgression_Msgs.Q52Treatment
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                              {/* <ErrorField
                                                show={
                                                data.dose_administration_techHard_dt
                                                }
                                                message={
                                                TTCharacteristics_MSGS.administrationEmptyDate
                                                }
                                                style={{ paddingLeft: "0px" }}
                                            /> */}
                                            </td>

                                            {!(
                                              data.Q52FR_tmtResponseStatus ===
                                                5 ||
                                              data.Q52FR_tmtResponseStatus ===
                                                8 ||
                                              data.Q52FR_tmtResponseStatus === 9
                                            ) ? (
                                              <>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "Q52FR_dateOfResponse_assessRd" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.Q52FR_dateOfResponse_assessRd ===
                                                            1
                                                          }
                                                          onChange={(e) =>
                                                            HandleRepeaterFieldChange(
                                                              e,
                                                              data.cohorttreatmentid,
                                                            )
                                                          }
                                                        />

                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          First positive
                                                          response assessed on:
                                                        </span>
                                                      </label>
                                                    </div>

                                                    {/* <div
                                                            className="option-without-input"
                                                            style={{ display: "flex" }}
                                                            >
                                                                */}

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "41px",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      {/* <DateControl
                                                  ctrlId={
                                                    "Q52FR_dateOfResponse_assess_dt-" +
                                                    idx
                                                  }
                                                  HandleDateChange={
                                                    HandleRepeaterDateChange
                                                  }
                                                  date={
                                                    data.Q52FR_dateOfResponse_assess_dt
                                                  }
                                                /> */}

                                                      <DatePickerComponent
                                                        ctrlId={
                                                          "Q52FR_dateOfResponse_assess_dt-" +
                                                          idx
                                                        }
                                                        // selectedDate={selectedDate}
                                                        //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        // optionId={1}
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                        date={
                                                          data.Q52FR_dateOfResponse_assess_dt
                                                        }
                                                      />
                                                    </span>
                                                    {/* </div> */}
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "Q52FR_dateOfResponse_assessRd" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            data.Q52FR_dateOfResponse_assessRd ===
                                                            99
                                                          }
                                                          onChange={(e) =>
                                                            HandleRepeaterFieldChange(
                                                              e,
                                                              data.cohorttreatmentid,
                                                            )
                                                          }
                                                        />

                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          First positive
                                                          response occurred but
                                                          date of assessment
                                                          unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.Q52FR_dateOfResponse_assessEmpty
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.RadioEmtypError
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.Q52FRBR_DateMismatch
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.Q52DateMismatch
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.Q52FR_dateOfResponse_assess_dtEmpty
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.Q52DateEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.Invalid_Q52FR_dateOfResponse_assess_dt
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.Q52FRDateValidation
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.Q52DateOutOfBoundError
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      {assessmentMethods &&
                                                        assessmentMethods.length >
                                                          0 &&
                                                        assessmentMethods.map(
                                                          (item, index) => (
                                                            <div
                                                              key={index}
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="radio"
                                                                  style={{
                                                                    marginTop:
                                                                      "6px",
                                                                  }}
                                                                  id={idx}
                                                                  name={
                                                                    "Q52FR_assessmentMethodRd" +
                                                                    idx
                                                                  }
                                                                  value={
                                                                    item.assessmentmethodid
                                                                  }
                                                                  checked={
                                                                    data.Q52FR_assessmentMethodRd ===
                                                                    item.assessmentmethodid
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    HandleRepeaterFieldChange(
                                                                      e,
                                                                      data.cohorttreatmentid,
                                                                    )
                                                                  }
                                                                />

                                                                {item.assessmentmethodid ===
                                                                1 ? (
                                                                  <span
                                                                    className="radio-text-padding modal-popup"
                                                                    data-tooltip-id="encounterTip"
                                                                    onClick={() =>
                                                                      setShowHideHyperlinkModalIMWG(
                                                                        true,
                                                                      )
                                                                    }
                                                                  >
                                                                    {item.name}
                                                                  </span>
                                                                ) : (
                                                                  <span
                                                                    className="radio-text-padding"
                                                                    style={{
                                                                      paddingLeft:
                                                                        "10px",
                                                                    }}
                                                                  >
                                                                    {item.name}
                                                                  </span>
                                                                )}
                                                              </label>
                                                            </div>
                                                          ),
                                                        )}
                                                    </div>
                                                    <ErrorField
                                                      show={
                                                        data.Q52FR_assessmentMethodEmpty
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.RadioEmtypError
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </>
                                            ) : (
                                              <td
                                                colSpan={2}
                                                style={{
                                                  border: "1px solid black",
                                                  textAlign: "center",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  Not applicable
                                                </span>
                                              </td>
                                            )}
                                          </tr>

                                          <tr>
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span className="quest-text-pad">
                                                Best response
                                              </span>
                                            </td>

                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div>
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q52BR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.Q52BR_tmtResponseStatus ===
                                                        1
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Stringent complete
                                                      response (sCR)
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q52BR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        data.Q52BR_tmtResponseStatus ===
                                                        2
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Complete response (CR)
                                                    </span>
                                                  </label>
                                                </div>

                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q52BR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={3}
                                                      checked={
                                                        data.Q52BR_tmtResponseStatus ===
                                                        3
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Very good partial response
                                                      (VGPR)
                                                    </span>
                                                  </label>
                                                </div>

                                                {/* <div
                                                            className="option-without-input"
                                                            style={{ display: "flex" }}
                                                            >
                                                                */}

                                                {/* </div> */}
                                                <div
                                                  className="option-without-input"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      id={idx}
                                                      name={
                                                        "Q52BR_tmtResponseStatus" +
                                                        idx
                                                      }
                                                      value={4}
                                                      checked={
                                                        data.Q52BR_tmtResponseStatus ===
                                                        4
                                                      }
                                                      onChange={(e) =>
                                                        HandleRepeaterFieldChange(
                                                          e,
                                                          data.cohorttreatmentid,
                                                        )
                                                      }
                                                    />

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Partial response (PR)
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={
                                                      "Q52BR_tmtResponseStatus" +
                                                      idx
                                                    }
                                                    value={5}
                                                    checked={
                                                      data.Q52BR_tmtResponseStatus ===
                                                      5
                                                    }
                                                    onChange={(e) =>
                                                      HandleRepeaterFieldChange(
                                                        e,
                                                        data.cohorttreatmentid,
                                                      )
                                                    }
                                                  />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Minimal response (MR)
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={
                                                      "Q52BR_tmtResponseStatus" +
                                                      idx
                                                    }
                                                    value={6}
                                                    checked={
                                                      data.Q52BR_tmtResponseStatus ===
                                                      6
                                                    }
                                                    onChange={(e) =>
                                                      HandleRepeaterFieldChange(
                                                        e,
                                                        data.cohorttreatmentid,
                                                      )
                                                    }
                                                  />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Stable disease (SD)
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={
                                                      "Q52BR_tmtResponseStatus" +
                                                      idx
                                                    }
                                                    value={7}
                                                    checked={
                                                      data.Q52BR_tmtResponseStatus ===
                                                      7
                                                    }
                                                    onChange={(e) =>
                                                      HandleRepeaterFieldChange(
                                                        e,
                                                        data.cohorttreatmentid,
                                                      )
                                                    }
                                                  />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Progressive disease (PD)
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={
                                                      "Q52BR_tmtResponseStatus" +
                                                      idx
                                                    }
                                                    value={8}
                                                    checked={
                                                      data.Q52BR_tmtResponseStatus ===
                                                      8
                                                    }
                                                    onChange={(e) =>
                                                      HandleRepeaterFieldChange(
                                                        e,
                                                        data.cohorttreatmentid,
                                                      )
                                                    }
                                                  />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Unknown
                                                  </span>
                                                </label>
                                              </div>
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={
                                                      "Q52BR_tmtResponseStatus" +
                                                      idx
                                                    }
                                                    value={9}
                                                    checked={
                                                      data.Q52BR_tmtResponseStatus ===
                                                      9
                                                    }
                                                    onChange={(e) =>
                                                      HandleRepeaterFieldChange(
                                                        e,
                                                        data.cohorttreatmentid,
                                                      )
                                                    }
                                                  />

                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Not assessed
                                                  </span>
                                                </label>
                                              </div>
                                              <ErrorField
                                                show={
                                                  data.Q52BR_tmtResponseStatusEmpty
                                                }
                                                message={
                                                  TreatmentResponseProgression_Msgs.Q52Treatment
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                              {/* <ErrorField
                                                show={
                                                data.dose_administration_techHard_dt
                                                }
                                                message={
                                                TTCharacteristics_MSGS.administrationEmptyDate
                                                }
                                                style={{ paddingLeft: "0px" }}
                                            /> */}
                                            </td>

                                            {!(
                                              data.Q52BR_tmtResponseStatus ===
                                                8 ||
                                              data.Q52BR_tmtResponseStatus === 9
                                            ) ? (
                                              <>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "Q52BR_dateOfResponse_assessRd" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.Q52BR_dateOfResponse_assessRd ===
                                                            1
                                                          }
                                                          onChange={(e) =>
                                                            HandleRepeaterFieldChange(
                                                              e,
                                                              data.cohorttreatmentid,
                                                            )
                                                          }
                                                        />

                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Best response assessed
                                                          on:
                                                        </span>
                                                      </label>
                                                    </div>

                                                    {/* <div
                                                            className="option-without-input"
                                                            style={{ display: "flex" }}
                                                            >
                                                                */}

                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "41px",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      {/* <DateControl
                                                  ctrlId={
                                                    "Q52BR_dateOfResponse_assess_dt-" +
                                                    idx
                                                  }
                                                  HandleDateChange={
                                                    HandleRepeaterDateChange
                                                  }
                                                  date={
                                                    data.Q52BR_dateOfResponse_assess_dt
                                                  }
                                                /> */}

                                                      <DatePickerComponent
                                                        ctrlId={
                                                          "Q52BR_dateOfResponse_assess_dt-" +
                                                          idx
                                                        }
                                                        // selectedDate={selectedDate}
                                                        //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        // optionId={1}
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                        date={
                                                          data.Q52BR_dateOfResponse_assess_dt
                                                        }
                                                      />
                                                    </span>
                                                    {/* </div> */}
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="long-text-option">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "Q52BR_dateOfResponse_assessRd" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            data.Q52BR_dateOfResponse_assessRd ===
                                                            99
                                                          }
                                                          onChange={(e) =>
                                                            HandleRepeaterFieldChange(
                                                              e,
                                                              data.cohorttreatmentid,
                                                            )
                                                          }
                                                        />

                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Best response occurred
                                                          but date of assessment
                                                          unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.Q52BR_dateOfResponse_assessEmpty
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.RadioEmtypError
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.Q52FRBR_DateMismatch
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.Q52DateMismatch
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.Q52BR_PD_DateMismatch
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.Q52PDDateMismatch
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.Q52BR_dateOfResponse_assess_dtEmpty
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.Q52DateEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.Invalid_Q52BR_dateOfResponse_assess_dt
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.Q52BRDateValidation
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.Q52DateOutOfBoundError
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      {assessmentMethods &&
                                                        assessmentMethods.length >
                                                          0 &&
                                                        assessmentMethods.map(
                                                          (item, index) => (
                                                            <div
                                                              key={index}
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="radio"
                                                                  style={{
                                                                    marginTop:
                                                                      "6px",
                                                                  }}
                                                                  id={idx}
                                                                  name={
                                                                    "Q52BR_assessmentMethodRd" +
                                                                    idx
                                                                  }
                                                                  value={
                                                                    item.assessmentmethodid
                                                                  }
                                                                  checked={
                                                                    data.Q52BR_assessmentMethodRd ===
                                                                    item.assessmentmethodid
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    HandleRepeaterFieldChange(
                                                                      e,
                                                                      data.cohorttreatmentid,
                                                                    )
                                                                  }
                                                                />

                                                                {item.assessmentmethodid ===
                                                                1 ? (
                                                                  <span
                                                                    className="radio-text-padding modal-popup"
                                                                    data-tooltip-id="encounterTip"
                                                                    onClick={() =>
                                                                      setShowHideHyperlinkModalIMWG(
                                                                        true,
                                                                      )
                                                                    }
                                                                  >
                                                                    {item.name}
                                                                  </span>
                                                                ) : (
                                                                  <span
                                                                    className="radio-text-padding"
                                                                    style={{
                                                                      paddingLeft:
                                                                        "10px",
                                                                    }}
                                                                  >
                                                                    {item.name}
                                                                  </span>
                                                                )}
                                                              </label>
                                                            </div>
                                                          ),
                                                        )}
                                                    </div>
                                                    <ErrorField
                                                      show={
                                                        data.Q52BR_assessmentMethodEmpty
                                                      }
                                                      message={
                                                        TreatmentResponseProgression_Msgs.RadioEmtypError
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </>
                                            ) : (
                                              <td
                                                colSpan={2}
                                                style={{
                                                  border: "1px solid black",
                                                  textAlign: "center",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  Not applicable
                                                </span>
                                              </td>
                                            )}
                                          </tr>
                                        </tbody>
                                      </table>
                                      <ErrorField
                                        show={data.Q52q33WarningMsg}
                                        message={
                                          TreatmentResponseProgression_Msgs.Q50WarningInsufficientResponse
                                        }
                                      />
                                    </div>
                                  </div>
                                </>
                              )}
                          </>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {showHideHyperlinkModalIMWG && (
        <InfoPopUp
          description={hyperlinkTextStandardIMWGReportingCriteria}
          OkClick={() => setShowHideHyperlinkModalIMWG(false)}
        />
      )}

      {showHideHyperlinkModal && (
        <InfoPopUp
          description={hyperlinkTextLineOfTherapy}
          OkClick={() => setShowHideHyperlinkModal(false)}
        />
      )}
    </>
  );
};

export default TreatmentResponseProgression;
